webpackJsonp([1],Array(21).concat([
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(657),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hotel__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Hotel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Addhotel__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Addhotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Addhotel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Callback__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Callback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Callback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Logout__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Ombrelli__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Ombrelli___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Ombrelli__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Editgrid__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Editgrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Editgrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pool__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Pool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Canvas__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ForgotPassword__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pagamenti__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pagamenti___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Pagamenti__);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Hello___default.a
  }, {
    path: '/Hotel',
    name: 'Hotel',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Hotel___default.a
  }, {
    path: '/Ombrelli/:hotel',
    name: 'Ombrelli',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Ombrelli___default.a
  }, {
    path: '/Editgrid/:hotel',
    name: 'Editgrid',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Editgrid___default.a
  }, {
    path: '/Canvas/:hotel',
    name: 'Canvas',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Canvas___default.a
  }, {
    path: '/Pool/:hotel',
    name: 'Pool',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Pool___default.a
  }, {
    path: '/pagamenti/:hotel',
    name: 'Pagamenti',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Pagamenti___default.a
  }, {
    path: '/password-forgot/:token',
    name: 'Password-forgot',
    component: __WEBPACK_IMPORTED_MODULE_12__components_ForgotPassword___default.a
  }, {
    path: '/Addhotel',
    name: 'Addhotel',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Addhotel___default.a
  }, {
    path: '/Callback',
    name: 'Callback',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Callback___default.a
  }, {
    path: '/Logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Logout___default.a
  }]
}));

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAkCAYAAAA5DDySAAAAAXNSR0IArs4c6QAABUhJREFUaAXdmW2IVUUYx72ri1pma1HZIgiJQWmhm31IyiVX3S/iC2FWiPuhREtSi0AlqawP4vYlUlBEDQURWnQVNcRQaBNMfMnNfKGkDfENS3xJ08309PufO3OZnXvcezb27p6zD/x2nnmeOTPPc86cuTNnM908CYKgAtMoOJrJZHZ77q5bJfHhsANc+bjrZpzNLEO2Zagr4VXIQBOshQ/gPqiEx6Ac7odGaGB23KJMv3ADtphHfoZyFpQqK8oPjT2quIxxevqzzyb6F8lcBz3tnFDvAxdBoldjHsyGjXAbJJ/mLkirQhL7wlSCoNrPAft7xlfn+rA9D5fgLoxxfanTSWAySA74wWPrBXo1lOhw1099EkiOQYnrS51OAgeUCTLJDx6b1gXJjgjfd1lXMM33papOEtUmkaOULZ4m9VL4zfhHuolhe9HYT1H2cH2p00nge5PMG37w2GuMb0+Eb6fxzfB9qaqTxCiTyH4/cOzd4YTxV7l+bCOM/TRlT9eXOp0EFsG7UYFjnwKSfb4f2+bQEwRzfV+XqZOgdo0/mkTHu4lhGwp34E8Y7PqSrmvr20JIQLaFsJftboPrxKfEt8ERqMAfWD++L9E1e87BV/AzFFMaGf+EBmDs5yjcG3+b+jH4hTZ3KeMLnT0I+t0/Dy12h+oFm9046eyQE+w9YR10lJzV4AymvUrzPQY9i73FbM0FbJS8GWA63Uj5GsznDtaatmFBh6NRdEw+CUPx3wkd5g/+Yahq86hrL4L+A2NvUb+MWUPxlDNGKfozoF2qcqyh7XrKeEKHT8K/oO1uX/8qbHtAooETK8Q3DnRuuQJteyBcsAYkn/gZYnsh9GQ3SLrbiRXiXGZi1YyOL1w0EPRuXYWH/SuxbQfJLN+XpDrxTQ2jDIKlUXFFrgG2IRcuR58NtbxD861dJT4djg7Befgc2lP+obM6xvyDcR5Afx3yFuSYAw6h3VuwFzaZa/QroTVE8d9bGPxx+BtuQH+/JbY6KJZ8pvHofGaRBtAv3TutzgATgJ6uPo8t447Nkc0KHejV0LvV3uuAnpBmgD7IaBHWGP93BnBpnqivxXAxzg1Qkk2gff5gOAOVMBa0sl6Dg1BPwDcpUyHc2NMEOiBWsDReDJJv4FCo5f/R05oSq8MENCJWHd7i7RJpqN2h9gRWDqK8DVUwDTaBRO/VhATkVzAE4mzTDdBHkSaQ1ELeq4NNn9a06dAX4ycKRtCJDYhPBzvN2Oa8RKLiouGb2FfDt7zn49QG28sU1aBDzwbsmIIF6EvgClyFpEpvAtP61RArQBL7WtkhSlrJ281FaOSPToKy9wX9ZCZdNFMbYJDiLig0bDQZ9VNj9F2mbgv9XyGcTZT2y1Hb9t4FoyjcgLFLoAm0FukXKyfU7Se/0TkjSolbaUW3J76HTJtLXtvLegWMTT+XkuvZouP+EoNW9TWgh6HX1pVVpjLDNcbSuXv2nB+e/qjrtKhVVKIpP1EdUQ6SATkVq+MiNGLsctBJ9gKU2iHQe4MW6FuQd7ax7SJLLqgEif5JUqZGlPoQUQH2tdAqWA8SfVHqNGH8rWEUQfCKGwQ2ezJ837XH0rl4helUe4Cn3Yuol8F64z9M2cP1d7TO+ONNLDvdsbE9a+zHrT1cuGyltZIL++CvhzGgvfph+AkegSrQqe1XmMC7eJKy04RYuzP471AOOtHaNQy1m9YA5fISceqEGF/oWNNcO0B9/XXlJpUvoD0PLPEDi2hJLB+5AUbo83RZ7BngjkFnusPDoD9o03OEu3mDMjFCjFoAx0KviKD0vUGbuub/ABxRvQnCXr0RAAAAAElFTkSuQmCC"

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAiCAYAAAD23jEpAAAAAXNSR0IArs4c6QAAA81JREFUWAnVmX9oTWEYx3c3JjPM5EeIsDQR8qOmSUm0RSK/SsgfRqjNjz9mUbSV/6ZNSppNUTIRbaZFaX8pWVIsbGY2IbTYZGN+vD7f1z2a3c09trPt3m999pz73Od9n+c973nPe+5ZRAQyxvhgBVyDO7Bc/rARBS+CapB+whdohJhwGkQDBbfCKZgOh0HaGU6DeEbBHyFWRWNHgQZVFU6DyKRgaY9TNMdF1mPMMscX0pZi46EFnoBPxWJng3Q9pItvXxzFnrYlG5Pq+PlcAVroCY4vpC2FzgCp3CmU4zXWY8wJxxfyloJvgc58oorFRkIdNMOwUB6AXQP+oldiS+Ec5MqHdoAWfDZcAbdqI7De5/O1um3gSRxnW7t2DXglzepLKIMUT4rsopM/M6HvSZaOyYfncBW6q0gaxsFMmAf6fB82MDu1WE/VcRBD6f2VP8NirC6L7qqFgl9wYsbRwUHQZdkIKfg1oN4TSfPAK9XSkTbTgbAK2kAD8/RG8ddM6NSQYCqmGj5DEUjxsAUawO1lNoJY3SzU9jasgDTQLTuf2diL7T0xkBKQ5igLVov+MWhnH+k2M7FDoRykXNBt+ynotm2f1dz29d9xJFgK0lmnMce7rceYLMfnxtImGnQCvsFYyABpm5v2PYohyUPQb4vRoJmIhQ+g26aucfnckkaslAVL7JExhVhX7bs9EBI4if05+9W8IfvqrgYTsLCdQBrN5/ge1EGN4++m7TKPy/4WEKe9ZiI3hCaXbexidtZFputGvRTICd3nvw4OdJZCowsHnaHIZkhnMAM6FhzgaBegfUJaS8Mpvw/7/G8Jl08ZfKIGDWS/6oFiV5XQKApuQn9Kv/2Hq2DsJPgOdzsOIOiCo9EjGk2DJJgLBXAejkBvajOdZ8MhZuKYElHLJcx6SMZ3R76golEySBcUjC21n4yZFbRxDwPIMwTewzuw78CwSSBddt09wRdtE2MWYqfCD6hw3UEPA8nlvAPLcLrCpzeUuqwmO74uLUHjQY8K2is0C8dB0sLqE5ErDppATwnRSopdB1Je0CIIyrGhxmzFamq1yPS2MCpoYw8DyHcMpO3qFqsbTh3oIdIu+k7T8eUg0LX41n+8Cyvpx02fipx6I6mnZ72ptCcQ+8/NzxZIkM6+lCMHtgpawfVjuJcjJW8+SJv89egRX5dZPXS+1/FFJWjxJEAqSIVeFvY/fZF7AnwFPVnHwGA4CdLGgL5wJtqvAv/YH0gBDfrIQTkFgSVZz43OpuI1dWlDG9Ouvko2lwftPvfH4VGS6tdgx/+bFP8C55BwaECzvCAAAAAASUVORK5CYII="

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABECAYAAAB6UOAlAAAAAXNSR0IArs4c6QAACNNJREFUeAHtnHmMFEUUh12EACKIiCQEUAiJoKKC8UBxQSVRRINiIIqGCBiUEIgHiMEAakQgBo1R8SCIYhSBAPKHkSiJghwegKBGQiTIrQgCIosHp98b+m3e1vTMds9Ms9M7/ZLfvqOqXtV7NVPd1V2zZWdkoJMnT5ZT1AtcDH4B08rKyrbAE4o6AyS/PhgE1gGXDmC4NOoxlLR/EtwATAC/g2y0uKQTFWXwZP1c8FOG7B/FvsOUnUDuGOV4StY3iZ1pEq3iPoTJoA3orEaPv16yyYoycJK7xyR6C/JQ0ND2ib4UKFUgNLXliVyADJDUzZph+DI/l9j7mjoijvarl9jyyABJfc1JcmfXHeVngi2m3laxufUSPY8MkNAOQC7CSu/4uaNwlFbw+N1+9RJbHhkgsYtNkv9FbuG6w9YUyPVByXcZc9sleogMkNleml2Pj/drTtk0p17aMubXLrEFzADJLQMbTZJ/Ra7nNscWaBlz2yV6iAyQ5OFmIkS836859mqXMb92iS1gBkhwIyDPk5S+9WtKYaBlzK9tYguYAZI8VWfB49e5TbEHWsbcdokeIgMkuS045k2CsDl+zbEHWsb82ia2gBkgyQtlBjySh36t3abYAi1jbrtED5EBktwDWJrk15wK1S5jfu0SW4gMkOT1Zib+QK7yEFBcYQu0jIXotqSrlvlFT5IHY59pyl5GXmt0FcchdPCUY/Bh4D9Pj4JV4HSfhx28uj0URSc14TPTRNRnMDvA+TUxqIB9nqDeBvAV+Bh8wsTIh6F2Ed+K50CcaDeDnQiaxHEmfL8REggBtYRtA2mPOqS8iGkvYxvLt+PtIh5j2tAyToTUZDI+gN1nWo1Bft/op1OUscqH4hzQBsiJkm6gJ2gEXPoQw1Am5LBbEDudibgGWPJ97FGTgTG4s8AgsMEO1JO/hsdiqcr6jZAEE4hcDLuaZI9E/t3op1s8SofbwY982kVOEeOUN4YytsmgQcp46s9KWE/qRnk3Z7qLSCTAe0Ex0iEGNQ/I8lRJ6HLqZBew9FZlhbgKRFMX7LRRFaEsj2Waa46R24PfnHH20fLYcgJ6ygmqGFVJvJzTTRFyV3DEDHQbsl2ytGpR8GqvETJKApBPm2zwNJDVyPcAl27B8KYxTkGebvRCiPVxIndM/UB/INcGpV0I5VwPUoelGfcz6E9rIXwEZdOMHj+RoGYAS5e4UVDoLmObsAWabNdXEB3fncAPwNIalDrSHt4AyGtfpa0IduKCdFNcdQjgMo3G4/aTXzlYytxl7PbKwggE+msC1npjUvawdoVhvBo9fquWxZYTyOcmqMPIzdxgsDUH/5h6n7l1Cq3TV0tw0PQpT4xTmzx4CyBHhJRmFbr/0+6PSO7UaDwuO+00oqzaZSytUZ4G+hzpjK3yGoZ9vimTnx5EtlzmGUaw5gRQB9izsnInkrbmYgu0jAXrNVgt+mwI/gRKC7UlhmFq9Hja9U3rxoYTyGNOUP3Q5UCBTJLFF+hKqWUMxZZHIU/XDuGyPN4EysFgYGkgSkH7z3cCQ39FCUAeuu0EZ3udn4SH9uO1rU1sP8F8CcZwi7wpbGCp27wwjejkIPXfNW2SSTiVDLlxuQvI7bPsc0JR6InwvC8N1UtpVZanvTPChlw3bAOvvr3YyevJcaDySWiOPvNtluuHKt9+tf1tCDd7ijxekR3+ci2MhNPJJKB0IJJOYuaUZFwA7OG8j8KEUNOfojBjLeq6fPq3M8AFZpB9mJj2Rs8qJhORNT2hC18yLSS3jxg9q5hMRNb0hCvkW/ENLVaZVrJ/aWr0jGKuF+vjxmM9OrsKXfYTpUQbSbzfwQT5VlzvJUL2Wg+BFzw9I8tpD0DiB+LxvYxeS6NAThn2YDLW2XDJjTzykQ1dO88um9921Mt6+C3XpWkRzuUlTClTY4KXo6hViITLavGKMbZGlhdYWSmnb4R4ZOYvh80Bla8nxV6CJPuFFTZuciOTJN8E2dwJraHO1adE/785T4S6o9NnkSeoDpdXkzoweSn0uCmTtfJTo8dRlIvvPKBPnReT5N5uIORlKrZRxt6detFt8Ojwe6C0B0HeKacIebkWwP8C8kmJPRHHbBOXiF3coLC5G7yFbp2C6XR2o4zC0ER1jq2LsYto102tFktOLJ2A/W8N8/0Coc5coHQcIfAGz89fRhuOF2gvcPmZVyutjDzTlMmgL9Ky2sCJZ5GJT5Lc0Y0L27WmjoiF/zDi1P3qzdWBUOa+t651//mMGN1zwbM0fsuptxIoyenEQBs86yOrjMMp6t3j3bQB+linLO1ipnXjzIlxiYlTVoS2bjzY5A2mpSfcOjnreJX3w3JSQuk7dYZB/qXQdi2AR3q2SfutCU5s7jXyDXcc1JF8bAFKkpu6br2cdBw9qF49PkgdobufgMAPvtRHnDjx2qVHju3ID3yqELZHgaUBVSrkquBxvfG6F1mPYspGb5kpkzVRNzW5dlfU7Yivt4lXRNk/VCFsjYE9d7W6SoVcFBx2B5aeVz8Yr7AFyNO0rDZz4lxn4pYPXzM3Xmwvmjoi3uDWCaXjwB7WkguUPEtJEbI9WCa3rGm3dFq3NnHi7A8sydOGKkThhcC+wct9g4ejNo4z2eqnCHsz8DdQivyopfZd05yA5YzURg0cvh+kPUXAVpgNHo4mA0vlmgSMY2wB8h1aVgqceB9w4n/SjZvy/Dd4OJEj7vaWtfI5PHa5RdsKlDYj5PqI3R1/LHTilZ8k2BzsRm/oDh7bKqAUfoNHyyHa2uNDtBP0vk6ZfeKq1Wo9JwfDnTyMcIOm3L29D7fBw4G9M5DDvq3AeR6WwpUqEAq7jXejKVKduGXVsL/d24YuPwvQPAkX3f7YMvgGj4blICil7S6LNG+RDIskjQ6aKFNvQNB1PMyvbF6NJML4OJVfUu0POdxeQSdiJY7lv8FUR7N5CyX/MaZkifgrCN7+gDJILpYHflXK1+hKPHYGmdrspmwJAzkSpOfaXod8ydPoDiBTviQFcgTpZ3K24n85khK7n1dUJgAAAABJRU5ErkJggg=="

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(626),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports) {

module.exports = {
  en: {
    message: {
      welcome: 'Welcome',
      settings: 'Settings',
      seats: 'Umbrellas in total',
      beach: 'Beach',
      pool: 'Pool',
      umbrella: {
        free: '',
        occupied: ''
      }
    }
  },
  it: {
    message: {
      welcome: 'Benvenuto',
      settings: 'Impostazioni',
      seats: 'Ombrelloni in totale',
      beach: 'Spiaggia',
      pool: 'Piscina',
      umbrella: {
        free: 'liberi',
        occupied: 'occupati'
      }
    }
  },
  de: {
    message: {
      welcome: 'Willkommen',
      settings: 'Einstellungen',
      seats: 'Schirme',
      beach: 'Strand',
      pool: 'Pool',
      umbrella: {
        free: '',
        occupied: ''
      }
    }
  }
};

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_auth0_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_auth0_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_auth0_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_event_emitter__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_event_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_event_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(258);









__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);

var AuthService = function () {
  function AuthService() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthService);

    this.authenticated = this.isAuthenticated();
    this.authNotifier = new __WEBPACK_IMPORTED_MODULE_5_event_emitter___default.a();
    this.auth0 = new __WEBPACK_IMPORTED_MODULE_3_auth0_js___default.a.WebAuth({
      domain: 'gweit.eu.auth0.com',
      clientID: '1arTRlw6K1AINYliP54281pQxemtLRwX',
      redirectUri: 'http://localhost:8080/callback',
      // redirectUri: 'http://vue.drophost.it/callback',
      audience: 'https://gweit.eu.auth0.com/userinfo',
      responseType: 'token id_token',
      scope: 'openid profile email'
    });

    this.login = this.login.bind(this);
    this.setSession = this.setSession.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AuthService, [{
    key: 'login',
    value: function login() {
      this.auth0.authorize();
    }
  }, {
    key: 'handleAuthentication',
    value: function handleAuthentication(id, jwt) {
      console.log(id);
      console.log(jwt);
      localStorage.setItem('userid', id);
      localStorage.setItem('jwt', jwt);
      // this.auth.authenticated = true
      // router.replace('ombrelli')
      // Vue.http
      //         .post('http://localhost:44534/ombrelloni', {'userid': id}).then((data) => {
      //           console.log(data)
      //           // router.replace('ombrelli/' + id)
      //         }, (error) => {
      //           console.log(error)
      //         })
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get('http://localhost:44537/ombrelloni', {
        headers: {
          'Authorization': 'Bearer ' + jwt
        }
      }).then(function (data) {
        console.log(data.body.hotels.length);
        if (data.body.hotels.length > 1) {
          console.log('multihotel');
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('hotel');
        } else if (data.body.hotels.length === 1) {
          console.log('one hotel');
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('ombrelli/' + data.body.hotels[0]._id);
        } else {
          console.log('no hotel');
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('addhotel');
        }
      }, function (error) {
        console.log(error);
      });
      // this.auth0.parseHash((err, authResult) => {
      //   console.log(authResult)
      //   // if (authResult && authResult.accessToken && authResult.idToken) {
      //   //   this.setSession(authResult)
      //   //   // router.replace('hello')
      //   // }
      //   if (authResult) {
      //     // this.setSession(authResult)
      //     console.log(authResult)
      //     // router.replace('hello')
      //   } else if (err) {
      //     router.replace('hello')
      //     console.log(err)
      //     alert(`Error: ${err.error}. Check the console for further details.`)
      //   }
      //   // get user profile data
      //   this.auth0.client.userInfo(authResult.accessToken, function (err, profile) {
      //     if (err) {
      //       // handle error
      //       alert(err)
      //     }
      //     console.log(profile.email)
      //     localStorage.setItem('profile', JSON.stringify(profile))
      //     localStorage.setItem('email', profile.email)
      //   })
      //   Vue.$http
      //     .post('https://gweit.eu.auth0.com/oauth/token', {client_id: 'Kypu4g8sp1yYw8f9CWlyAFH4oXO9RWhT', client_secret: 'j9I5NW9PqVDPXj0af0mVSrpKligpdkjBkxK1qjpPeAUZ78lsC7_enQT7FdzwBZAI', audience: 'https://obrelleria.node.systems', grant_type: 'client_credentials'}).then((data) => {
      //       console.log(data)
      //       const access = JSON.parse(data.bodyText)
      //       console.log(access.access_token)
      //       localStorage.setItem('token', access.access_token)
      //     }, (error) => {
      //       console.log(error)
      //     })
      //   // Vue.$http
      //   //   .post('http://localhost:8000/api/user', {'email': localStorage.email}).then((data) => {
      //   //     console.log(data)
      //   //     // const access = JSON.parse(data.bodyText)
      //   //     // console.log(access.access_token)
      //   //     // localStorage.setItem('token', access.access_token)
      //   //   }, (error) => {
      //   //     console.log(error)
      //   //   })
      // })
    }
  }, {
    key: 'setSession',
    value: function setSession(authResult) {
      // Set the time that the access token will expire at
      var expiresAt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(authResult.expiresIn * 1000 + new Date().getTime());
      localStorage.setItem('access_token', authResult.accessToken);
      localStorage.setItem('id_token', authResult.idToken);
      localStorage.setItem('expires_at', expiresAt);
      this.authNotifier.emit('authChange', { authenticated: true });
    }
  }, {
    key: 'logout',
    value: function logout() {
      // Clear access token and ID token from local storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('expires_at');
      localStorage.removeItem('token');
      localStorage.removeItem('profile');
      localStorage.removeItem('jwt');
      localStorage.removeItem('userid');
      localStorage.removeItem('email');
      localStorage.removeItem('profile.email');
      this.userProfile = null;
      this.authNotifier.emit('authChange', false);
      // navigate to the home route
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('/');
    }
  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      // Check whether the current time is past the
      // access token's expiry time
      var expiresAt = JSON.parse(localStorage.getItem('expires_at'));
      return new Date().getTime() < expiresAt;
    }
  }]);

  return AuthService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthService);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_it__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_i18n__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locale__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_drag_drop__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_drag_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_resize__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_drag_resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_socket_io_extended__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_socket_io_client__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__chenfengyuan_vue_qrcode__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_mq__ = __webpack_require__(270);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import Notifications from 'vue-notification'

// import socketio from 'socket.io'
// import VueSocketIO from 'vue-socket.io'
// export const SocketInstance = socketio('http://localhost:44544')
// Vue.use(VueSocketIO, SocketInstance)
// import VueSocketIO from 'vue-socket.io'





var sockethost = "https://dexter.node.systems:44546";





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_14__chenfengyuan_vue_qrcode__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__chenfengyuan_vue_qrcode__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_mq__["a" /* default */], {
  breakpoints: { // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: 'sm' // customize this for SSR
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: 'UA-124191030-1',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  beforeFirstHit: function beforeFirstHit() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$ga.set('anonymizeIp', true);
  }
});
// import VueGridLayout from 'vue-grid-layout'
// import VueDragscroll from 'vue-dragscroll'

// Vue.use(VueDragscroll)
// Vue.use(VueGridLayout)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_socket_io_extended__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13_socket_io_client___default()(sockethost));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vue-drag-resize', __WEBPACK_IMPORTED_MODULE_11_vue_drag_resize___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_drag_drop___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]);
// Vue.use(ElementUI)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_it___default.a });
// Vue.use(VueSocketio, 'http://127.0.0.1:44544')
// Vue.use(VueSocketio, sockethost)
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: sockethost
// }))

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// Vue.use(Notifications)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default.a, { dynamic: true });

// const messages = {
//   en: {
//     message: {
//       welcome: 'Welcome',
//       settings: 'Settings'
//     }
//   },
//   it: {
//     message: {
//       welcome: 'Benvenuto',
//       settings: 'Impostazioni'
//     }
//   },
//   de: {
//     message: {
//       welcome: 'Willkommen',
//       settings: 'Einstellungen'
//     }
//   }
// }

var i18n = new __WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]({
  locale: 'en', // set locale
  messages: __WEBPACK_IMPORTED_MODULE_9__locale___default.a // set locale messages
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },
  i18n: i18n
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// export default {
//   // All elemets with the class 'selectable' selectable.
//   selectables: ['.selectable']
// }

/* harmony default export */ __webpack_exports__["a"] = ({
  // Class for the selection-area-element
  class: 'selection-area',

  selectedClass: 'selected',

  // px, how many pixels the point should move before starting the selection
  startThreshold: 10,

  // Disable the selection functionality for touch devices
  disableTouch: false,

  // Enable single-click selection
  singleClick: true,

  // Query selectors from elements from which the siblings can be selected
  // containers: ['.icon-grid'],
  // selectionAreaContainer: ['.editgrid'],

  // Query selectors from elements which can be selected
  selectables: ['.seat'],

  // Query selectors for elements from where a selection can be start
  startareas: ['html'],

  // Query selectors for elements which will be used as boundaries for the selection
  boundaries: ['.boundary'],

  //  ------------------------------------------
  // SELECT
  //  ------------------------------------------

  onSelect: function onSelect(evt) {
    var _this = this;

    // Check if clicked element is already selected
    var selected = evt.target.classList.contains(this.options.selectedClass);

    // Remove class if user don't press the control key or ⌘ key and the
    // current target is already selected
    if (!evt.originalEvent.shiftKey && !evt.originalEvent.metaKey) {
      // Remove class from every element which is selected
      evt.selectedElements.forEach(function (s) {
        return s.classList.remove(_this.options.selectedClass);
      });

      // Clear previous selection
      this.clearSelection();
    }

    if (!selected) {
      // Select element
      evt.target.classList.add(this.options.selectedClass);
      this.keepSelection();
    } else {
      // Deselect element
      evt.target.classList.remove(this.options.selectedClass);
      this.removeFromSelection(evt.target);
    }
  },


  //  ------------------------------------------
  // START
  //  ------------------------------------------

  // this event is triggered on drag start
  onStart: function onStart(evt) {
    var _this2 = this;

    // Get selected elements
    var selectedElements = evt.selectedElements;

    // Remove class if the user is'nt pressing the control key or ⌘ key
    if (!evt.originalEvent.shiftKey && !evt.originalEvent.metaKey) {
      // Deselect all elements
      selectedElements.forEach(function (s) {
        return s.classList.remove(_this2.options.selectedClass);
      });
      // Clear previous selection
      this.clearSelection();
    }
  },


  //  ------------------------------------------
  // MOVE
  //  ------------------------------------------

  // this event is triggered on mouse drag, not move
  onMove: function onMove(evt) {
    var _this3 = this;

    // Get elements added or removed
    var selectedElements = evt.selectedElements;
    var removedElements = evt.changedElements.removed;

    // Add a custom class to the elements which where selected.
    selectedElements.forEach(function (s) {
      return s.classList.add(_this3.options.selectedClass);
    });

    // Remove the class from elements which where removed
    // since the last selection
    removedElements.forEach(function (s) {
      return s.classList.remove(_this3.options.selectedClass);
    });
  },


  //  ------------------------------------------
  // STOP
  //  ------------------------------------------

  // this event is triggered on dragend
  onStop: function onStop() {
    this.keepSelection();
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 100 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    color: {
      default: '#35495e'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        border: this.stroke + ' solid ' + this.background,
        borderTopColor: this.color
      };
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    dotSize: {
      default: function _default() {
        var size = parseInt(this.size);
        return size / 3 + 1;
      }
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      var halfSize = size / 3;
      return {
        width: this.size,
        height: this.size,
        border: '0px solid ' + this.background,
        boxShadow: '0 -' + halfSize + 'px 0 ' + this.dotSize + 'px ' + this.background + ' inset'
      };
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 44 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 120 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    diamondStyle: function diamondStyle() {
      var size = parseInt(this.size);
      return {
        width: size / 4 + 'px',
        height: size / 4 + 'px'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 4 + 'px'
      };
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '2.0s'
    }
  },
  computed: {
    bounceStyle: function bounceStyle() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 2 + 'px'
      };
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 164 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 64 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size) / 2;
      return {
        transform: 'scale(' + size / 75 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 31 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: 'auto',
        fill: this.color
      };
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 250 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size,
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size
      };
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        backgroundColor: this.background,
        width: this.size,
        height: this.size,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 80 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.0s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 220 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    lineStyles: function lineStyles() {
      return {
        width: this.size,
        height: this.stroke,
        background: this.color,
        borderRadius: this.stroke
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.3s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    rectStyles: function rectStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    blobStyles: function blobStyles() {
      return {
        borderColor: this.color
      };
    },
    moveBlobStyles: function moveBlobStyles() {
      return {
        borderColor: this.color,
        background: this.color
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationName: 'sk-cubemove',
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_AuthService__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var host = "https://dexter.node.systems:44537";
// var sockethost = process.env.ROOT_SOCKET



var auth = new __WEBPACK_IMPORTED_MODULE_0__auth_AuthService__["a" /* default */]();

var login = auth.login,
    logout = auth.logout,
    authenticated = auth.authenticated,
    authNotifier = auth.authNotifier;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    var _this = this;

    authNotifier.on('authChange', function (authState) {
      _this.authenticated = authState.authenticated;
    });
    return {
      auth: auth,
      authenticated: authenticated
    };
  },

  components: {
    RotateSquare2: __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__["a" /* RotateSquare2 */]
  },
  methods: {
    login: login,
    logout: logout,
    getHotels: function getHotels() {
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized', {}).then((data) => {
      .get(host
      // {
      //   headers: {
      //     'Authorization': 'Bearer ' + localStorage.token
      //   },
      //   access_token: localStorage.access_token
      // }
      ).then(function (data) {
        console.log('api good');
      }, function (error) {
        // this.$notify({
        //   group: 'foo',
        //   title: 'Important message',
        //   text: 'Hello user! This is a notification!',
        //   type: 'error'
        // })
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getHotels();
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var host = "https://dexter.node.systems:44537";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ombrelli',
  data: function data() {
    return {
      loading: false,
      grid: {
        active: 0,
        options: [{
          title: 'Nome Hotel',
          desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
          visible: true
        }, {
          title: 'Scelta spiaggia',
          desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
          visible: true
        }, {
          title: 'Generator',
          desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
          visible: false
        }, {
          title: 'Controlla e salva',
          desc: 'inserischi il nome del tuo Hotel e scegli il tuo colore preferito',
          visible: true
        }]
      },
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      ombrelli: [],
      letters: {
        first: 'A',
        last: '',
        act: 0,
        row: 1
      },
      numbers: {
        first: 1,
        last: 0,
        act: 0
      },
      hotel: {
        name: '',
        rows: '',
        cols: '',
        lang: 'it',
        colors: {
          primary: '#19b5fe',
          secondary: '#753dfe'
        },
        beachtype: 'grid',
        gridtype: 'left'
      },
      rules: {
        name: [{ required: true, message: 'prego inserisci il nome del tuo Hotel', trigger: 'blur' }],
        // cols: [
        //     { required: false, message: 'prego inserisci un numero', trigger: 'blur' }
        // ],
        // rows: [
        //     { required: false, message: 'prego inserisci un numero', trigger: 'blur' }
        // ],
        letterfirst: [{ required: true, message: 'prego inserisci una lettera', trigger: 'blur' }, { min: 0, max: 1, message: 'Length should be 3 to 5', trigger: 'blur' }],
        numberfirst: [{ required: false, message: 'prego inserisci un numero', trigger: 'blur' }]
      },
      error: {
        state: false,
        message: ''
      },
      success: {
        state: false,
        message: ''
      }
    };
  },

  components: {
    Circle4: __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__["b" /* Circle4 */]
  },
  methods: {
    next: function next(formName) {
      var _this = this;

      console.log(formName);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.grid.active++;
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },
    stepHandler: function stepHandler(e, i) {
      console.log(e, i);
      this.grid.active = i;
    },
    changeStep: function changeStep(type) {
      console.log(type);
      if (this.hotel.beachtype === 'grid') {
        this.grid.options[2].visible = true;
        this.grid.active = 2;
      } else {
        this.grid.options[2].visible = false;
        this.grid.active = 3;
      }
    },
    resetGrid: function resetGrid() {
      console.log('resetGrid');
      this.ombrelli = [];
      this.grid.firststep = true;
      this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
      this.letters.row = 1;
      this.numbers.act = this.numbers.first;
      // this.grid.active = 2
      if (this.letters.first.length === 0 || this.hotel.gridtype === 'empty') {
        this.setemptyGrid();
      } else {
        this.setGrid();
      }
    },
    setemptyGrid: function setemptyGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      this.grid.active = 3;
      this.hotel.gridtype = 'empty';
      console.log('ombrelli length', this.ombrelli.length + 1, 'numbers act: ', this.numbers.act);
      if (this.ombrelli.length === grid) {
        console.log('done');
      } else {
        this.ombrelli.push({ ombrid: parseInt(this.numbers.act), free: true });
        this.numbers.act++;
        // if (grid > 99 && this.numbers.act <= 9) {
        //   console.log('case: 1')
        //   this.ombrelli.push({ombrid: '00' + (parseInt(this.numbers.act)), free: true})
        //   this.numbers.act++
        // } else if (grid > 99 && this.numbers.act <= 99) {
        //   console.log('case: 2')
        //   this.ombrelli.push({ombrid: '0' + (parseInt(this.numbers.act)), free: true})
        //   this.numbers.act++
        // } else {
        //   console.log('case: 3')
        //   this.ombrelli.push({ombrid: (parseInt(this.numbers.act)), free: true})
        //   this.numbers.act++
        // }
        this.setemptyGrid();
      }
    },
    setGrid: function setGrid() {
      this.grid.active = 3;
      var grid = this.hotel.cols * this.hotel.rows;
      // console.log(this.letters.first)
      if (this.letters.act === this.alphabet.length) {
        this.letters.act = 0;
      }
      var act = this.alphabet[this.letters.act].toUpperCase();
      console.log('act: ', act, this.numbers.act);
      if (this.ombrelli.length === grid) {
        console.log('done');
      } else {
        // console.log('not done')
        this.ombrelli.push({ ombrid: act + this.numbers.act, free: true });
        console.log('nr: ', act + this.numbers.act);
        if (this.hotel.gridtype === 'left') {
          this.numbers.act++;
        } else {
          this.letters.act++;
        }
        if (this.ombrelli.length === this.hotel.cols * this.letters.row) {
          if (this.hotel.gridtype === 'left') {
            this.numbers.act = this.numbers.first;
            this.letters.row++;
            this.letters.act++;
          } else {
            this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
            this.numbers.act++;
            this.letters.row++;
          }
          console.log('end of row', this.letters.row - 1, this.numbers.act);
        } else {}
        this.setGrid();
        // this.ombrelli.push({ombrid: act + this.numbers.act, free: true})
        // console.log('nr: ', act + this.numbers.act)
        // if (this.hotel.gridtype === 'left') {
        //   this.numbers.act++
        // } else {
        //   this.letters.act++
        // }
        // if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //   if (this.hotel.gridtype === 'left') {
        //     this.numbers.act = this.numbers.first
        //     this.letters.row++
        //     this.letters.act++
        //   } else {
        //     this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
        //     this.numbers.act++
        //     this.letters.row++
        //   }
        //   console.log('end of row', this.letters.row - 1, this.numbers.act)
        // } else {}
        // this.setGrid()
      }
    },
    saveGrid: function saveGrid() {
      var _this2 = this;

      console.log(this.ombrelli);
      this.loading = true;
      this.$http.post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        if (_this2.hotel.beachtype === 'grid') {
          __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace('ombrelli/' + data.body.hotel._id);
        } else {
          __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace('Canvas/' + data.body.hotel._id);
        }
      }, function (error) {
        console.log(error);
        _this2.$notify({
          group: 'foo',
          title: 'grid saved',
          type: 'success',
          duration: 500
        });
      });
    },

    inserthotel: function inserthotel() {
      console.log(this.hotels);
      this.loading = true;
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/addhotel', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data.body.hotelid);
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace('ombrelli/' + data.body.hotelid);
      }, function (error) {
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    // this.getHotel()
  },

  computed: {
    filteredSteps: function filteredSteps(options) {
      return this.grid.options.filter(function (option) {
        return option.visible === true;
      });
    },
    style: function style() {
      return 'grid-template-columns: repeat(' + this.hotel.cols + ', 1fr); grid-template-rows: repeat(' + this.hotel.rows + ', auto);';
    },
    pregrid: function pregrid() {
      var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1;
      if (this.letters.first.length > 0) {
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.numbers.first) + 1 } };
        }
      } else {
        console.log('no letter', this.hotel.cols);
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.hotel.cols + 1 }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.hotel.cols) + 1 } };
        }
      }
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'callback',
  props: ['auth'],
  data: function data() {
    this.auth.handleAuthentication(this.$route.query.id, this.$route.query.jwt);
    // console.log(this.$route.query.id)
    return {};
  },

  components: {
    Circle4: __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__["b" /* Circle4 */]
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_range__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Navbar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Hello_World__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Hello_World___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Hello_World__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_drag_drop__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_drag_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_drag_resize__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_drag_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_drag_resize__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import EmbeddedSlack from 'embedded-slack'
// const chat = new EmbeddedSlack({
//   containerId: 'embedded-slack',
//   channel: 'C03M1FH6Y',
//   token: 'xoxp-3715527188-3715527214-346873012933-85307408b261ae33e2a178e9a2c4914c'
// })
var host = "https://dexter.node.systems:44537";
// var host = 'http://drop3.drophost.it:44534'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pool',
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      loading: true,
      hotel: '',
      secret: '',
      ombrelli: '',
      style: '',
      hotelid: '',
      ombrellos: '',
      today: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'),
      overview: {
        arrivals: [],
        departures: [],
        stays: []
      },
      langs: [{
        lang: 'it'
      }, {
        lang: 'de'
      }],
      addombrello: {
        ombrid: ''
      },
      query: '',
      date: ['2016-10-16', '2024-10-05'],
      lang: 'it',
      rangepicker: [],
      range: {
        startDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()(),
        endDate: ''
      },
      datePickerOptions: {
        firstDayOfWeek: 1
      },
      firstDayOfWeek: 1,
      editombrid: false,
      dragging: null,
      lock: null,
      draggable: true,
      location: 'canvas',
      edit: false,
      disabledDates: []
    };
  },

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_date___default.a,
    Circle4: __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__["b" /* Circle4 */],
    DateRange: __WEBPACK_IMPORTED_MODULE_4_vue_date_range__["DateRange"],
    'Navbar': __WEBPACK_IMPORTED_MODULE_6__components_Navbar___default.a,
    Hello: __WEBPACK_IMPORTED_MODULE_7__components_Hello_World___default.a,
    Drag: __WEBPACK_IMPORTED_MODULE_8_vue_drag_drop__["Drag"],
    Drop: __WEBPACK_IMPORTED_MODULE_8_vue_drag_drop__["Drop"],
    VueDragResize: __WEBPACK_IMPORTED_MODULE_9_vue_drag_resize___default.a
    // EmbeddedSlack
    // chat
  },
  sockets: {
    connect: function connect() {
      console.log('socket connected');
    },
    stream: function stream(val) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)');
      console.log(val.hotelid);
      if (val.hotelid === this.hotelid) {
        console.log('an umbrella was updated');
        this.getOmbrelli();
      }
    },
    disconnect: function disconnect() {
      console.log('socket error');
      this.$notify({
        group: 'foo',
        title: 'Error loading Data',
        text: 'I´ll fix it in a few',
        type: 'warning',
        duration: 5000
      });
    }
  },
  methods: {
    changeDate: function changeDate() {
      console.log(__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.today).format('YYYY-MM-DD'));
      this.today = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.today).format('YYYY-MM-DD');
      // this.range.startDate = moment(this.today)
      this.getOmbrelli();
      this.rangeview = false;
    },
    changeRange: function changeRange() {
      var _this = this;

      this.loading = true;
      // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
      var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.rangepicker[0], 'YYYY-MM-DD');
      var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.rangepicker[1], 'YYYY-MM-DD');
      var range = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.range(start, end);
      var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days')).map(function (m) {
        return m.format('YYYY-MM-DD');
      });
      // console.log('range picker dates: ', dates)
      this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);';
      this.rangeviewdata = dates;
      this.rangeview = true;
      this.ombrelli.forEach(function (ombrello, indexo) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this.ombrelli[indexo], 'dates', []);
        dates.forEach(function (date, indexd) {
          _this.ombrelli[indexo].dates.push({ date: __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD'), day: __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('dd'), guests: [], free: true });
          ombrello.guests.forEach(function (guest, index) {
            if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).isBetween(guest.arrival, guest.departure, null, _this.hotel.singledaybooking ? '[]' : '[)')) {
              _this.ombrelli[indexo].dates[indexd].guests.push(guest);
              _this.ombrelli[indexo].dates[indexd].free = false;
            } else {}
          });
        });
      });
      this.loading = false;
    },
    noshow: function noshow() {},
    deleteOmbrello: function deleteOmbrello(index) {
      console.log('deleteOmbrello: ', index);
      this.ombrelli.splice(index, 1);
    },
    getOverview: function getOverview() {
      var _this2 = this;

      this.overview.arrivals = [];
      this.overview.departures = [];
      this.overview.stays = [];
      this.ombrelli.forEach(function (ombrello, indexo) {
        // console.log('ombrello: ', ombrello)
        // this.ombrelli.push(ombrello)
        ombrello.guests.forEach(function (guest, index) {
          console.log('guest: ', guest);
          // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
          if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this2.today).isSame(guest.arrival)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
            console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival);
            _this2.overview.arrivals.push({ guest: guest, ombrid: ombrello.ombrid });
          } else if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this2.today).isSame(guest.departure)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
            console.log(ombrello.ombrid + ' is starting today: ' + guest.departure);
            _this2.overview.departures.push({ guest: guest, ombrid: ombrello.ombrid });
          } else if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this2.today).isBetween(guest.arrival, guest.departure, null, '()')) {
            console.log(ombrello.ombrid + ' is staying here today: ' + guest.departure);
            _this2.overview.stays.push({ guest: guest, ombrid: ombrello.ombrid });
          }
        });
      });
    },

    // filter (query) {
    //   console.log(this.query, this.overview.arrivals.filter(item => item.ombrid === this.query))
    //   this.filtered = this.overview.arrivals.filter(item => item.guest.name === this.query)
    // },
    editCanvas: function editCanvas() {
      // console.log(this.edit)
      if (this.edit) {
        console.log('edit off');
        this.edit = false;
        this.updategrid();
      } else {
        console.log('edit on');
        this.edit = true;
      }
    },

    disabledFunc: function disabledFunc(dayMoment) {
      // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
      // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
      if (this.disabledDates.includes(__WEBPACK_IMPORTED_MODULE_5_moment___default()(dayMoment).format('YYYY-MM-DD'))) {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return true;
      } else {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return false;
      }
    },
    preCheckDate: function preCheckDate() {
      var _this3 = this;

      console.log('preCheckDate');
      this.disabledDates = [];
      this.ombrellos.guests.forEach(function (guest, indexo) {
        if (guest.name !== _this3.ombrellos.guest) {
          var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(guest.arrival, 'YYYY-MM-DD');
          var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(guest.departure, 'YYYY-MM-DD');
          var range = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.range(start, end);
          var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days', { excludeStart: false, excludeEnd: !_this3.hotel.singledaybooking })).map(function (m) {
            return m.format('YYYY-MM-DD');
          });
          Array.prototype.push.apply(_this3.disabledDates, dates);
          console.log('guest: ', guest.name, dates);
        }
      });
    },

    // saveOmbrello: function () {
    //   console.log(this.ombrellos)
    //   console.log(this.range['endDate'])
    //   this.$delete(this.ombrellos, '__v')
    //   this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
    //   this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
    //   this.editombrid = false
    //   this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
    //   this.ombrellos.guest = ''
    //   this.ombrellos.room = ''
    //   this.ombrellos.arrival = ''
    //   this.ombrellos.departure = ''
    //   this.ombrellos.guestsinday = []
    //   this.ombrellos.free = true
    //   console.log('ombrello: ', this.ombrellos.ombrid, this.ombrellos.guests)
    //   this.$http
    //     .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       this.$modal.hide('hello-world')
    //       this.getOmbrelli()
    //     }, (error) => {
    //       console.log(error)
    //       this.$notify({
    //         group: 'foo',
    //         title: 'Error loading Data',
    //         text: 'I´ll fix it in a few',
    //         type: 'warning',
    //         duration: 500
    //       })
    //     })
    // },
    addombrid: function addombrid() {
      // this.hotel.pools = []
      this.ombrelli.push({
        free: true,
        location: 'canvas',
        ombrid: this.ombrelli.length + 1,
        hotelid: this.hotel._id,
        user: this.hotel.user,
        width: 130,
        height: 145,
        guests: [],
        x: 500,
        y: 500
      });
      this.ombrellos = {
        free: true,
        location: 'canvas',
        ombrid: this.ombrelli.length + 1,
        hotelid: this.hotel._id,
        user: this.hotel.user,
        width: 130,
        height: 145,
        guests: [],
        x: 500,
        y: 500
        // this.updateombrello()
      };
    },
    onResizing: function onResizing(id, left, top, width, height) {
      // console.log(id, left, top, width, height)
      this.ombrelli[id].left = left.left;
      this.ombrelli[id].top = left.top;
      this.ombrelli[id].x = left.left;
      this.ombrelli[id].y = left.top;
      // this.ombrelli[id].x = left.left
      // this.ombrelli[id].left = left.left
    },
    resize: function resize(newRect) {
      console.log(newRect);
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    pooldrag: function pooldrag(id, left, top, width, height) {
      // console.log(id, left, top, width, height)
      this.hotel.pools[id].x = left.left;
      this.hotel.pools[id].y = left.top;
      this.hotel.pools[id].width = left.width;
      this.hotel.pools[id].height = left.height;
    },
    handleDragover: function handleDragover(group, data, event) {
      // console.log(data)
      // console.log(group.ombrid)
      // console.log(event)
      if (!group.free) {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleDrop: function handleDrop(group, data, key) {
      console.log(group.ombrello.ombrid, data.target.id);
      this.moveombrello(group.ombrello, data.target.id);
      // alert(`You dropped with data: ${JSON.stringify(data)}`)
    },
    changeombrid: function changeombrid() {
      console.log('changeombrid');
      this.editombrid = true;
    },
    onChange: function onChange(range) {
      this.range = range;
      console.log(__WEBPACK_IMPORTED_MODULE_5_moment___default()(range.endDate._d));
    },
    setRange: function setRange(p) {
      if (typeof p === 'number') {
        console.log(p);
        this.range = {
          startDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(p, 'days'),
          endDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()()
        };
      }
    },
    show: function show(ombrello) {
      console.log(ombrello.arrival);
      this.ombrellos = ombrello;
      this.range = {};
      if (ombrello.free) {
        this.ombrellos.items = this.hotel.items;
        // this.ombrellos.chairs = this.hotel.chairs
        // this.ombrellos.beds = this.hotel.beds
      } else if (!ombrello.items) {
        this.ombrellos.items = this.hotel.items;
      }
      // if (ombrello.free) {
      //   this.ombrellos.chairs = this.hotel.chairs
      //   this.ombrellos.beds = this.hotel.beds
      // }
      // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
      // this.date[0] = ombrello.arrival
      // this.date[1] = ombrello.departure
      // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
      if (!ombrello.free) {
        // console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'))
        this.range.startDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(ombrello.arrival);
        this.range.endDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(ombrello.departure);
      } else if (this.hotel.singledaybooking) {
        this.range.startDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.today);
        this.range.endDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.today);
      } else {
        this.range.startDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.today);
        this.range.endDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.today).add(1, 'days');
      }
      // if (ombrello.departure !== '') {
      //   this.range.endDate = moment(ombrello.departure)
      // } else {
      //   this.range.endDate = moment(this.today).add(1, 'days')
      // }
      this.preCheckDate();
      this.$modal.show('hello-world');
    },
    hide: function hide() {
      this.$modal.hide('hello-world');
    },
    settings: function settings() {
      this.$modal.show('settings');
    },

    updategrid: function updategrid() {
      var _this4 = this;

      console.log(this.ombrelli);
      // console.log(this.range['endDate'])
      // this.editombrid = false
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/api/updategrid', { ombrelli: this.ombrelli, hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        // this.$modal.hide('hello-world')
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this4.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    updatehotel: function updatehotel() {
      var _this5 = this;

      this.$http.post(host + '/api/updatehotel', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this5.$modal.hide('settings');
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this5.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    // updateombrello: function () {
    //   console.log(this.ombrellos)
    //   console.log(this.range['endDate'])
    //   this.$delete(this.ombrellos, '__v')
    //   this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
    //   this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
    //   this.editombrid = false
    //   // this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
    //   if (this.ombrellos.free) {
    //     console.log(this.ombrellos.guests[this.ombrellos.guestnr] + ' is free so i am not updating guest data')
    //     // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
    //   } else {
    //     this.ombrellos.guests[this.ombrellos.guestnr] = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
    //   }
    //   this.ombrellos.guest = ''
    //   this.ombrellos.room = ''
    //   this.ombrellos.arrival = ''
    //   this.ombrellos.departure = ''
    //   this.ombrellos.guestsinday = []
    //   this.ombrellos.free = true
    //   console.log('ombrello update: ', this.ombrellos)
    //   this.$http
    //     .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       this.$modal.hide('hello-world')
    //       this.getOmbrelli()
    //     }, (error) => {
    //       console.log(error)
    //       this.$notify({
    //         group: 'foo',
    //         title: 'Error loading Data',
    //         text: 'I´ll fix it in a few',
    //         type: 'warning',
    //         duration: 500
    //       })
    //     })
    // },
    moveombrello: function moveombrello(old, newo) {
      var _this6 = this;

      console.log(old, newo);
      // this.ombrellos = old
      // this.closeombrello()
      // old._id = newo
      // old.ombrid = ombrid
      // console.log(this.ombrellos)
      // this.ombrellos = newo
      this.$http.post(host + '/api/moveombrello', { old: old, newo: newo }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this6.dragging = null;
        _this6.getOmbrelli();
      }, function (error) {
        console.log(error);
        _this6.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    closeombrello: function closeombrello(index) {
      var _this7 = this;

      console.log(this.ombrellos.guests, index);
      this.ombrellos.guests.splice(index, 1);
      console.log('updated: ', this.ombrellos.guests);
      this.ombrellos.guest = '';
      this.ombrellos.room = '';
      this.ombrellos.arrival = '';
      this.ombrellos.note = '';
      this.ombrellos.departure = '';
      this.ombrellos.guestsinday = [];
      this.ombrellos.free = true;
      this.$http.post(host + '/ombrelloni/close', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this7.$modal.hide('hello-world');
        _this7.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },

    addombrell: function addombrell() {
      var _this8 = this;

      console.log(this.addombrello, this.hotelid);
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/ombrelloni/add', { ombrid: 'pool', hotelid: this.hotelid, location: this.location }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this8.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },
    editguest: function editguest(index) {
      console.log(index.ombrid, index.edit);
      index.edit = true;
      // Vue.set(this.ombrelli[index], 'edit', true)
    },
    saveEdit: function saveEdit(index, guest) {
      // save your changes
      // this.toggleEdit(index, guest)
      console.log(index, guest);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.ombrelli[index], 'guest', guest);
    },
    getOmbrelli: function getOmbrelli() {
      var _this9 = this;

      // console.log(localStorage.access_token)
      // this.$i18n.locale = 'en'
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized/richards',
      // .get('http://localhost:8000/authorized/' + this.$route.params.hotel,
      // .post(host + '/ombrelloni', { userid: localStorage.userid },
      .post(host + '/ombrelloni/canvas', { hotelid: this.$route.params.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data.body);
        if (data.body.hotels === null) {
          _this9.$router.push('/hotel');
        }
        _this9.hotelid = data.body.hotels._id;
        _this9.hotel = data.body.hotels;
        if (data.body.hotels.chairs === undefined) {
          _this9.hotel.chairs = 1;
        }
        if (data.body.hotels.beds === undefined) {
          _this9.hotel.beds = 1;
        }
        _this9.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', 284px);';
        // console.log('hotel: ' + this.hotelid)
        // console.log(data)
        // this.ombrelli = data.body.ombrells
        _this9.ombrelli = [];
        data.body.ombrells.forEach(function (ombrello, indexo) {
          // console.log('ombrello: ', ombrello)
          _this9.ombrelli.push(ombrello);
          ombrello.guests.forEach(function (guest, index) {
            console.log('guest: ', guest);
            // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
            if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this9.today).isBetween(guest.arrival, guest.departure, null, _this9.hotel.singledaybooking ? '[]' : '[)')) {
              // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
              console.log(ombrello.ombrid + ' is occupied between ' + guest.arrival + ' and ' + guest.departure);
              _this9.ombrelli[indexo].guest = guest.name;
              _this9.ombrelli[indexo].room = guest.room;
              _this9.ombrelli[indexo].arrival = guest.arrival;
              _this9.ombrelli[indexo].departure = guest.departure;
              _this9.ombrelli[indexo].free = false;
              _this9.ombrelli[indexo].note = guest.note;
              _this9.ombrelli[indexo].guestnr = index;
              if (guest.passid) {
                _this9.ombrelli[indexo].passid = guest.passid;
              }
              if (!guest.items) {
                console.log('no items');
                _this9.ombrelli[indexo].items = _this9.hotel.items;
              } else {
                console.log(guest.items);
                _this9.ombrelli[indexo].items = guest.items;
              }
              _this9.ombrelli[indexo].guestsinday.push(guest);
            } else {}
          });
        });
        _this9.getOverview();
        _this9.loading = false;
        _this9.$notify({
          group: 'foo',
          title: 'Hoteldata loaded',
          text: 'You are good to go',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
        _this9.$router.replace('/');
      });
    },
    addchair: function addchair(index, nr, chair, hotel) {
      var _this10 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addchair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this10.ombrelli[index], 'chairs', newchairs);
        _this10.$notify({
          group: 'foo',
          title: 'Chair added',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
      });
    },
    removechair: function removechair(index, nr, chair, hotel) {
      var _this11 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removechair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this11.ombrelli[index], 'chairs', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    addbed: function addbed(index, nr, chair, hotel) {
      var _this12 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addbed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this12.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    removebed: function removebed(index, nr, chair, hotel) {
      var _this13 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removebed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this13.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    changeguest: function changeguest(index, chair, guest) {
      console.log(this.ombrelli);
      console.log(index, chair, guest);
      // var newchairs = nr - 1
      // this.$http
      //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
      //   {
      //     headers: {
      //       'Authorization': 'Bearer ' + localStorage.jwt
      //     }
      //   },
      //   ).then((data) => {
      //     console.log(data)
      //     // this.loading = false
      //     Vue.set(this.ombrelli[index], 'beds', newchairs)
      //   }, (error) => {
      //     console.log(error)
      //   })
    }
  },
  beforeMount: function beforeMount() {
    this.getOmbrelli();
  },

  computed: {
    hotelgrid: function hotelgrid() {
      // `this` points to the vm instance
      return this.hotel.cols * this.hotel.rows;
    },
    userLastCount: function userLastCount() {
      console.log(this.ombrells);
    },
    filteredArrivals: function filteredArrivals() {
      var _this14 = this;

      console.log('filteredArrivals');
      return this.overview.arrivals.filter(function (post) {
        var arrivals = post.guest.name.toLowerCase().includes(_this14.query.toLowerCase());
        var arrivalsroom = post.guest.room.toLowerCase().includes(_this14.query.toLowerCase());
        console.log(arrivals);
        if (arrivals) {
          return arrivals;
        } else {
          return arrivalsroom;
        }
      });
    },
    filteredDepartures: function filteredDepartures() {
      var _this15 = this;

      return this.overview.departures.filter(function (post) {
        var departures = post.guest.name.toLowerCase().includes(_this15.query.toLowerCase());
        var departuresroom = post.guest.room.toLowerCase().includes(_this15.query.toLowerCase());
        if (departures) {
          return departures;
        } else {
          return departuresroom;
        }
      });
    },
    filteredStays: function filteredStays() {
      var _this16 = this;

      return this.overview.stays.filter(function (post) {
        var stays = post.guest.name.toLowerCase().includes(_this16.query.toLowerCase());
        var staysroom = post.guest.room.toLowerCase().includes(_this16.query.toLowerCase());
        if (stays) {
          return stays;
        } else {
          return staysroom;
        }
      });
    },
    windowWidth: function windowWidth() {
      if (this.ombrelli.length === 0) return;
      var highest = this.ombrelli.reduce(function (a, b) {
        return Number(a.x) > Number(b.x) ? a : b;
      });
      console.log('width: ', highest.x + 500, 'client: ', this.$refs.canvas.clientWidth);
      if (highest.x + 500 < this.$refs.canvas.clientWidth) {
        return this.$refs.canvas.clientWidth;
      } else {
        return highest.x + 500;
      }
    },
    windowHeight: function windowHeight() {
      if (this.ombrelli.length === 0) return;
      var highest = this.ombrelli.reduce(function (a, b) {
        return Number(a.y) > Number(b.y) ? a : b;
      });
      console.log('height: ', highest.y + 500, 'client: ', this.$refs.canvas.clientHeight);
      // return highest.y + 500
      if (highest.y + 500 < this.$refs.canvas.clientHeight) {
        return this.$refs.canvas.clientHeight;
      } else {
        return highest.y + 500;
      }
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_range__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_range__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_de__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_it__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Navbar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_drag_drop__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_drag_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__simonwep_selection_js__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__simonwep_selection_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__simonwep_selection_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectionoptions__ = __webpack_require__(322);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'







var moment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_4_moment___default.a);



 // import options for selection.js
// const selection = Selection.create(options)
// import EmbeddedSlack from 'embedded-slack'
// const chat = new EmbeddedSlack({
//   containerId: 'embedded-slack',
//   channel: 'C03M1FH6Y',
//   token: 'xoxp-3715527188-3715527214-346873012933-85307408b261ae33e2a178e9a2c4914c'
// })
var host = "https://dexter.node.systems:44537";
// var sockethost = process.env.ROOT_SOCKET
// var host = 'http://drop3.drophost.it:44534'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ombrelli',
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      loading: true,
      nogrid: false,
      firstreset: false,
      grid: {
        direction: '',
        letter: true,
        number: true,
        firststep: false,
        active: 0
      },
      state1: '',
      setgrid: false,
      langs: [{
        lang: 'it'
      }, {
        lang: 'de'
      }],
      hotel: '',
      secret: '',
      updateseason: false,
      newseasons: [],
      // pregrid: '',
      newseason: '',
      ombrelli: [],
      newombrelli: [],
      style: '',
      rangestyle: '',
      hotelid: '',
      ombrellos: {
        cashable: true,
        visible: true
      },
      addombrello: {
        ombrid: ''
      },
      bulkedit: false,
      overview: {
        arrivals: [],
        departures: []
      },
      date: ['2016-10-16', '2024-10-05'],
      today: moment().format('YYYY-MM-DD'),
      lang: 'it',
      range: {
        startDate: moment(),
        endDate: moment().add(7, 'days')
        // startDate: '2019-04-03',
        // endDate: '2019-04-10'
      },
      rangepicker: [],
      rangeviewdata: '',
      // disabledRange: {
      //   startDate: moment(),
      //   endDate: moment().add(9, 'days')
      // },
      disabledDates: [],
      datePickerOptions: {
        firstDayOfWeek: 1
      },
      firstDayOfWeek: 1,
      editombrid: false,
      dragging: null,
      lock: null,
      location: 'beach',
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      letters: {
        first: 'A',
        last: '',
        act: 0,
        row: 1
      },
      numbers: {
        first: 1,
        last: 0,
        act: 0
      },
      selectedOmbrellos: [],
      rules: {
        name: [{ required: true, message: 'prego inserisci un nome per la stagione', trigger: 'blur' }]
      }
    };
  },

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date___default.a,
    Circle4: __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__["b" /* Circle4 */],
    DateRange: __WEBPACK_IMPORTED_MODULE_3_vue_date_range__["DateRange"],
    'Navbar': __WEBPACK_IMPORTED_MODULE_8__components_Navbar___default.a,
    Drag: __WEBPACK_IMPORTED_MODULE_9_vue_drag_drop__["Drag"],
    Drop: __WEBPACK_IMPORTED_MODULE_9_vue_drag_drop__["Drop"]
    // EmbeddedSlack
    // chat
  },
  sockets: {
    connect: function connect() {
      console.log('socket connected');
    },
    stream: function stream(val) {
      // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      // console.log(val.hotelid)
      if (val.hotelid === this.hotelid) {
        console.log('an umbrella was updated');
        this.getOmbrelli();
      }
    },
    disconnect: function disconnect() {
      console.log('socket error');
      // this.$notify({
      //   group: 'foo',
      //   title: 'Error loading Data',
      //   text: 'I´ll fix it in a few',
      //   type: 'warning',
      //   duration: 5000
      // })
    }
  },
  methods: {
    editseason: function editseason(season, index) {
      this.updateseason = true;
      this.newseason = season;
      console.log(season);
    },
    enableSelection: function enableSelection() {
      this.selection = __WEBPACK_IMPORTED_MODULE_10__simonwep_selection_js__["create"](__WEBPACK_IMPORTED_MODULE_11__selectionoptions__["a" /* default */]);
      this.newseasons = [];
      // Selection.create(options)
      // selection()
      this.bulkedit = true;
      // this.newseasons = this.hotel.seasons
      // this.newseasons = Object.assign(this.hotel.seasons, true)
      this.newseasons = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.hotel.seasons));
      // this.newseasons = Array.from(this.hotel.seasons).map(m => m)
      // this.newseasons = Array.from(this.hotel.seasons)
      // this.newseasons = this.hotel.seasons.slice(0)
      // this.hotel.seasons.forEach((season, index) => {
      //   console.log(index, season)
      //   this.newseasons.push(Vue.util.extend({}, season))
      //   // this.newseasons[index] = season
      //   // Vue.set(this.newseasons[index], {}, season)
      // })
      this.$notify.success({
        title: 'Multiedit abilitato',
        message: 'Adesso puoi selezionare multipli ombrelloni con il tuo mouse, cosi come lo fai gia sul tuo device.',
        offset: 100
      });
      // console.log(this.newseasons)
    },
    disableSelection: function disableSelection() {
      this.selection.disable();
    },
    destroySelection: function destroySelection() {
      var items = this.$el.querySelectorAll('.selected');
      items.forEach(function (guest, indexo) {
        guest.classList.remove('selected');
      });
      this.selection.clearSelection();
      this.selection.destroy();
      this.bulkedit = false;
    },
    beforeClose: function beforeClose() {
      this.selection.enable();
      this.newseason = '';
      this.updateseason = false;
    },
    getelements: function getelements() {
      var _this = this;

      this.selectedOmbrellos = [];
      // console.log(this.$el.querySelectorAll('.selected'))
      var items = this.$el.querySelectorAll('.selected');
      items.forEach(function (guest, indexo) {
        // console.log(guest.dataset.item, guest.dataset.id)
        _this.selectedOmbrellos.push({ ombrid: guest.dataset.item, id: guest.dataset.id });
      });
    },
    changeGrid: function changeGrid() {
      this.resetGrid();
      this.firstreset = true;
    },
    resetGrid: function resetGrid() {
      console.log('resetGrid');
      // this.ombrelli = []
      var first = this.ombrelli[0].ombrid.match(/[a-zA-Z]+|[0-9]+/g);
      console.log(first);
      this.letters.first = first[0];
      this.numbers.first = first[1];
      this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
      this.letters.row = 1;
      this.numbers.act = this.numbers.first;
      if (this.letters.first.length === 0 || this.hotel.gridtype === 'empty') {
        this.newombrelli = [];
        this.numbers.first = first[0];
        this.numbers.act = first[0];
        this.setemptyGrid();
      } else {
        this.newombrelli = [];
        this.setGrid();
      }
    },
    setemptyGrid: function setemptyGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      // this.hotel.gridtype = 'empty'
      console.log('newombrelli length', this.newombrelli.length + 1, 'numbers act: ', this.numbers.act);
      if (this.newombrelli.length === grid) {
        console.log('done');
        this.compareGrid();
      } else {
        this.newombrelli.push({ ombrid: parseInt(this.numbers.act), free: true });
        this.numbers.act++;
        this.setemptyGrid();
      }
    },
    compareGrid: function compareGrid() {
      var _this2 = this;

      console.log('compare now');
      // this.ombrelli.filter(post => {
      //   this.newombrelli.filter(newpost => {
      //     if (post.ombrid.includes(newpost.ombrid)) {
      //       console.log(post.ombrid + ' already there')
      //     } else {
      //       // this.newombrelli.push({ombrid: act + this.numbers.act, free: true})
      //     }
      //   })
      // })
      if (this.hotel.gridtype === 'empty') {
        this.newombrelli.forEach(function (ombrello, indexo) {
          _this2.ombrelli.forEach(function (ombrella, index) {
            if (ombrello.ombrid.toString() === ombrella.ombrid) {
              console.log(ombrella.ombrid + ' already there: ', indexo);
              _this2.newombrelli[indexo] = ombrella;
            } else {
              // console.log(ombrella.ombrid + ' is a new one')
            }
          });
        });
      } else {
        this.newombrelli.forEach(function (ombrello, indexo) {
          _this2.ombrelli.forEach(function (ombrella, index) {
            if (ombrello.ombrid === ombrella.ombrid) {
              console.log(ombrella.ombrid + ' already there: ', indexo);
              _this2.newombrelli[indexo] = ombrella;
            } else {
              // console.log(ombrella.ombrid + ' is a new one')
            }
          });
        });
      }
    },
    setGrid: function setGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      // console.log(this.letters.first)
      console.log(grid);
      if (this.letters.act === this.alphabet.length) {
        this.letters.act = 0;
      }
      var act = this.alphabet[this.letters.act].toUpperCase();
      // console.log('act: ', act, this.numbers.act)
      if (this.newombrelli.length === grid) {
        console.log('done');
        this.compareGrid();
      } else {
        // console.log('not done')
        // this.ombrelli.filter(post => {
        //   // var stays = post.ombrid.toLowerCase().includes((act + this.numbers.act).toLowerCase())
        //   // console.log((act + this.numbers.act), post.ombrid.toLowerCase().includes((act + this.numbers.act).toLowerCase()))
        //   if (post.ombrid.includes((act + this.numbers.act))) {
        //     console.log((act + this.numbers.act) + ' already there')
        //     this.newombrelli.push(post)
        //   } else {
        //     // this.newombrelli.push({ombrid: act + this.numbers.act, free: true})
        //   }
        // })
        // this.ombrelli.find(function (omg) {
        //   console.log(omg === (act + this.numbers.act))
        // })
        // this.ombrelli.forEach((ombrello, indexo) => {
        //   if (ombrello.ombrid === (act + this.numbers.act)) {
        //     console.log((act + this.numbers.act) + ' already there')
        //     this.newombrelli.push(ombrello)
        //   } else {
        //     // this.newombrelli.push({ombrid: act + this.numbers.act, free: true})
        //   }
        // })
        this.newombrelli.push({ ombrid: act + this.numbers.act, free: true });
        // console.log('nr: ', act + this.numbers.act)
        if (this.hotel.gridtype === 'left') {
          this.numbers.act++;
        } else {
          this.letters.act++;
        }
        if (this.newombrelli.length === this.hotel.cols * this.letters.row) {
          if (this.hotel.gridtype === 'left') {
            this.numbers.act = this.numbers.first;
            this.letters.row++;
            this.letters.act++;
          } else {
            this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
            this.numbers.act++;
            this.letters.row++;
          }
          console.log('end of row', this.letters.row - 1, this.numbers.act);
        } else {}
        this.setGrid();
      }
    },
    show: function show(modal, ombrello) {
      this.getelements();
      console.log(this.selectedOmbrellos.length);
      if (this.selectedOmbrellos.length === 0) {
        this.ombrellos = ombrello;
      } else {}
      this.$modal.show(modal);
    },
    hide: function hide(modal) {
      this.$modal.hide(modal);
    },
    settings: function settings() {
      this.$modal.show('settings');
    },
    saveBulk: function saveBulk() {
      var _this3 = this;

      console.log(this.ombrellos);
      console.log(this.selectedOmbrellos);
      this.$http.post(host + '/api/savebulkombrelloni', { ombrellos: this.ombrellos, selectedOmbrellos: this.selectedOmbrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this3.$modal.hide('bulkombrellosettings');
        _this3.getOmbrelli();
        _this3.$notify.success({
          title: _this3.selectedOmbrellos.length + ' Ombrelloni salvati',
          offset: 100
        });
      }, function (error) {
        console.log(error);
        _this3.$notify.error({
          title: 'Si é verificato un errore, prego riprovare',
          offset: 100
        });
      });
    },
    bulkUpdateseason: function bulkUpdateseason() {
      var _this4 = this;

      console.log(this.ombrellos);
      console.log(this.selectedOmbrellos);
      console.log(this.hotel.seasons);
      console.log(this.newseasons);
      this.$http.post(host + '/api/bulkupdateseason', { oldseasons: this.hotel.seasons, newseasons: this.newseasons, selectedOmbrellos: this.selectedOmbrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this4.$modal.hide('bulkombrellosettings');
        _this4.getOmbrelli();
        _this4.newseason = '';
        _this4.updateseason = false;
        _this4.$notify.success({
          title: _this4.selectedOmbrellos.length + ' Ombrelloni salvati',
          offset: 100
        });
      }, function (error) {
        console.log(error);
        _this4.$notify.error({
          title: 'Si é verificato un errore, prego riprovare',
          offset: 100
        });
      });
    },

    saveGrid: function saveGrid() {
      var _this5 = this;

      // console.log(this.ombrelli)
      this.loading = true;
      if (this.newombrelli.length > 0) {
        console.log('new ombrelli');
        this.$http.post(host + '/api/resetgrid', { hotel: this.hotel, ombrelli: this.newombrelli }, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.jwt
          }
        }).then(function (data) {
          console.log(data);
          _this5.firstreset = false;
          _this5.newombrelli = [];
          _this5.getOmbrelli();
          _this5.loading = false;
          _this5.nogrid = false;
        }, function (error) {
          console.log(error);
          _this5.$notify.error({
            title: 'Si é verificato un errore, prego riprovare',
            offset: 100
          });
        });
      } else {
        console.log('old ombrelli');
        this.$http.post(host + '/api/resetgrid', { hotel: this.hotel, ombrelli: this.ombrelli }, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.jwt
          }
        }).then(function (data) {
          console.log(data);
          _this5.firstreset = false;
          _this5.ombrelli = [];
          _this5.getOmbrelli();
          _this5.loading = false;
          _this5.nogrid = false;
        }, function (error) {
          console.log(error);
          _this5.$notify.error({
            title: 'Si é verificato un errore, prego riprovare',
            offset: 100
          });
        });
      }
    },
    getOmbrelli: function getOmbrelli() {
      var _this6 = this;

      this.$http.post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log('hotel: ', data.body.ombrells);
        _this6.hotelid = data.body.hotels._id;
        _this6.hotel = data.body.hotels;
        moment.locale(data.body.hotels.lang);
        if (data.body.hotels.chairs === undefined) {
          _this6.hotel.chairs = 1;
        }
        if (data.body.hotels.beds === undefined) {
          _this6.hotel.beds = 1;
        }
        _this6.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);';
        // console.log('hotel: ' + this.hotelid)
        // console.log(data)
        _this6.ombrelli = data.body.ombrells;
        // console.log(this.today)
        if (!_this6.hotel.firststep && data.body.ombrells <= 0) {
          _this6.nogrid = true;
          // this.setGrid()
        }
        _this6.loading = false;
        // this.$notify.error({
        //   title: 'Si é verificato un errore, prego riprovare',
        //   offset: 100
        // })
      }, function (error) {
        console.log(error);
        _this6.$router.replace('/');
      });
    }
    // getOverview () {
    //   this.overview.arrivals = []
    //   this.overview.departures = []
    //   this.ombrelli.forEach((ombrello, indexo) => {
    //     // console.log('ombrello: ', ombrello)
    //     // this.ombrelli.push(ombrello)
    //     ombrello.guests.forEach((guest, index) => {
    //       console.log('guest: ', guest)
    //       // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
    //       if (moment(this.today).isSame(guest.arrival)) {
    //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
    //         console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival)
    //         this.overview.arrivals.push({guest: guest, ombrid: ombrello.ombrid})
    //       } else {
    //         // console.log(ombrello.ombrid + ' is free on ' + this.today)
    //         // this.ombrelli[indexo].free = true
    //       }
    //       if (moment(this.today).isSame(guest.departure)) {
    //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
    //         console.log(ombrello.ombrid + ' is starting today: ' + guest.departure)
    //         this.overview.departures.push({guest: guest, ombrid: ombrello.ombrid})
    //       } else {
    //         // console.log(ombrello.ombrid + ' is free on ' + this.today)
    //         // this.ombrelli[indexo].free = true
    //       }
    //     })
    //   })
    // },
    // addchair (index, nr, chair, hotel) {
    //   console.log(this.ombrelli)
    //   console.log(index, chair, hotel)
    //   var newchairs = nr + 1
    //   this.$http
    //     .post(host + '/api/addchair/' + chair, {chairid: chair, hotelid: hotel},
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       // this.loading = false
    //       Vue.set(this.ombrelli[index], 'chairs', newchairs)
    //       // this.$notify({
    //       //   group: 'foo',
    //       //   title: 'Chair added',
    //       //   type: 'success',
    //       //   duration: 500
    //       // })
    //     }, (error) => {
    //       console.log(error)
    //     })
    // },
    // removechair (index, nr, chair, hotel) {
    //   console.log(this.ombrelli)
    //   console.log(index, chair, hotel)
    //   var newchairs = nr - 1
    //   this.$http
    //     .post(host + '/api/removechair/' + chair, {chairid: chair, hotelid: hotel},
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       // this.loading = false
    //       Vue.set(this.ombrelli[index], 'chairs', newchairs)
    //     }, (error) => {
    //       console.log(error)
    //     })
    // },
    // addbed (index, nr, chair, hotel) {
    //   console.log(this.ombrelli)
    //   console.log(index, chair, hotel)
    //   var newchairs = nr + 1
    //   this.$http
    //     .post(host + '/api/addbed/' + chair, {chairid: chair, hotelid: hotel},
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       // this.loading = false
    //       Vue.set(this.ombrelli[index], 'beds', newchairs)
    //     }, (error) => {
    //       console.log(error)
    //     })
    // },
    // removebed (index, nr, chair, hotel) {
    //   console.log(this.ombrelli)
    //   console.log(index, chair, hotel)
    //   var newchairs = nr - 1
    //   this.$http
    //     .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       // this.loading = false
    //       Vue.set(this.ombrelli[index], 'beds', newchairs)
    //     }, (error) => {
    //       console.log(error)
    //     })
    // }

  },
  beforeMount: function beforeMount() {
    this.getOmbrelli();
    // this.letters.act = this.alphabet.indexOf(this.letters.first)
  },

  mounted: function mounted() {
    // Selection.create(options)
    // this.getOverview()
    // moment.locale(this.hotel.lang)
    // console.log('hotel: ', this.hotel)
  },
  beforeDestroy: function beforeDestroy() {
    this.selection.destroy();
  },

  computed: {
    // newseasons: {
    //   get () {
    //     // console.log(this.range)
    //     return Object.assign({}, this.hotel.seasons)
    //     // return [moment(this.range.startDate).format('YYYY-MM-DD'), moment(this.range.endDate).format('YYYY-MM-DD')]
    //   },
    //   set (newValue) {
    //     console.log(newValue)
    //   }
    // },
    hotelgrid: function hotelgrid() {
      // `this` points to the vm instance
      this.numbers.last = this.hotel.cols * this.hotel.rows;
      return this.hotel.cols * this.hotel.rows;
    },
    gridstyle: function gridstyle() {
      return 'grid-template-columns: repeat(' + this.hotel.cols + ', 1fr); grid-template-rows: repeat(' + this.hotel.rows + ', auto);';
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var host = "https://dexter.node.systems:44537";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      loading: false,
      formel: {
        email: '',
        password: ''
      },
      rules: {
        password: [{ required: true, message: 'prego inserisci una password', trigger: 'blur' }, { min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }]
      },
      error: {
        state: false,
        message: ''
      },
      success: {
        state: false,
        message: ''
      }
    };
  },

  methods: {
    forgot: function forgot(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('login');
          _this.loading = true;
          setTimeout(function () {
            _this.loading = false;
          }, 2000);
          _this.error.state = false;
          _this.$http.post(host + '/resetpassword', { email: _this.formel.email.toLowerCase().trim(), password: _this.formel.password }).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/');
            _this.loading = false;
          }, function (error) {
            console.log(error);
            // this.loading = false
            setTimeout(function () {
              _this.loading = false;
            }, 1000);
            _this.error.state = true;
            _this.error.message = error.body.error;
          });
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },
    getHotel: function getHotel() {
      var _this2 = this;

      this.$http.post(host + '/checkreset', { token: this.$route.params.token }).then(function (data) {
        console.log(data);
        _this2.formel.email = data.body.email;
        _this2.loading = false;
      }, function (error) {
        console.log(error);
        // router.replace('/')
        _this2.loading = false;
        _this2.error.state = true;
        _this2.error.message = error.body.error;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getHotel();
  },

  mounted: function mounted() {
    // this.$refs.emailinput.focus()
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_date_range__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_date_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_date_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_range__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_de__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_it__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Navbar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var moment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_6_moment___default.a);


var host = "https://dexter.node.systems:44537";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ombrelli',
  props: ['auth', 'authenticated', 'hotel', 'ombrellos', 'disabledDates', 'range'],
  data: function data() {
    return {
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      letters: {
        first: 'A',
        last: '',
        act: 0,
        row: 1
      },
      value6: '',
      dialogVisibleOmbrello: false,
      sendPassForm: false,
      modal: {
        width: '70%',
        height: 'auto'
      },
      guest: {
        email: ''
      },
      beachitem: {
        name: '',
        icon: ''
      },
      addbeachitem: false,
      numbers: {
        first: 1,
        last: 0,
        act: 0
      },
      query: '',
      filtered: '',
      loading: false,
      nogrid: false,
      grid: {
        direction: '',
        letter: true,
        number: true,
        firststep: false,
        active: 0
      },
      state1: '',
      langs: [{
        lang: 'it'
      }, {
        lang: 'de'
      }],
      // hotel: '',
      secret: '',
      // pregrid: '',
      ombrelli: [],
      // hellorange: this.range,
      // range: {
      //   startDate: moment(),
      //   endDate: moment().add(1, 'days')
      // },
      style: '',
      rangestyle: '',
      hotelid: '',
      addombrello: {
        ombrid: ''
      },
      overview: {
        arrivals: [],
        departures: [],
        stays: []
      },
      date: ['2016-10-16', '2024-10-05'],
      today: moment().format('YYYY-MM-DD'),
      lang: 'it',
      rangepicker: [],
      rangeviewdata: '',
      // disabledRange: {
      //   startDate: moment(),
      //   endDate: moment().add(9, 'days')
      // },
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledFunc,
        onPick: this.onChangedate
      },
      firstDayOfWeek: 1,
      editombrid: false,
      dragging: null,
      lock: null,
      location: 'beach',
      rangeview: false
    };
  },

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_4_vue_date___default.a,
    Circle4: __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__["b" /* Circle4 */],
    DateRange: __WEBPACK_IMPORTED_MODULE_5_vue_date_range__["DateRange"],
    'Navbar': __WEBPACK_IMPORTED_MODULE_10__components_Navbar___default.a,
    Drag: __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__["Drag"],
    Drop: __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__["Drop"]
    // EmbeddedSlack
    // chat
  },
  sockets: {
    connect: function connect() {
      // console.log('socket connected')
    },
    stream: function stream(val) {
      // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      // console.log(val.hotelid)
      if (val.hotelid === this.hotelid) {
        // console.log('an umbrella was updated')
        // this.getOmbrelli()
      }
    },
    disconnect: function disconnect() {
      // console.log('socket error')
      // this.$notify({
      //   group: 'foo',
      //   title: 'Error loading Data',
      //   text: 'I´ll fix it in a few',
      //   type: 'warning',
      //   duration: 5000
      // })
    }
  },
  methods: {
    dayClassFunc: function dayClassFunc(dayMoment) {
      // console.log(dayMoment, moment(this.range.startDate._d).format('YYYY-MM-DD'))
      // this.disabledDates.forEach((date, index) => {
      //   if (true) {}
      // })
      // if (dayMoment.format('YYYY-MM-DD') === moment(this.range.startDate._d).format('YYYY-MM-DD')) {
      //   return ['today', 'important']
      // }
      if (this.disabledDates.includes(dayMoment.format('YYYY-MM-DD'))) {
        return ['ayou-day-cell', 'passive'];
      }
    },
    emitVal: function emitVal() {
      var date = this.date;
      // to support three ways to get value

      this.$emit('update:syncDate', date);
      this.$emit('input', date);
      this.$emit('change', date);
    },
    handleDayClick: function handleDayClick(day) {
      this.date = day.dayMoment;
      this.emitVal();
    },
    getViewport: function getViewport() {
      // console.log(this.$mq)
      if (this.$mq === 'sm') {
        this.modal.width = '100%';
      } else {
        this.modal.width = '70%';
      }
    },
    updatebeachitems: function updatebeachitems() {
      // console.log('add beachitem')
    },
    deletebeachitem: function deletebeachitem(index) {
      // console.log(index)
      this.hotel.items.splice(index, 1);
    },
    stepHandler: function stepHandler(e, i) {
      // console.log(e, i)
      this.grid.active = i;
    },
    nextStep: function nextStep() {
      this.grid.active++;
    },
    previousStep: function previousStep() {
      if (this.grid.active === 2) {
        this.ombrelli = [];
        this.grid.direction = '';
        this.grid.active = 0;
      } else {
        this.grid.active--;
      }
    },
    filter: function filter(query) {
      var _this = this;

      // console.log(this.query, this.overview.arrivals.filter(item => item.ombrid === this.query))
      this.filtered = this.overview.arrivals.filter(function (item) {
        return item.guest.name === _this.query;
      });
    },

    // querySearch (queryString, cb) {
    //   var links = this.linkst
    //   var results = queryString ? links.filter(this.createFilter(queryString)) : links
    //   // call callback function to return suggestions
    //   console.log(results)
    //   cb(results)
    // },
    // createFilter (queryString) {
    //   return (link) => {
    //     // console.log(link, queryString)
    //     return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
    //   }
    // },
    handleSelect: function handleSelect(item) {
      // console.log(item)
    },
    disabledFunc: function disabledFunc(dayMoment) {
      // console.log(dayMoment)
      // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
      // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
      if (this.disabledDates.includes(moment(dayMoment).format('YYYY-MM-DD'))) {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return true;
      } else {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return false;
      }
    },

    // preCheckDate () {
    //   // console.log('ombrellos: ', this.ombrellos)
    //   // console.log(date)
    //   // console.log('preCheckDate')
    //   this.disabledDates = []
    //   this.ombrellos.guests.forEach((guest, indexo) => {
    //     // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
    //     // console.log('guest: ', guest.name, 'ombrello guest: ', this.ombrellos.guest)
    //     if (guest.name !== this.ombrellos.guest) {
    //       var start = moment(guest.arrival, 'YYYY-MM-DD').add('days', 1)
    //       var end = moment(guest.departure, 'YYYY-MM-DD')
    //       // console.log('guest name: ', guest.name, 'start: ', start, 'end: ', end)
    //       var range = moment.range(start, end)
    //       var dates = Array.from(range.by('days', { excludeStart: true, excludeEnd: true })).map(m => m.format('YYYY-MM-DD'))
    //       // this.disabledDates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
    //       Array.prototype.push.apply(this.disabledDates, dates)
    //       // console.log('guest: ', guest.name, dates)
    //     }
    //   })
    // },
    // checkDate (date) {
    // console.log(moment(date).format('YYYY-MM-DD'))
    // date = moment(date).format('YYYY-MM-DD')
    // return moment(date).isBetween(moment(this.ombrellos.arrival), moment(this.ombrellos.departure))
    // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
    // if (moment(date).isBetween(moment('2019-04-12'), moment('2019-04-14'))) {
    //   return true
    // } else {
    //   return false
    // }
    // this.ombrellos.guests.forEach(function (guest, indexo) {
    //   console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
    //   if (moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12'))) {
    //     return true
    //   } else {
    //     return false
    //   }
    // })
    // },
    handleDragover: function handleDragover(group, data, event) {
      // console.log(data)
      // console.log(group.ombrid)
      // console.log(event)
      if (!group.free) {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleDrop: function handleDrop(group, data, key) {
      // console.log(group.ombrello.ombrid, data.target.id)
      this.moveombrello(group.ombrello, data.target.id);
      // alert(`You dropped with data: ${JSON.stringify(data)}`)
    },
    changeombrid: function changeombrid() {
      // console.log('changeombrid')
      this.editombrid = true;
    },
    onChangedate: function onChangedate(range) {
      // this.range = range
      // console.log(range)
      this.$emit('changeOmbrellodate', range);
      // console.log('hello-world onChange: ', moment(range.endDate._d))
    },

    // setRange (p) {
    //   if (typeof p === 'number') {
    //     console.log(p)
    //     // this.$emit()
    //     this.range = {
    //       startDate: moment().add(p, 'days'),
    //       endDate: moment()
    //     }
    //   }
    // },
    // show (ombrello) {
    //   console.log(ombrello.arrival)
    //   this.ombrellos = ombrello
    //   if (ombrello.free) {
    //     this.ombrellos.chairs = this.hotel.chairs
    //     this.ombrellos.beds = this.hotel.beds
    //   }
    //   // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
    //   this.date[0] = ombrello.arrival
    //   this.date[1] = ombrello.departure
    //   // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
    //   if (ombrello.arrival) {
    //     console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'))
    //     this.range.startDate = moment(ombrello.arrival)
    //   }
    //   if (ombrello.departure) {
    //     this.range.endDate = moment(ombrello.departure)
    //   }
    //   this.preCheckDate()
    //   this.$modal.show('hello-world')
    // },
    hide: function hide() {
      this.$modal.hide('hello-world');
    },

    // settings () {
    //   this.$modal.show('settings')
    // },
    // updatehotel: function () {
    //   this.$http
    //     .post(host + '/api/updatehotel', { hotel: this.hotel },
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       // this.ombrelli = data.body.ombrells
    //       console.log(data)
    //       this.$modal.hide('settings')
    //       // this.getOmbrelli()
    //     }, (error) => {
    //       console.log(error)
    //       this.$notify({
    //         group: 'foo',
    //         title: 'Error loading Data',
    //         text: 'I´ll fix it in a few',
    //         type: 'warning',
    //         duration: 500
    //       })
    //     })
    // },
    sendPass: function sendPass() {
      var _this2 = this;

      // console.log('pass email: ', this.guest.email)
      this.$http.post(host + '/api/pass/send', { ombrellos: this.ombrellos, hotel: this.hotel, email: this.guest.email }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this2.$notify({
          group: 'foo',
          title: 'Beachpass mandato a ' + _this2.guest.email,
          type: 'success',
          duration: 500
        });
        _this2.sendPassForm = false;
      }, function (error) {
        console.log(error);
        _this2.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    generatePass: function generatePass() {
      var _this3 = this;

      // console.log('pass: ', this.hotel)
      this.$http.post(host + '/api/generatepass', { ombrellos: this.ombrellos, hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        if (!_this3.ombrellos.passid) {
          _this3.ombrellos.passid = data.body.passid;
        } else {
          _this3.ombrellos.passid = data.body.passid;
          _this3.updateombrello();
        }
        // this.ombrellos.guestsinday[0].passid = data.body.passid
        // this.$modal.hide('hello-world')
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this3.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    updatePass: function updatePass(passid) {
      var _this4 = this;

      // console.log('passid: ', passid)
      this.$http.post(host + '/api/pass/update', { ombrellos: this.ombrellos, passid: passid }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        // this.ombrellos.passid = data.body.passid
        // this.updateombrello()
        // this.ombrellos.guestsinday[0].passid = data.body.passid
        // this.$modal.hide('hello-world')
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this4.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },

    saveOmbrello: function saveOmbrello() {
      var _this5 = this;

      console.log(this.ombrellos);
      this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD');
      if (this.hotel.singledaybooking && this.range.startDate._d === this.range.endDate._d) {
        console.log('same day');
        this.ombrellos.departure = moment(this.range.startDate._d).format('YYYY-MM-DD');
      } else {
        this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD');
      }
      // console.log(this.range['endDate'])
      this.$http.post(host + '/api/generatepass', { ombrellos: this.ombrellos, hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log('second: ', _this5.ombrellos);
        _this5.ombrellos.passid = data.body.passid;
        // this.updateombrello()
        // this.ombrellos.guestsinday[0].passid = data.body.passid
        // this.$modal.hide('hello-world')
        // this.getOmbrelli()
        _this5.$delete(_this5.ombrellos, '__v');
        // this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
        // this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
        _this5.editombrid = false;
        _this5.ombrellos.guests.push({ name: _this5.ombrellos.guest, room: _this5.ombrellos.room, arrival: _this5.ombrellos.arrival, departure: _this5.ombrellos.departure, items: _this5.ombrellos.items, note: _this5.ombrellos.note, passid: _this5.ombrellos.passid });
        _this5.ombrellos.guest = '';
        _this5.ombrellos.note = '';
        _this5.ombrellos.room = '';
        _this5.ombrellos.arrival = '';
        _this5.ombrellos.departure = '';
        // this.ombrellos.passid = ''
        _this5.ombrellos.guestsinday = [];
        _this5.ombrellos.free = true;
        // console.log('ombrello: ', this.ombrellos.ombrid, this.ombrellos.guests)
        _this5.$http.post(host + '/api/updateombrello', { ombrellos: _this5.ombrellos }, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.jwt
          }
        }).then(function (data) {
          console.log(data);
          _this5.$modal.hide('hello-world');
          // this.getOmbrelli()
        }, function (error) {
          console.log(error);
          _this5.$notify({
            group: 'foo',
            title: 'Error loading Data',
            text: 'I´ll fix it in a few',
            type: 'warning',
            duration: 500
          });
        });
      }, function (error) {
        console.log(error);
        _this5.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    updateombrello: function updateombrello() {
      var _this6 = this;

      console.log(this.ombrellos);
      // console.log(this.range['endDate'])
      var passid = this.ombrellos.passid;
      var passombrello = this.ombrellos;
      this.$delete(this.ombrellos, '__v');
      this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD');
      if (this.hotel.singledaybooking && this.range.startDate._d === this.range.endDate._d) {
        this.ombrellos.departure = moment(this.range.startDate._d).format('YYYY-MM-DD');
      } else {
        this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD');
      }
      this.editombrid = false;
      // this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
      if (this.ombrellos.free) {
        console.log(this.ombrellos.guests[this.ombrellos.guestnr] + ' is free so i am not updating guest data');
        // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
      } else {
        this.ombrellos.guests[this.ombrellos.guestnr] = { name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure, items: this.ombrellos.items, note: this.ombrellos.note, passid: this.ombrellos.passid };
      }
      // this.ombrellos.guest = ''
      // this.ombrellos.note = ''
      // this.ombrellos.room = ''
      // this.ombrellos.arrival = ''
      // this.ombrellos.departure = ''
      // this.ombrellos.passid = ''
      this.ombrellos.guestsinday = [];
      this.ombrellos.free = true;
      // console.log('ombrello update: ', this.ombrellos, passid, passombrello)
      this.$http.post(host + '/api/updateombrello', { ombrellos: this.ombrellos, passid: passid, passombrello: passombrello }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this6.$modal.hide('hello-world');
        _this6.updatePass(passid);
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this6.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },

    moveombrello: function moveombrello(old, newo) {
      var _this7 = this;

      // console.log(old, newo)
      // this.ombrellos = old
      // this.closeombrello()
      // old._id = newo
      // old.ombrid = ombrid
      // console.log(this.ombrellos)
      // this.ombrellos = newo
      this.$http.post(host + '/api/moveombrello', { old: old, newo: newo }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this7.dragging = null;
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this7.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    closeombrello: function closeombrello(index) {
      var _this8 = this;

      // console.log(this.ombrellos.guests, index)
      this.dialogVisibleOmbrello = false;
      var passid = this.ombrellos.passid;
      this.ombrellos.guests.splice(index, 1);
      // console.log('updated: ', this.ombrellos.guests)
      this.ombrellos.guest = '';
      this.ombrellos.room = '';
      this.ombrellos.arrival = '';
      this.ombrellos.departure = '';
      this.ombrellos.free = true;
      this.ombrellos.guestsinday = [];
      this.$http.post(host + '/ombrelloni/close', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this8.$modal.hide('hello-world');
        _this8.updatePass(passid);
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
      });
    },

    addombrell: function addombrell() {
      // console.log(this.addombrello, this.hotelid)
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/ombrelloni/add', { ombrid: this.addombrello.ombrid, hotelid: this.hotelid, location: this.location }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        // console.log(data)
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
      });
    },
    editguest: function editguest(index) {
      // console.log(index.ombrid, index.edit)
      index.edit = true;
      // Vue.set(this.ombrelli[index], 'edit', true)
    },
    saveEdit: function saveEdit(index, guest) {
      // save your changes
      // this.toggleEdit(index, guest)
      // console.log(index, guest)
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.ombrelli[index], 'guest', guest);
    },
    // presetGrid () {
    //   var grid = this.hotel.cols * this.hotel.rows
    //   if (this.ombrelli.length === grid) {
    //     console.log('preset grid done')
    //   } else {
    //     console.log('preset grid not yet done')
    //     if (this.numbers.first < 10) {
    //       this.pregrid = {
    //         first: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         },
    //         left: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         },
    //         up: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         }
    //       }
    //     } else {
    //       this.pregrid = {
    //         first: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         },
    //         left: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         },
    //         up: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         }
    //       }
    //     }
    //   }
    // },
    resetGrid: function resetGrid() {
      this.ombrelli = [];
      this.grid.firststep = true;
      this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
      this.letters.row = 1;
      this.numbers.act = this.numbers.first;
      this.grid.active = 2;
      if (this.letters.first.length === 0 || this.grid.direction === 'empty') {
        this.setemptyGrid();
      } else {
        this.setGrid();
      }
    },
    setemptyGrid: function setemptyGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      // console.log('ombrelli length', (this.ombrelli.length + 1), 'numbers act: ', this.numbers.act)
      if (this.ombrelli.length === grid) {
        // console.log('done')
      } else {
        if (grid > 99 && this.numbers.act <= 9) {
          // console.log('case: 1')
          this.ombrelli.push({ ombrid: '00' + parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        } else if (grid > 99 && this.numbers.act <= 99) {
          // console.log('case: 2')
          this.ombrelli.push({ ombrid: '0' + parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        } else {
          // console.log('case: 3')
          this.ombrelli.push({ ombrid: parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        }
        this.setemptyGrid();
      }
    },
    setGrid: function setGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      // console.log(this.letters.first)
      if (this.letters.act === this.alphabet.length) {
        this.letters.act = 0;
      }
      var act = this.alphabet[this.letters.act].toUpperCase();
      // console.log('act: ', act, this.numbers.act)
      if (this.ombrelli.length === grid) {
        // console.log('done')
      } else {
        // console.log('not done')
        if (this.numbers.act < 10) {
          this.ombrelli.push({ ombrid: act + '0' + this.numbers.act, free: true });
          // console.log('nr: ', act + '0' + this.numbers.act)
          if (this.grid.direction === 'left') {
            this.numbers.act++;
          } else {
            this.letters.act++;
          }
          if (this.ombrelli.length === this.hotel.cols * this.letters.row) {
            if (this.grid.direction === 'left') {
              this.numbers.act = this.numbers.first;
              this.letters.row++;
              this.letters.act++;
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
              this.numbers.act++;
              this.letters.row++;
            }
            // console.log('end of row', this.letters.row - 1, this.numbers.act)
          } else {}
          this.setGrid();
        } else {
          this.ombrelli.push({ ombrid: act + this.numbers.act, free: true });
          // console.log('nr: ', act + this.numbers.act)
          if (this.grid.direction === 'left') {
            this.numbers.act++;
          } else {
            this.letters.act++;
          }
          if (this.ombrelli.length === this.hotel.cols * this.letters.row) {
            if (this.grid.direction === 'left') {
              this.numbers.act = this.numbers.first;
              this.letters.row++;
              this.letters.act++;
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
              this.numbers.act++;
              this.letters.row++;
            }
            // console.log('end of row', this.letters.row - 1, this.numbers.act)
          } else {}
          this.setGrid();
        }
        // if (this.numbers.first < 10) {
        //   this.ombrelli.push({ombrid: act + '0' + this.numbers.first, free: true})
        //   this.letters.act = this.alphabet.indexOf(act) + 1
        //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //     this.letters.act = 0
        //     this.letters.row = this.letters.row + 1
        //   }
        //   this.setGrid()
        // } else {
        //   this.ombrelli.push({ombrid: act + this.numbers.first, free: true})
        //   this.letters.act = this.alphabet.indexOf(act) + 1
        //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //     this.letters.act = 0
        //     this.letters.row = this.letters.row + 1
        //   }
        //   this.setGrid()
        // }
      }
      // var grid = this.hotel.cols * this.hotel.rows
      // console.log(this.letters.first)
      // var act = this.alphabet[this.letters.act]
      // console.log('act: ', act)
      // if (this.ombrelli.length === grid) {
      //   console.log('done')
      // } else {
      //   console.log('not done')
      //   if (this.hotel.rows > 10 && this.letters.row < 10) {
      //     this.ombrelli.push({ombrid: act + '0' + this.letters.row, free: true})
      //     this.letters.act = this.alphabet.indexOf(act) + 1
      //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
      //       this.letters.act = 0
      //       this.letters.row = this.letters.row + 1
      //     }
      //     this.setGrid()
      //   } else {
      //     this.ombrelli.push({ombrid: act + this.letters.row, free: true})
      //     this.letters.act = this.alphabet.indexOf(act) + 1
      //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
      //       this.letters.act = 0
      //       this.letters.row = this.letters.row + 1
      //     }
      //     this.setGrid()
      //   }
      // }
    },

    // saveGrid: function () {
    //   console.log(this.ombrelli)
    //   this.$http
    //     .post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli },
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       this.getOmbrelli()
    //       this.nogrid = false
    //     }, (error) => {
    //       console.log(error)
    //       this.$notify({
    //         group: 'foo',
    //         title: 'grid saved',
    //         type: 'success',
    //         duration: 500
    //       })
    //     })
    // },
    // changeDate () {
    //   console.log(moment(this.today).format('YYYY-MM-DD'))
    //   this.today = moment(this.today).format('YYYY-MM-DD')
    //   this.getOmbrelli()
    //   this.rangeview = false
    // },
    // changeRange () {
    //   // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
    //   var start = moment(this.rangepicker[0], 'YYYY-MM-DD')
    //   var end = moment(this.rangepicker[1], 'YYYY-MM-DD')
    //   var range = moment.range(start, end)
    //   var dates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
    //   // console.log('range picker dates: ', dates)
    //   this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);'
    //   this.rangeviewdata = dates
    //   this.rangeview = true
    //   this.ombrelli.forEach((ombrello, indexo) => {
    //     // console.log('ombrello: ', ombrello)
    //     // this.ombrelli.push(ombrello)
    //     Vue.set(this.ombrelli[indexo], 'dates', [])
    //     // ombrello.guests.forEach((guest, index) => {
    //       // console.log('guest: ', guest)
    //       // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
    //     dates.forEach((date, indexd) => {
    //       this.ombrelli[indexo].dates.push({date: moment(date).format('DD/MM'), day: moment(date).format('dd'), guests: [], free: true})
    //       ombrello.guests.forEach((guest, index) => {
    //         if (moment(date).isBetween(guest.arrival, guest.departure, null, '[]')) {
    //           console.log(ombrello.ombrid + ' is occupied on ' + date)
    //           // this.ombrelli[indexo].dates.push({date: date, guest: guest})
    //           this.ombrelli[indexo].dates[indexd].guests.push(guest)
    //           this.ombrelli[indexo].dates[indexd].free = false
    //         } else {
    //           // console.log(ombrello.ombrid + ' is free on ' + this.today)
    //           console.log(ombrello.ombrid + ' is free on ' + date)
    //           // this.ombrelli[indexo].free = true
    //           // this.ombrelli[indexo].dates.push({date: date, guest: guest})
    //         }
    //       })
    //     })
    //   })
    // },
    // getOmbrelli () {
    //   this.$http
    //     .post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel },
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log('hotel: ', data.body.ombrells)
    //       // this.hotelid = data.body.hotels._id
    //       // this.hotel = data.body.hotels
    //       moment.locale(data.body.hotels.lang)
    //       if (data.body.hotels.chairs === undefined) {
    //         this.hotel.chairs = 1
    //       }
    //       if (data.body.hotels.beds === undefined) {
    //         this.hotel.beds = 1
    //       }
    //       this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);'
    //       console.log('hotel: ' + this.hotelid)
    //       console.log(data)
    //       this.ombrelli = data.body.ombrells
    //       console.log(this.today)
    //       this.ombrelli = []
    //       data.body.ombrells.forEach((ombrello, indexo) => {
    //         this.ombrelli.push(ombrello)
    //         ombrello.guests.forEach((guest, index) => {
    //           console.log('guest: ', guest)
    //           if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '[]')) {
    //             console.log(ombrello.ombrid + ' is occupied between ' + guest.arrival + ' and ' + guest.departure)
    //             this.ombrelli[indexo].guest = guest.name
    //             this.ombrelli[indexo].room = guest.room
    //             this.ombrelli[indexo].arrival = guest.arrival
    //             this.ombrelli[indexo].departure = guest.departure
    //             this.ombrelli[indexo].free = false
    //             this.ombrelli[indexo].guestnr = index
    //             this.ombrelli[indexo].guestsinday.push(guest)
    //           } else {
    //           }
    //         })
    //       })
    //       this.getOverview()
    //       if (data.body.ombrells <= 0) {
    //         this.nogrid = true
    //       }
    //       this.loading = false
    //     }, (error) => {
    //       console.log(error)
    //       this.$router.replace('/')
    //     })
    // },
    // getOverview () {
    //   this.overview.arrivals = []
    //   this.overview.departures = []
    //   this.overview.stays = []
    //   this.ombrelli.forEach((ombrello, indexo) => {
    //     // console.log('ombrello: ', ombrello)
    //     // this.ombrelli.push(ombrello)
    //     ombrello.guests.forEach((guest, index) => {
    //       console.log('guest: ', guest)
    //       // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
    //       if (moment(this.today).isSame(guest.arrival)) {
    //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
    //         console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival)
    //         this.overview.arrivals.push({guest: guest, ombrid: ombrello.ombrid})
    //       } else if (moment(this.today).isSame(guest.departure)) {
    //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
    //         console.log(ombrello.ombrid + ' is starting today: ' + guest.departure)
    //         this.overview.departures.push({guest: guest, ombrid: ombrello.ombrid})
    //       } else if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '()')) {
    //         console.log(ombrello.ombrid + ' is staying here today: ' + guest.departure)
    //         this.overview.stays.push({guest: guest, ombrid: ombrello.ombrid})
    //       }
    //     })
    //   })
    // },
    addchair: function addchair(index, nr, chair, hotel) {
      var _this9 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addchair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this9.ombrelli[index], 'chairs', newchairs);
        _this9.$notify({
          group: 'foo',
          title: 'Chair added',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
      });
    },
    removechair: function removechair(index, nr, chair, hotel) {
      var _this10 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removechair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this10.ombrelli[index], 'chairs', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    addbed: function addbed(index, nr, chair, hotel) {
      var _this11 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addbed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this11.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    removebed: function removebed(index, nr, chair, hotel) {
      var _this12 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removebed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this12.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    }
    // changeguest (index, chair, guest) {
    //   // console.log(this.ombrelli)
    //   // console.log(index, chair, guest)
    //   // var newchairs = nr - 1
    //   // this.$http
    //   //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
    //   //   {
    //   //     headers: {
    //   //       'Authorization': 'Bearer ' + localStorage.jwt
    //   //     }
    //   //   },
    //   //   ).then((data) => {
    //   //     console.log(data)
    //   //     // this.loading = false
    //   //     Vue.set(this.ombrelli[index], 'beds', newchairs)
    //   //   }, (error) => {
    //   //     console.log(error)
    //   //   })
    // }

  },
  beforeMount: function beforeMount() {
    // this.getOmbrelli()
    // this.getViewport()
    // this.letters.act = this.alphabet.indexOf(this.letters.first)
  },

  mounted: function mounted() {
    // this.getOverview()
    this.getViewport();
    // moment.locale(this.hotel.lang)
    // console.log('hotel: ', this.hotel)
  },
  computed: {
    cashier: function cashier() {
      var _this13 = this;

      var tocash = 0;
      var extra = 0;
      var start = moment(this.hellorange.startDate);
      // var end = moment(this.hellorange.endDate)
      var end = this.hotel.singledaybooking ? moment(this.hellorange.endDate) : moment(this.hellorange.endDate).subtract(1, 'days');
      var range = moment.range(start, end);
      var dates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(range.by('days')).map(function (m) {
        return m.format('YYYY-MM-DD');
      });
      // console.log('dates: ', dates)
      console.log('ombrellos: ', this.ombrellos);
      dates.forEach(function (date, index) {
        // console.log(date)
        _this13.ombrellos.seasons.forEach(function (season, index) {
          // console.log(season)
          if (moment(date).isBetween(season.start, season.end, null, '[]')) {
            // console.log(date + 'is in ' + season.name, season.amount)
            _this13.ombrellos.items.forEach(function (item, index) {
              // console.log(item)
              extra = parseInt(extra) + parseInt(item.num) * parseInt(season.items[index].price);
            });
            tocash = parseInt(tocash) + parseInt(season.amount);
          }
        });
      });
      return {
        tocash: tocash.toFixed(2),
        extra: extra.toFixed(2),
        total: (parseInt(tocash) + parseInt(extra)).toFixed(2)
      };
    },
    modalWidth: function modalWidth() {
      // console.log(this.$mq)
      if (this.$mq === 'sm') {
        return '100%';
      } else if (this.$mq === 'md') {
        return '80%';
      } else {
        return '50%';
      }
    },

    hellorange: {
      get: function get() {
        // console.log(this.range)
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.range);
        // return [moment(this.range.startDate).format('YYYY-MM-DD'), moment(this.range.endDate).format('YYYY-MM-DD')]
      },
      set: function set(newValue) {
        console.log(newValue);
      }
    },
    hotelgrid: function hotelgrid() {
      // `this` points to the vm instance
      this.numbers.last = this.hotel.cols * this.hotel.rows;
      return this.hotel.cols * this.hotel.rows;
    },
    state: function state() {
      // console.log('today: ', this.today)
    },
    filteredArrivals: function filteredArrivals() {
      var _this14 = this;

      console.log('filteredArrivals');
      return this.overview.arrivals.filter(function (post) {
        var arrivals = post.guest.name.toLowerCase().includes(_this14.query.toLowerCase());
        var arrivalsroom = post.guest.room.toLowerCase().includes(_this14.query.toLowerCase());
        console.log(arrivals);
        if (arrivals) {
          return arrivals;
        } else {
          return arrivalsroom;
        }
      });
    },
    filteredDepartures: function filteredDepartures() {
      var _this15 = this;

      return this.overview.departures.filter(function (post) {
        var departures = post.guest.name.toLowerCase().includes(_this15.query.toLowerCase());
        var departuresroom = post.guest.room.toLowerCase().includes(_this15.query.toLowerCase());
        if (departures) {
          return departures;
        } else {
          return departuresroom;
        }
      });
    },
    filteredStays: function filteredStays() {
      var _this16 = this;

      return this.overview.stays.filter(function (post) {
        var stays = post.guest.name.toLowerCase().includes(_this16.query.toLowerCase());
        var staysroom = post.guest.room.toLowerCase().includes(_this16.query.toLowerCase());
        if (stays) {
          return stays;
        } else {
          return staysroom;
        }
      });
    },
    pregrid: function pregrid() {
      var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1;
      if (this.letters.first.length > 0) {
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.numbers.first) + 1 } };
        }
      } else {
        console.log('no letter', this.hotel.cols);
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.hotel.cols + 1 }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.hotel.cols) + 1 } };
        }
      }
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var host = "https://dexter.node.systems:44537";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      forgotpassword: false,
      loginform: true,
      signupform: false,
      formReset: false,
      loading: false,
      formel: {
        email: '',
        password: ''
      },
      rules: {
        email: [{ required: true, type: 'email', message: 'prego controlla l´ email', trigger: 'blur' }],
        password: [{ required: true, message: 'prego inserisci una password', trigger: 'blur' }, { min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }]
      },
      error: {
        state: false,
        message: ''
      },
      success: {
        state: false,
        message: ''
      }
    };
  },

  methods: {
    login: function login(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('login');
          _this.loading = true;
          setTimeout(function () {
            _this.loading = false;
          }, 2000);
          _this.error.state = false;
          _this.$http.post(host + '/login', { email: _this.formel.email.toLowerCase().trim(), password: _this.formel.password }).then(function (data) {
            // this.ombrelli = data.body.ombrells
            console.log(data.body.profile);
            // localStorage.setItem('userid', data.body.id)
            localStorage.setItem('jwt', data.body.jwt);
            localStorage.setItem('profile', data.body.profile);
            // this.auth.authenticated = true
            _this.loading = false;
          }, function (error) {
            console.log(error);
            // this.loading = false
            setTimeout(function () {
              _this.loading = false;
            }, 1000);
            _this.error.state = true;
            _this.error.message = error.body.error;
          });
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },
    signup: function signup(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('login');
          _this2.loading = true;
          _this2.error.state = false;
          _this2.$http.post(host + '/signup', { email: _this2.formel.email.toLowerCase().trim(), password: _this2.formel.password }).then(function (data) {
            // this.ombrelli = data.body.ombrells
            console.log(data);
            localStorage.setItem('jwt', data.body.jwt);
            localStorage.setItem('profile', data.body.profile);
            // router.replace('Hotel')
            // this.loading = false
            _this2.getHotel();
          }, function (error) {
            console.log(error);
            _this2.loading = false;
            _this2.error.state = true;
            _this2.error.message = error.body.error;
          });
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },
    passreset: function passreset(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('passreset');
          _this3.loading = true;
          _this3.error.state = false;
          _this3.$http.post(host + '/forgot', { email: _this3.formel.email.toLowerCase().trim() }).then(function (data) {
            // this.ombrelli = data.body.ombrells
            console.log(data);
            _this3.loading = false;
            _this3.success.state = true;
            _this3.success.message = data.body.success;
            // localStorage.setItem('jwt', data.body.jwt)
            // localStorage.setItem('profile', data.body.profile)
            // router.replace('Hotel')
            // this.loading = false
            // this.getHotel()
          }, function (error) {
            console.log(error);
            _this3.loading = false;
            _this3.error.state = true;
            _this3.error.message = error.body.error;
          });
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },
    getHotel: function getHotel() {
      var _this4 = this;

      this.$http.get(host + '/ombrelloni', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this4.loading = false;
        if (data.body.hotels.length > 1) {
          console.log('multihotel');
          __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('hotel');
        } else if (data.body.hotels.length === 1) {
          console.log('one hotel');
          __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('ombrelli/' + data.body.hotels[0]._id);
        } else {
          console.log('no hotel');
          __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('addhotel');
        }
      }, function (error) {
        console.log(error);
        _this4.loading = false;
        _this4.error.state = true;
        _this4.error.message = error.body.error;
      });
    },
    getSettings: function getSettings() {
      console.log(location.hash);
      if (location.hash === '#signup') {
        this.loginform = false;
        this.signupform = true;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getSettings();
  },

  mounted: function mounted() {
    // this.$refs.emailinput.focus()
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var host = "https://dexter.node.systems:44537";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ombrelli',
  props: ['auth', 'authenticated', 'hotel'],
  data: function data() {
    return {
      hotels: '',
      loading: true
    };
  },

  methods: {
    getHotel: function getHotel() {
      var _this = this;

      // console.log('hotelid: ' + this.hotelid)
      // console.log(localStorage)
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      .get(host + '/ombrelloni', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        _this.hotels = data.body.hotels;
        console.log(data);
        _this.loading = false;
      }, function (error) {
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getHotel();
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logout',
  props: ['auth'],
  data: function data() {
    this.auth.logout(this.$route.query.id, this.$route.query.jwt);
    // console.log(this.$route.query.id)
    return {};
  },

  components: {
    Circle4: __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__["b" /* Circle4 */]
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Settings__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var host = "https://dexter.node.systems:44537";
// import router from './../router'

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'hotel', 'settings', 'ombrelli', 'addpool', 'addombrid', 'addombrell', 'editpool', 'editCanvas', 'edit', 'getOmbrelli'],
  data: function data() {
    return {
      ombrellostats: {
        free: [],
        occupied: []
      },
      hotels: '',
      pool: false,
      canvas: false,
      isCollapse: true
      // dialogVisible: false
    };
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_0__components_Settings___default.a
  },
  methods: {
    // deleteHotel () {
    //   console.log('hotel: ', this.hotel)
    //   this.$http
    //     .post(host + '/api/deletehotel', {hotel: this.hotel},
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       console.log(data)
    //       this.$notify({
    //         group: 'foo',
    //         title: this.hotel.name + ' deleted',
    //         type: 'info',
    //         duration: 500
    //       })
    //       router.push('/hotel')
    //     }, (error) => {
    //       console.log(error)
    //     })
    // },
    changeHotel: function changeHotel(hotel) {
      // console.log('hotel: ', hotel)
      // this.$router.push('/ombrelli/' + hotel._id)
      this.getHotel();
      this.getOmbrelli();
      // window.location.reload()
    },
    handleOpen: function handleOpen(key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose: function handleClose(key, keyPath) {
      // console.log(key, keyPath)
    },
    stats: function stats() {
      // console.log('ombrelli' + this.ombrelli)
    },
    getHotel: function getHotel() {
      var _this = this;

      // console.log('hotelid: ' + this.hotelid)
      // console.log(localStorage)
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      .get(host + '/ombrelloni', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        _this.hotels = data.body.hotels;
        // console.log(data)
      }, function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    hotelgrid: function hotelgrid() {
      // `this` points to the vm instance
      if (this.hotel.lang === 'undefined') {
        this.$i18n.locale = 'en';
      } else {
        this.$i18n.locale = this.hotel.lang;
      }
      // this.ombrelli.forEach((ombrello, index) => {
      //   // console.log(ombrello.free)
      //   if (ombrello.free) {
      //     this.ombrellostats.free.push(ombrello.ombrid)
      //   } else {
      //     this.ombrellostats.occupied.push(ombrello.ombrid)
      //   }
      // })
      return this.hotel.cols * this.hotel.rows;
    }
  },
  beforeMount: function beforeMount() {
    this.getHotel();
  },

  mounted: function mounted() {
    // this.stats()
    // console.log(this.$route.name)
    if (this.$route.name === 'Pool') {
      this.pool = true;
    } else if (this.$route.name === 'Canvas') {
      this.canvas = true;
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_range__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_range__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_de__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_it__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Navbar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Hello_World__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Hello_World___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Hello_World__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var moment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_5_moment___default.a);


// import Settings from '@/components/Settings'

var host = "https://dexter.node.systems:44537";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ombrelli',
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      checkboxGroup1: ['Shanghai'],
      checkboxGroup2: ['Shanghai'],
      checkboxGroup3: ['Shanghai'],
      checkboxGroup4: ['Shanghai'],
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      letters: {
        first: 'A',
        last: '',
        act: 0,
        row: 1
      },
      numbers: {
        first: 1,
        last: 0,
        act: 0
      },
      query: '',
      filtered: '',
      loading: true,
      nogrid: false,
      qrimg: '',
      grid: {
        direction: '',
        letter: true,
        number: true,
        firststep: false,
        active: 0
      },
      state1: '',
      langs: [{
        lang: 'it'
      }, {
        lang: 'de'
      }],
      hotel: '',
      secret: '',
      checkoutbasket: '',
      // pregrid: '',
      ombrelli: [],
      style: '',
      rangestyle: '',
      hotelid: '',
      ombrellos: '',
      addombrello: {
        ombrid: ''
      },
      overview: {
        arrivals: [],
        departures: [],
        stays: []
      },
      date: ['2016-10-16', '2024-10-05'],
      today: moment().format('YYYY-MM-DD'),
      lang: 'it',
      range: {
        startDate: moment(),
        endDate: ''
        // startDate: '2019-04-03',
        // endDate: '2019-04-10'
      },
      rangepicker: [],
      rangeviewdata: '',
      // disabledRange: {
      //   startDate: moment(),
      //   endDate: moment().add(9, 'days')
      // },
      disabledDates: [],
      disabledDatesBasket: [],
      datePickerOptions: {
        firstDayOfWeek: 1,
        onPick: this.changeRange
      },
      firstDayOfWeek: 1,
      editombrid: false,
      dragging: null,
      lock: null,
      location: 'beach',
      rangeview: false
    };
  },

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_date___default.a,
    Circle4: __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__["b" /* Circle4 */],
    DateRange: __WEBPACK_IMPORTED_MODULE_4_vue_date_range__["DateRange"],
    'Navbar': __WEBPACK_IMPORTED_MODULE_9__components_Navbar___default.a,
    Hello: __WEBPACK_IMPORTED_MODULE_10__components_Hello_World___default.a,
    Drag: __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__["Drag"],
    Drop: __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__["Drop"]
    // EmbeddedSlack
    // chat
  },
  sockets: {
    connect: function connect() {
      // console.log('socket connected')
    },
    stream: function stream(val) {
      // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      // console.log(val.hotelid)
      if (val.hotelid === this.hotelid) {
        // console.log('an umbrella was updated')
        this.getOmbrelli();
      }
    },
    disconnect: function disconnect() {
      // console.log('socket error')
      // this.$notify({
      //   group: 'foo',
      //   title: 'Error loading Data',
      //   text: 'I´ll fix it in a few',
      //   type: 'warning',
      //   duration: 5000
      // })
    }
  },
  methods: {
    getqr: function getqr() {
      var _this = this;

      this.$http.get(host + '/api/get/pass', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        // console.log(data)
        _this.qrimg = data.body;
        // this.$modal.hide('settings')
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    stepHandler: function stepHandler(e, i) {
      console.log(e, i);
      this.grid.active = i;
    },
    nextStep: function nextStep() {
      this.grid.active++;
    },
    previousStep: function previousStep() {
      if (this.grid.active === 2) {
        this.ombrelli = [];
        this.grid.direction = '';
        this.grid.active = 0;
      } else {
        this.grid.active--;
      }
    },
    filter: function filter(query) {
      var _this2 = this;

      console.log(this.query, this.overview.arrivals.filter(function (item) {
        return item.ombrid === _this2.query;
      }));
      this.filtered = this.overview.arrivals.filter(function (item) {
        return item.guest.name === _this2.query;
      });
    },

    // querySearch (queryString, cb) {
    //   var links = this.linkst
    //   var results = queryString ? links.filter(this.createFilter(queryString)) : links
    //   // call callback function to return suggestions
    //   console.log(results)
    //   cb(results)
    // },
    // createFilter (queryString) {
    //   return (link) => {
    //     // console.log(link, queryString)
    //     return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
    //   }
    // },
    handleSelect: function handleSelect(item) {
      // console.log(item)
    },

    disabledFunc: function disabledFunc(dayMoment) {
      // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
      // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
      if (this.disabledDates.includes(moment(dayMoment).format('YYYY-MM-DD'))) {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return true;
      } else {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return false;
      }
    },
    preCheckDate: function preCheckDate() {
      var _this3 = this;

      // console.log('preCheckDate', this.ombrellos.guests)
      // console.log(!this.hotel.singledaybooking)
      this.disabledDates = [];
      this.ombrellos.guests.forEach(function (guest, indexo) {
        if (guest.name !== _this3.ombrellos.guest) {
          var start = moment(guest.arrival, 'YYYY-MM-DD');
          var end = moment(guest.departure, 'YYYY-MM-DD');
          var range = moment.range(start, end);
          var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days', { excludeStart: false, excludeEnd: !_this3.hotel.singledaybooking })).map(function (m) {
            return m.format('YYYY-MM-DD');
          });
          Array.prototype.push.apply(_this3.disabledDates, dates);
          // console.log('guest: ', guest.name, dates)
        }
      });
    },
    preCheckDateBasket: function preCheckDateBasket() {
      var _this4 = this;

      // console.log('preCheckDate', this.ombrellos.guests)
      console.log(!this.hotel.singledaybooking);
      this.disabledDatesBasket = [];
      this.checkoutbasket.guests.forEach(function (guest, indexo) {
        if (guest.name !== _this4.ombrellos.guest) {
          var start = moment(guest.arrival, 'YYYY-MM-DD');
          var end = moment(guest.departure, 'YYYY-MM-DD');
          var range = moment.range(start, end);
          var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days', { excludeStart: false, excludeEnd: !_this4.hotel.singledaybooking })).map(function (m) {
            return m.format('YYYY-MM-DD');
          });
          Array.prototype.push.apply(_this4.disabledDatesBasket, dates);
          // console.log('guest: ', guest.name, dates)
        }
      });
    },

    // checkDate (date) {
    // console.log(moment(date).format('YYYY-MM-DD'))
    // date = moment(date).format('YYYY-MM-DD')
    // return moment(date).isBetween(moment(this.ombrellos.arrival), moment(this.ombrellos.departure))
    // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
    // if (moment(date).isBetween(moment('2019-04-12'), moment('2019-04-14'))) {
    //   return true
    // } else {
    //   return false
    // }
    // this.ombrellos.guests.forEach(function (guest, indexo) {
    //   console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
    //   if (moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12'))) {
    //     return true
    //   } else {
    //     return false
    //   }
    // })
    // },
    handleDragover: function handleDragover(group, data, event) {
      // console.log(data)
      // console.log(group.ombrid)
      // console.log(event)
      if (!group.free) {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleDrop: function handleDrop(group, data, key) {
      // console.log(group.ombrello.ombrid, data.target.id)
      this.moveombrello(group.ombrello, data.target.id);
      // alert(`You dropped with data: ${JSON.stringify(data)}`)
    },
    changeombrid: function changeombrid() {
      // console.log('changeombrid')
      this.editombrid = true;
    },
    onChange: function onChange(range) {
      // console.log('range: ', range.minDate, range.maxDate)
      this.range = range;
      // console.log('ombrello onChange: ', moment(range))
    },

    // setRange (p) {
    //   if (typeof p === 'number') {
    //     // console.log(p)
    //     this.range = {
    //       startDate: moment().add(p, 'days'),
    //       endDate: moment()
    //     }
    //   }
    // },
    show: function show(ombrello) {
      console.log('show ombrello: ', ombrello);
      console.log(this.today);
      this.ombrellos = ombrello;
      this.range = {};
      if (ombrello.free) {
        this.ombrellos.items = this.hotel.items;
        // this.ombrellos.chairs = this.hotel.chairs
        // this.ombrellos.beds = this.hotel.beds
      } else if (!ombrello.items) {
        this.ombrellos.items = this.hotel.items;
      }
      // this.hotel.items.forEach((item, indexo) => {
      // })
      // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
      // this.date[0] = ombrello.arrival
      // this.date[1] = ombrello.departure
      // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
      if (!ombrello.free) {
        // console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'))
        this.range.startDate = moment(ombrello.arrival);
        this.range.endDate = moment(ombrello.departure);
      } else if (this.hotel.singledaybooking) {
        this.range.startDate = moment(this.today);
        this.range.endDate = moment(this.today);
      } else {
        this.range.startDate = moment(this.today);
        this.range.endDate = moment(this.today).add(1, 'days');
      }
      // if (ombrello.free) {
      //   this.range.endDate = moment(ombrello.departure)
      // } else {
      //   this.range.endDate = moment(this.today)
      // }
      this.preCheckDate();
      this.$modal.show('hello-world');
    },
    newshow: function newshow(ombrello, day) {
      console.log('newshow ombrello: ', ombrello, day);
      console.log(this.today);
      this.ombrellos = {};
      this.ombrellos.items = this.hotel.items;
      this.ombrellos.guests = ombrello.guests;
      this.ombrellos.ombrid = ombrello.ombrid;
      this.ombrellos.hotelid = ombrello.hotelid;
      this.ombrellos.free = true;
      this.ombrellos._id = ombrello._id;
      this.ombrellos.passid = '';
      this.range = {};
      this.preCheckDate();
      this.$modal.show('hello-world');
    },
    bookedshow: function bookedshow(ombrello, day) {
      console.log('bookedshow ombrello: ', ombrello, day);
      console.log(this.today);
      this.ombrellos = {};
      this.range = {};
      this.range.startDate = moment(day.guests[0].arrival);
      this.range.endDate = moment(day.guests[0].departure);
      this.ombrellos.items = day.guests[0].items;
      this.ombrellos.guests = ombrello.guests;
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.ombrellos, 'guest', day.guests[0].name);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.ombrellos, 'room', day.guests[0].room);
      this.ombrellos.ombrid = ombrello.ombrid;
      this.ombrellos.hotelid = ombrello.hotelid;
      this.ombrellos.guestnr = day.guestnr;
      this.ombrellos.free = false;
      this.ombrellos._id = ombrello._id;
      this.ombrellos.passid = day.guests[0].passid;
      this.preCheckDate();
      this.$modal.show('hello-world');
    },

    // checkOut (data, index) {
    //   // this.$modal.show(modal)
    //   this.ombrellos = data.ombrello
    //   // const filteredItems = this.ombrellos.guests.filter((item, key) => key === index)
    //   // console.log('key: ', filteredItems)
    //   this.ombrellos.guests.push(data.guest)
    //   // this.ombrellos.seasons = data.ombrello.seasons
    //   console.log(data, index, this.ombrellos)
    //   this.ombrellos.guests = this.ombrellos.guests.filter((item, key) => key === index)
    //   this.preCheckDate()
    // },
    open: function open(modal, data, index) {
      this.checkoutbasket = data.ombrello;
      console.log('guest: ', data);
      // const filteredItems = this.ombrellos.guests.filter((item, key) => key === index)
      // console.log('key: ', filteredItems)
      this.checkoutbasket.guests = [];
      this.checkoutbasket.guests.push(data.guest);
      // this.ombrellos.seasons = data.ombrello.seasons
      // console.log(data, index, this.ombrellos)
      // console.log(data, index, this.overview.departures[index])
      // this.checkoutbasket.guests = this.checkoutbasket.guests.filter((item, key) => key === index)
      this.preCheckDateBasket();
      this.$modal.show(modal);
    },
    hide: function hide() {
      this.$modal.hide('hello-world');
    },
    settings: function settings() {
      this.$modal.show('settings');
    },

    updatehotel: function updatehotel() {
      var _this5 = this;

      this.$http.post(host + '/api/updatehotel', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        // console.log(data)
        _this5.$modal.hide('settings');
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this5.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    // moveombrello: function (old, newo) {
    //   console.log(old, newo)
    //   // this.ombrellos = old
    //   // this.closeombrello()
    //   // old._id = newo
    //   // old.ombrid = ombrid
    //   // console.log(this.ombrellos)
    //   // this.ombrellos = newo
    //   this.$http
    //     .post(host + '/api/moveombrello', { old: old, newo: newo },
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + localStorage.jwt
    //       }
    //     },
    //     ).then((data) => {
    //       // console.log(data)
    //       this.dragging = null
    //       this.getOmbrelli()
    //     }, (error) => {
    //       console.log(error)
    //       this.$notify({
    //         group: 'foo',
    //         title: 'Error loading Data',
    //         text: 'I´ll fix it in a few',
    //         type: 'warning',
    //         duration: 500
    //       })
    //     })
    // },
    closeombrello: function closeombrello(index) {
      var _this6 = this;

      // console.log(this.ombrellos.guests, index)
      this.ombrellos.guests.splice(index, 1);
      // console.log('updated: ', this.ombrellos.guests)
      this.ombrellos.guest = '';
      this.ombrellos.room = '';
      this.ombrellos.arrival = '';
      this.ombrellos.note = '';
      this.ombrellos.departure = '';
      this.ombrellos.guestsinday = [];
      this.ombrellos.free = true;
      this.$http.post(host + '/ombrelloni/close', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this6.$modal.hide('hello-world');
        _this6.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },

    addombrell: function addombrell() {
      var _this7 = this;

      // console.log(this.addombrello, this.hotelid)
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/ombrelloni/add', { ombrid: this.addombrello.ombrid, hotelid: this.hotelid, location: this.location }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        // console.log(data)
        _this7.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },
    editguest: function editguest(index) {
      // console.log(index.ombrid, index.edit)
      index.edit = true;
      // Vue.set(this.ombrelli[index], 'edit', true)
    },
    saveEdit: function saveEdit(index, guest) {
      // save your changes
      // this.toggleEdit(index, guest)
      // console.log(index, guest)
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.ombrelli[index], 'guest', guest);
    },
    // presetGrid () {
    //   var grid = this.hotel.cols * this.hotel.rows
    //   if (this.ombrelli.length === grid) {
    //     console.log('preset grid done')
    //   } else {
    //     console.log('preset grid not yet done')
    //     if (this.numbers.first < 10) {
    //       this.pregrid = {
    //         first: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         },
    //         left: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         },
    //         up: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         }
    //       }
    //     } else {
    //       this.pregrid = {
    //         first: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         },
    //         left: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         },
    //         up: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         }
    //       }
    //     }
    //   }
    // },
    resetGrid: function resetGrid() {
      this.ombrelli = [];
      this.grid.firststep = true;
      this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
      this.letters.row = 1;
      this.numbers.act = this.numbers.first;
      this.grid.active = 2;
      if (this.letters.first.length === 0 || this.grid.direction === 'empty') {
        this.setemptyGrid();
      } else {
        this.setGrid();
      }
    },
    setemptyGrid: function setemptyGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      // console.log('ombrelli length', (this.ombrelli.length + 1), 'numbers act: ', this.numbers.act)
      if (this.ombrelli.length === grid) {
        // console.log('done')
      } else {
        if (grid > 99 && this.numbers.act <= 9) {
          // console.log('case: 1')
          this.ombrelli.push({ ombrid: '00' + parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        } else if (grid > 99 && this.numbers.act <= 99) {
          // console.log('case: 2')
          this.ombrelli.push({ ombrid: '0' + parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        } else {
          // console.log('case: 3')
          this.ombrelli.push({ ombrid: parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        }
        this.setemptyGrid();
      }
    },
    setGrid: function setGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      // console.log(this.letters.first)
      if (this.letters.act === this.alphabet.length) {
        this.letters.act = 0;
      }
      var act = this.alphabet[this.letters.act].toUpperCase();
      // console.log('act: ', act, this.numbers.act)
      if (this.ombrelli.length === grid) {
        // console.log('done')
      } else {
        // console.log('not done')
        if (this.numbers.act < 10) {
          this.ombrelli.push({ ombrid: act + '0' + this.numbers.act, free: true });
          console.log('nr: ', act + '0' + this.numbers.act);
          if (this.grid.direction === 'left') {
            this.numbers.act++;
          } else {
            this.letters.act++;
          }
          if (this.ombrelli.length === this.hotel.cols * this.letters.row) {
            if (this.grid.direction === 'left') {
              this.numbers.act = this.numbers.first;
              this.letters.row++;
              this.letters.act++;
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
              this.numbers.act++;
              this.letters.row++;
            }
            // console.log('end of row', this.letters.row - 1, this.numbers.act)
          } else {}
          this.setGrid();
        } else {
          this.ombrelli.push({ ombrid: act + this.numbers.act, free: true });
          // console.log('nr: ', act + this.numbers.act)
          if (this.grid.direction === 'left') {
            this.numbers.act++;
          } else {
            this.letters.act++;
          }
          if (this.ombrelli.length === this.hotel.cols * this.letters.row) {
            if (this.grid.direction === 'left') {
              this.numbers.act = this.numbers.first;
              this.letters.row++;
              this.letters.act++;
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
              this.numbers.act++;
              this.letters.row++;
            }
            // console.log('end of row', this.letters.row - 1, this.numbers.act)
          } else {}
          this.setGrid();
        }
      }
    },

    saveGrid: function saveGrid() {
      var _this8 = this;

      // console.log(this.ombrelli)
      this.$http.post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this8.getOmbrelli();
        _this8.nogrid = false;
      }, function (error) {
        console.log(error);
        _this8.$notify({
          group: 'foo',
          title: 'grid saved',
          type: 'success',
          duration: 500
        });
      });
    },
    changeDate: function changeDate() {
      // console.log(moment(this.today).format('YYYY-MM-DD'))
      this.today = moment(this.today).format('YYYY-MM-DD');
      this.range.startDate = moment(this.today);
      this.getOmbrelli();
      this.rangeview = false;
    },
    changeRange: function changeRange() {
      var _this9 = this;

      this.loading = true;
      // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
      var start = moment(this.rangepicker[0], 'YYYY-MM-DD');
      var end = moment(this.rangepicker[1], 'YYYY-MM-DD');
      var range = moment.range(start, end);
      var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days')).map(function (m) {
        return m.format('YYYY-MM-DD');
      });
      // console.log('range picker dates: ', dates)
      this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);';
      this.rangeviewdata = dates;
      // var set = this.ombrelli.length * dates.length
      var count = 1;
      console.log('count: ', count);
      this.ombrelli.forEach(function (ombrello, indexo) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this9.ombrelli[indexo], 'dates', []);
        dates.forEach(function (date, indexd) {
          _this9.ombrelli[indexo].dates.push({ date: moment(date).format('DD'), fulldate: moment(date).format('YYYY-MM-DD'), day: moment(date).format('dd'), ombrid: ombrello.ombrid, guests: [], free: true });
          if (count === _this9.ombrelli.length * dates.length) {
            console.log('count done');
            _this9.loading = false;
            _this9.rangeview = true;
            return true;
          } else {
            count++;
            console.log('count not done');
            ombrello.guests.forEach(function (guest, index) {
              if (moment(date).isBetween(guest.arrival, guest.departure, null, _this9.hotel.singledaybooking ? '[]' : '[)')) {
                _this9.ombrelli[indexo].dates[indexd].guests.push(guest);
                _this9.ombrelli[indexo].dates[indexd].free = false;
                _this9.ombrelli[indexo].dates[indexd].guestnr = index;
              } else {}
            });
          }
        });
      });
    },
    getOmbrelli: function getOmbrelli() {
      var _this10 = this;

      this.$http.post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log('hotel: ', data.body.ombrells)
        _this10.hotelid = data.body.hotels._id;
        _this10.hotel = data.body.hotels;
        moment.locale(data.body.hotels.lang);
        if (data.body.hotels.chairs === undefined) {
          _this10.hotel.chairs = 1;
        }
        if (data.body.hotels.beds === undefined) {
          _this10.hotel.beds = 1;
        }
        _this10.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);';
        _this10.ombrelli = [];
        data.body.ombrells.forEach(function (ombrello, indexo) {
          _this10.ombrelli.push(ombrello);
          ombrello.guests.forEach(function (guest, index) {
            if (moment(_this10.today).isBetween(guest.arrival, guest.departure, null, _this10.hotel.singledaybooking ? '[]' : '[)')) {
              // console.log('guest: ', guest, 'ombrello: ', this.ombrelli[indexo])
              _this10.ombrelli[indexo].guest = guest.name;
              _this10.ombrelli[indexo].room = guest.room;
              _this10.ombrelli[indexo].arrival = guest.arrival;
              _this10.ombrelli[indexo].departure = guest.departure;
              _this10.ombrelli[indexo].free = false;
              _this10.ombrelli[indexo].note = guest.note;
              _this10.ombrelli[indexo].guestnr = index;
              if (guest.passid) {
                _this10.ombrelli[indexo].passid = guest.passid;
              }
              if (!guest.items) {
                // console.log('no items')
                _this10.ombrelli[indexo].items = _this10.hotel.items;
              } else {
                _this10.ombrelli[indexo].items = guest.items;
              }
              _this10.ombrelli[indexo].guestsinday.push(guest);
            } else {}
          });
        });
        _this10.getOverview();
        // var grid = this.hotel.cols * this.hotel.rows
        if (!_this10.hotel.firststep && data.body.ombrells <= 0) {
          // this.nogrid = true
          // this.setGrid()
        }
        _this10.loading = false;
        if (_this10.rangeview) {
          _this10.changeRange();
        }
        // this.$notify({
        //   group: 'foo',
        //   title: 'Hoteldata loaded',
        //   text: 'You are good to go',
        //   type: 'success',
        //   duration: 500
        // })
      }, function (error) {
        console.log(error);
        _this10.$router.replace('/');
      });
    },
    getOverview: function getOverview() {
      var _this11 = this;

      this.overview.arrivals = [];
      this.overview.departures = [];
      this.overview.stays = [];
      this.ombrelli.forEach(function (ombrello, indexo) {
        ombrello.guests.forEach(function (guest, index) {
          if (moment(_this11.today).isSame(guest.arrival)) {
            _this11.overview.arrivals.push({ guest: guest, ombrello: ombrello });
          } else if (moment(_this11.today).isSame(guest.departure)) {
            _this11.overview.departures.push({ guest: guest, ombrello: ombrello, guestindex: index });
          } else if (moment(_this11.today).isBetween(guest.arrival, guest.departure, null, '()')) {
            _this11.overview.stays.push({ guest: guest, ombrello: ombrello });
          }
        });
      });
    },
    addchair: function addchair(index, nr, chair, hotel) {
      var _this12 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addchair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this12.ombrelli[index], 'chairs', newchairs);
        _this12.$notify({
          group: 'foo',
          title: 'Chair added',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
      });
    },
    removechair: function removechair(index, nr, chair, hotel) {
      var _this13 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removechair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this13.ombrelli[index], 'chairs', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    addbed: function addbed(index, nr, chair, hotel) {
      var _this14 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addbed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this14.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    removebed: function removebed(index, nr, chair, hotel) {
      var _this15 = this;

      // console.log(this.ombrelli)
      // console.log(index, chair, hotel)
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removebed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this15.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    changeguest: function changeguest(index, chair, guest) {
      // console.log(this.ombrelli)
      // console.log(index, chair, guest)
      // var newchairs = nr - 1
      // this.$http
      //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
      //   {
      //     headers: {
      //       'Authorization': 'Bearer ' + localStorage.jwt
      //     }
      //   },
      //   ).then((data) => {
      //     console.log(data)
      //     // this.loading = false
      //     Vue.set(this.ombrelli[index], 'beds', newchairs)
      //   }, (error) => {
      //     console.log(error)
      //   })
    }
  },
  beforeMount: function beforeMount() {
    this.getOmbrelli();
    this.letters.act = this.alphabet.indexOf(this.letters.first);
  },

  mounted: function mounted() {
    // this.getOverview()
    // moment.locale(this.hotel.lang)
    // console.log('hotel: ', this.hotel)
  },
  computed: {
    cashierbasket: function cashierbasket() {
      var _this16 = this;

      var tocash = 0;
      var extra = 0;
      console.log(this.disabledDatesBasket);
      // console.log(this.ombrellos.guests[0])
      var start = moment(this.checkoutbasket.guests[0].arrival);
      // var end = moment(this.checkoutbasket.guests[0].departure).subtract(1, 'days')
      var end = this.hotel.singledaybooking ? moment(this.checkoutbasket.guests[0].departure) : moment(this.checkoutbasket.guests[0].departure).subtract(1, 'days');
      // if (moment(date).isBetween(guest.arrival, guest.departure, null, this.hotel.singledaybooking ? '[]' : '[)')) {
      var range = moment.range(start, end);
      var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days')).map(function (m) {
        return m.format('YYYY-MM-DD');
      });
      console.log('dates: ', dates);
      dates.forEach(function (date, index) {
        // console.log(date)
        _this16.checkoutbasket.seasons.forEach(function (season, index) {
          // console.log(season)
          if (moment(date).isBetween(season.start, season.end, null, '[]')) {
            console.log(date + ' is in ' + season.name, season.amount, _this16.checkoutbasket.guests);
            _this16.checkoutbasket.guests[0].items.forEach(function (item, index) {
              // console.log(item)
              extra = parseInt(extra) + parseInt(item.num) * parseInt(season.items[index].price);
            });
            tocash = parseInt(tocash) + parseInt(season.amount);
          }
        });
      });
      return {
        tocash: tocash.toFixed(2),
        extra: extra.toFixed(2),
        total: (parseInt(tocash) + parseInt(extra)).toFixed(2)
      };
    },

    hotelgrid: function hotelgrid() {
      // `this` points to the vm instance
      this.numbers.last = this.hotel.cols * this.hotel.rows;
      return this.hotel.cols * this.hotel.rows;
    },
    state: function state() {
      // console.log('today: ', this.today)
    },
    filteredArrivals: function filteredArrivals() {
      var _this17 = this;

      // console.log('filteredArrivals')
      return this.overview.arrivals.filter(function (post) {
        var arrivals = post.guest.name.toLowerCase().includes(_this17.query.toLowerCase());
        var arrivalsroom = post.guest.room.toLowerCase().includes(_this17.query.toLowerCase());
        // console.log(arrivals)
        if (arrivals) {
          return arrivals;
        } else {
          return arrivalsroom;
        }
      });
    },
    filteredDepartures: function filteredDepartures() {
      var _this18 = this;

      return this.overview.departures.filter(function (post) {
        var departures = post.guest.name.toLowerCase().includes(_this18.query.toLowerCase());
        var departuresroom = post.guest.room.toLowerCase().includes(_this18.query.toLowerCase());
        if (departures) {
          return departures;
        } else {
          return departuresroom;
        }
      });
    },
    filteredStays: function filteredStays() {
      var _this19 = this;

      return this.overview.stays.filter(function (post) {
        var stays = post.guest.name.toLowerCase().includes(_this19.query.toLowerCase());
        var staysroom = post.guest.room.toLowerCase().includes(_this19.query.toLowerCase());
        if (stays) {
          return stays;
        } else {
          return staysroom;
        }
      });
    },
    pregrid: function pregrid() {
      var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1;
      if (this.letters.first.length > 0) {
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.numbers.first) + 1 } };
        }
      } else {
        console.log('no letter', this.hotel.cols);
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.hotel.cols + 1 }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.hotel.cols) + 1 } };
        }
      }
      // if (this.numbers.first < 10) {
      //   return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
      // } else {
      //   return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.numbers.first) + 1) } }
      // }
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_range__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Navbar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Navbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'



// import 'moment/locale/de'
// import 'moment/locale/it'
var moment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_1_moment___default.a);

// import Settings from '@/components/Settings'
var host = "https://dexter.node.systems:44537";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pagamenti',
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      loading: true,
      dialogVisible: false,
      hotel: '',
      newseason: false,
      updateseason: false,
      season: {
        name: '',
        daterange: [],
        items: []
      },
      datePickerOptions: {
        firstDayOfWeek: 1
      },
      rules: {
        name: [{ required: true, message: 'prego inserisci un nome per la stagione', trigger: 'blur' }]
      }
    };
  },

  components: {
    // datepicker,
    Circle4: __WEBPACK_IMPORTED_MODULE_0_vue_loading_spinner__["b" /* Circle4 */],
    // DateRange,
    'Navbar': __WEBPACK_IMPORTED_MODULE_3__components_Navbar___default.a
  },
  sockets: {
    connect: function connect() {
      // console.log('socket connected')
    },
    stream: function stream(val) {
      // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      // console.log(val.hotelid)
      if (val.hotelid === this.hotelid) {
        // console.log('an umbrella was updated')
        // this.getHotel()
      }
    },
    disconnect: function disconnect() {
      // console.log('socket error')
      // this.$notify({
      //   group: 'foo',
      //   title: 'Error loading Data',
      //   text: 'I´ll fix it in a few',
      //   type: 'warning',
      //   duration: 5000
      // })
    }
  },
  methods: {
    changeRange: function changeRange() {
      console.log(this.season.daterange);
    },
    editcashier: function editcashier() {
      var _this = this;

      this.loading = true;
      this.$http.post(host + '/updateseason', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this.loading = false;
        _this.updateseason = false;
        _this.$notify({
          group: 'foo',
          title: 'Cashier Update',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
        _this.loading = false;
        _this.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 5000
        });
      });
    },
    addseason: function addseason() {
      var _this2 = this;

      this.newseason = true;
      this.updateseason = false;
      // this.season.items = this.hotel.items
      this.season.name = '';
      this.season.items = [];
      this.hotel.items.forEach(function (item, indexo) {
        _this2.season.items.push({ name: item.name, price: 0 });
      });
    },
    editseason: function editseason(season, index) {
      this.updateseason = true;
      this.newseason = false;
      this.season = season;
      this.season.index = index;
      console.log(season);
    },
    addnewseason: function addnewseason(formName) {
      var _this3 = this;

      console.log('season: ', moment(this.season.daterange[0]).format('YYYY-MM-DD'));
      this.season.start = moment(this.season.daterange[0]).format('YYYY-MM-DD');
      this.season.end = moment(this.season.daterange[1]).format('YYYY-MM-DD');
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('addseason');
          _this3.loading = true;
          _this3.hotel.seasons.push(_this3.season);
          // this.error.state = false
          _this3.$http.post(host + '/addseason', { hotel: _this3.hotel }, {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }).then(function (data) {
            console.log(data);
            _this3.loading = false;
            _this3.season = {};
            _this3.newseason = false;
            _this3.updateseason = false;
            _this3.$notify({
              group: 'foo',
              title: 'Stagione aggiunta',
              type: 'success',
              duration: 500
            });
          }, function (error) {
            console.log(error);
            _this3.loading = false;
            _this3.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 5000
            });
            // this.error.state = true
            // this.error.message = error.body.error
          });
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },
    saveseason: function saveseason(formName, index) {
      var _this4 = this;

      console.log('season: ', this.season, index);
      this.hotel.seasons[index].start = moment(this.season.daterange[0]).format('YYYY-MM-DD');
      this.hotel.seasons[index].end = moment(this.season.daterange[1]).format('YYYY-MM-DD');
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('addseason');
          _this4.loading = true;
          // this.hotel.seasons.push(this.season)
          // this.error.state = false
          _this4.$http.post(host + '/updateseason', { hotel: _this4.hotel }, {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }).then(function (data) {
            console.log(data);
            _this4.season = {};
            _this4.newseason = false;
            _this4.updateseason = false;
            _this4.loading = false;
            _this4.$notify({
              group: 'foo',
              title: 'Stagione salvata',
              type: 'success',
              duration: 500
            });
          }, function (error) {
            console.log(error);
            _this4.loading = false;
            _this4.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 5000
            });
            // this.error.state = true
            // this.error.message = error.body.error
          });
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },
    deleteseason: function deleteseason(index) {
      var _this5 = this;

      console.log('season: ', this.season, index);
      this.hotel.seasons.splice(index, 1);
      this.$http.post(host + '/updateseason', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this5.loading = false;
        _this5.dialogVisible = false;
        _this5.updateseason = false;
        _this5.$notify({
          group: 'foo',
          title: 'Stagione salvata',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
        _this5.loading = false;
        _this5.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 5000
        });
      });
    },
    getHotel: function getHotel() {
      var _this6 = this;

      // console.log('hotelid: ' + this.hotelid)
      // console.log(localStorage)
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      .post(host + '/hotel', { hotelid: this.$route.params.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        _this6.hotel = data.body.hotel;
        _this6.loading = false;
        console.log(data);
      }, function (error) {
        console.log(error);
      });
    },
    settings: function settings() {
      this.$modal.show('settings');
    }
  },
  beforeMount: function beforeMount() {
    // this.getHotel()
  },

  mounted: function mounted() {
    this.getHotel();
    // this.getOverview()
    // moment.locale(this.hotel.lang)
    // console.log('hotel: ', this.hotel)
  },
  computed: {}
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_range__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Navbar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_drag_drop__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_drag_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_drag_resize__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_drag_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_drag_resize__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import EmbeddedSlack from 'embedded-slack'
// const chat = new EmbeddedSlack({
//   containerId: 'embedded-slack',
//   channel: 'C03M1FH6Y',
//   token: 'xoxp-3715527188-3715527214-346873012933-85307408b261ae33e2a178e9a2c4914c'
// })
var host = "https://dexter.node.systems:44537";
// var host = 'http://drop3.drophost.it:44534'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pool',
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      loading: true,
      hotel: '',
      secret: '',
      ombrelli: '',
      style: '',
      hotelid: '',
      ombrellos: '',
      addombrello: {
        ombrid: ''
      },
      date: ['2016-10-16', '2018-10-05'],
      lang: 'it',
      range: {
        startDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(),
        endDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(7, 'days')
      },
      firstDayOfWeek: 1,
      editombrid: false,
      dragging: null,
      lock: null,
      draggable: true,
      location: 'pool',
      edit: false
    };
  },

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date___default.a,
    Circle4: __WEBPACK_IMPORTED_MODULE_1_vue_loading_spinner__["b" /* Circle4 */],
    DateRange: __WEBPACK_IMPORTED_MODULE_3_vue_date_range__["DateRange"],
    'Navbar': __WEBPACK_IMPORTED_MODULE_5__components_Navbar___default.a,
    Drag: __WEBPACK_IMPORTED_MODULE_6_vue_drag_drop__["Drag"],
    Drop: __WEBPACK_IMPORTED_MODULE_6_vue_drag_drop__["Drop"],
    VueDragResize: __WEBPACK_IMPORTED_MODULE_7_vue_drag_resize___default.a
    // EmbeddedSlack
    // chat
  },
  sockets: {
    connect: function connect() {
      console.log('socket connected');
    },
    stream: function stream(val) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)');
      console.log(val.hotelid);
      if (val.hotelid === this.hotelid) {
        console.log('an umbrella was updated');
        this.getOmbrelli();
      }
    },
    disconnect: function disconnect() {
      console.log('socket error');
      this.$notify({
        group: 'foo',
        title: 'Error loading Data',
        text: 'I´ll fix it in a few',
        type: 'warning',
        duration: 5000
      });
    }
  },
  methods: {
    editpool: function editpool() {
      // console.log(this.edit)
      if (this.edit) {
        this.edit = false;
        this.updategrid();
      } else {
        this.edit = true;
      }
    },
    removePool: function removePool(index) {
      console.log(index);
      this.hotel.pools.splice(index, 1);
    },
    addpool: function addpool() {
      // this.hotel.pools = []
      this.hotel.pools.push({
        x: 500,
        y: 500,
        height: 500,
        width: 400
      });
    },
    addombrid: function addombrid() {
      // this.hotel.pools = []
      this.ombrelli.push({
        free: true,
        location: 'pool',
        ombrid: 'pool',
        hotelid: this.hotel._id,
        user: this.hotel.user,
        width: 120,
        height: 120,
        x: 500,
        y: 500
      });
      this.ombrellos = {
        free: true,
        location: 'pool',
        ombrid: 'pool',
        hotelid: this.hotel._id,
        user: this.hotel.user,
        width: 120,
        height: 120,
        x: 500,
        y: 500
        // this.updateombrello()
      };
    },
    onResizing: function onResizing(id, left, top, width, height) {
      // console.log(id, left, top, width, height)
      this.ombrelli[id].left = left.left;
      this.ombrelli[id].top = left.top;
      this.ombrelli[id].x = left.left;
      this.ombrelli[id].y = left.top;
      // this.ombrelli[id].x = left.left
      // this.ombrelli[id].left = left.left
    },
    resize: function resize(newRect) {
      console.log(newRect);
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    pooldrag: function pooldrag(id, left, top, width, height) {
      // console.log(id, left, top, width, height)
      this.hotel.pools[id].x = left.left;
      this.hotel.pools[id].y = left.top;
      this.hotel.pools[id].width = left.width;
      this.hotel.pools[id].height = left.height;
    },
    handleDragover: function handleDragover(group, data, event) {
      // console.log(data)
      // console.log(group.ombrid)
      // console.log(event)
      if (!group.free) {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleDrop: function handleDrop(group, data, key) {
      console.log(group.ombrello.ombrid, data.target.id);
      this.moveombrello(group.ombrello, data.target.id);
      // alert(`You dropped with data: ${JSON.stringify(data)}`)
    },
    changeombrid: function changeombrid() {
      console.log('changeombrid');
      this.editombrid = true;
    },
    onChange: function onChange(range) {
      this.range = range;
      console.log(__WEBPACK_IMPORTED_MODULE_4_moment___default()(range.endDate._d));
    },
    setRange: function setRange(p) {
      if (typeof p === 'number') {
        console.log(p);
        this.range = {
          startDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(p, 'days'),
          endDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()()
        };
      }
    },
    show: function show(ombrello) {
      console.log(ombrello);
      this.ombrellos = ombrello;
      if (ombrello.free) {
        this.ombrellos.chairs = this.hotel.chairs;
        this.ombrellos.beds = this.hotel.beds;
      }
      // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
      this.date[0] = ombrello.arrival;
      this.date[1] = ombrello.departure;
      console.log(__WEBPACK_IMPORTED_MODULE_4_moment___default()(ombrello.arrival, 'DD.MM.YYYY'));
      if (ombrello.arrival) {
        this.range.startDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(ombrello.arrival, 'DD.MM.YYYY');
      }
      if (ombrello.departure) {
        this.range.endDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(ombrello.departure, 'DD.MM.YYYY');
      }
      this.$modal.show('hello-world');
    },
    hide: function hide() {
      this.$modal.hide('hello-world');
    },
    settings: function settings() {
      this.$modal.show('settings');
    },

    updategrid: function updategrid() {
      var _this = this;

      console.log(this.ombrelli);
      // console.log(this.range['endDate'])
      // this.editombrid = false
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/api/updategrid', { ombrelli: this.ombrelli, hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        // this.$modal.hide('hello-world')
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    updatehotel: function updatehotel() {
      var _this2 = this;

      this.$http.post(host + '/api/updatehotel', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this2.$modal.hide('settings');
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this2.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    updateombrello: function updateombrello() {
      var _this3 = this;

      console.log(this.ombrellos);
      console.log(this.range['endDate']);
      this.ombrellos.free = false;
      this.ombrellos.arrival = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.range.startDate._d).format('DD.MM.YYYY');
      this.ombrellos.departure = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.range.endDate._d).format('DD.MM.YYYY');
      this.editombrid = false;
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/api/updateombrello', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this3.$modal.hide('hello-world');
        _this3.getOmbrelli();
      }, function (error) {
        console.log(error);
        _this3.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    moveombrello: function moveombrello(old, newo) {
      var _this4 = this;

      console.log(old, newo);
      // this.ombrellos = old
      // this.closeombrello()
      // old._id = newo
      // old.ombrid = ombrid
      // console.log(this.ombrellos)
      // this.ombrellos = newo
      this.$http.post(host + '/api/moveombrello', { old: old, newo: newo }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this4.dragging = null;
        _this4.getOmbrelli();
      }, function (error) {
        console.log(error);
        _this4.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    closeombrello: function closeombrello() {
      var _this5 = this;

      console.log(this.ombrellos);
      console.log(this.date);
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/ombrelloni/close', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this5.$modal.hide('hello-world');
        _this5.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },
    addombrell: function addombrell() {
      var _this6 = this;

      console.log(this.addombrello, this.hotelid);
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/ombrelloni/add', { ombrid: 'pool', hotelid: this.hotelid, location: this.location }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this6.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },
    editguest: function editguest(index) {
      console.log(index.ombrid, index.edit);
      index.edit = true;
      // Vue.set(this.ombrelli[index], 'edit', true)
    },
    saveEdit: function saveEdit(index, guest) {
      // save your changes
      // this.toggleEdit(index, guest)
      console.log(index, guest);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.ombrelli[index], 'guest', guest);
    },
    getOmbrelli: function getOmbrelli() {
      var _this7 = this;

      // console.log(localStorage.access_token)
      // this.$i18n.locale = 'en'
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized/richards',
      // .get('http://localhost:8000/authorized/' + this.$route.params.hotel,
      // .post(host + '/ombrelloni', { userid: localStorage.userid },
      .post(host + '/ombrelloni/pool', { hotelid: this.$route.params.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data.body);
        _this7.hotelid = data.body.hotels._id;
        _this7.hotel = data.body.hotels;
        if (data.body.hotels.chairs === undefined) {
          _this7.hotel.chairs = 1;
        }
        if (data.body.hotels.beds === undefined) {
          _this7.hotel.beds = 1;
        }
        _this7.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', 284px);';
        // console.log('hotel: ' + this.hotelid)
        // console.log(data)
        _this7.ombrelli = data.body.ombrells;
        _this7.loading = false;
        _this7.$notify({
          group: 'foo',
          title: 'Hoteldata loaded',
          text: 'You are good to go',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
        _this7.$router.replace('/');
      });
    },
    addchair: function addchair(index, nr, chair, hotel) {
      var _this8 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addchair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this8.ombrelli[index], 'chairs', newchairs);
        _this8.$notify({
          group: 'foo',
          title: 'Chair added',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
      });
    },
    removechair: function removechair(index, nr, chair, hotel) {
      var _this9 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removechair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this9.ombrelli[index], 'chairs', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    addbed: function addbed(index, nr, chair, hotel) {
      var _this10 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addbed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this10.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    removebed: function removebed(index, nr, chair, hotel) {
      var _this11 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removebed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this11.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    changeguest: function changeguest(index, chair, guest) {
      console.log(this.ombrelli);
      console.log(index, chair, guest);
      // var newchairs = nr - 1
      // this.$http
      //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
      //   {
      //     headers: {
      //       'Authorization': 'Bearer ' + localStorage.jwt
      //     }
      //   },
      //   ).then((data) => {
      //     console.log(data)
      //     // this.loading = false
      //     Vue.set(this.ombrelli[index], 'beds', newchairs)
      //   }, (error) => {
      //     console.log(error)
      //   })
    }
  },
  beforeMount: function beforeMount() {
    this.getOmbrelli();
  },

  computed: {
    hotelgrid: function hotelgrid() {
      // `this` points to the vm instance
      return this.hotel.cols * this.hotel.rows;
    },
    userLastCount: function userLastCount() {
      console.log(this.ombrells);
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_range__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_range__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_de__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_it__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Navbar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var moment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_5_moment___default.a);


var host = "https://dexter.node.systems:44537";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ombrelli',
  props: ['auth', 'authenticated', 'hotel'],
  data: function data() {
    return {
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      letters: {
        first: 'A',
        last: '',
        act: 0,
        row: 1
      },
      formel: {
        password: ''
      },
      rules: {
        password: [{ required: true, message: 'prego inserisci una password', trigger: 'blur' }, { min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }]
      },
      modal: {
        width: '70%',
        height: 'auto'
      },
      beachitem: {
        name: '',
        icon: ''
      },
      addbeachitem: false,
      numbers: {
        first: 1,
        last: 0,
        act: 0
      },
      query: '',
      filtered: '',
      loading: false,
      nogrid: false,
      grid: {
        direction: '',
        letter: true,
        number: true,
        firststep: false,
        active: 0
      },
      state1: '',
      passForm: false,
      calcform: false,
      langs: [{
        lang: 'it'
      }, {
        lang: 'de'
      }],
      // hotel: '',
      secret: '',
      // pregrid: '',
      ombrelli: [],
      style: '',
      dialogVisible: false,
      rangestyle: '',
      hotelid: '',
      ombrellos: '',
      addombrello: {
        ombrid: ''
      },
      overview: {
        arrivals: [],
        departures: [],
        stays: []
      },
      date: ['2016-10-16', '2024-10-05'],
      today: moment().format('YYYY-MM-DD'),
      lang: 'it',
      range: {
        startDate: moment(),
        endDate: moment().add(7, 'days')
        // startDate: '2019-04-03',
        // endDate: '2019-04-10'
      },
      rangepicker: [],
      rangeviewdata: '',
      // disabledRange: {
      //   startDate: moment(),
      //   endDate: moment().add(9, 'days')
      // },
      disabledDates: [],
      datePickerOptions: {
        firstDayOfWeek: 1
      },
      firstDayOfWeek: 1,
      editombrid: false,
      dragging: null,
      lock: null,
      location: 'beach',
      rangeview: false
    };
  },

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_date___default.a,
    Circle4: __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__["b" /* Circle4 */],
    DateRange: __WEBPACK_IMPORTED_MODULE_4_vue_date_range__["DateRange"],
    'Navbar': __WEBPACK_IMPORTED_MODULE_10__components_Navbar___default.a,
    Drag: __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__["Drag"],
    Drop: __WEBPACK_IMPORTED_MODULE_11_vue_drag_drop__["Drop"]
    // EmbeddedSlack
    // chat
  },
  sockets: {
    connect: function connect() {
      console.log('socket connected');
    },
    stream: function stream(val) {
      // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      // console.log(val.hotelid)
      if (val.hotelid === this.hotelid) {
        console.log('an umbrella was updated');
        this.getOmbrelli();
      }
    },
    disconnect: function disconnect() {
      console.log('socket error');
      this.$notify({
        group: 'foo',
        title: 'Error loading Data',
        text: 'I´ll fix it in a few',
        type: 'warning',
        duration: 5000
      });
    }
  },
  methods: {
    deleteHotel: function deleteHotel() {
      var _this = this;

      console.log('hotel: ', this.hotel);
      this.$http.post(host + '/api/deletehotel', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this.$notify({
          group: 'foo',
          title: _this.hotel.name + ' deleted',
          type: 'info',
          duration: 500
        });
        __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push('/hotel');
      }, function (error) {
        console.log(error);
      });
    },
    updatebeachitems: function updatebeachitems() {
      console.log('add beachitem');
    },
    deletebeachitem: function deletebeachitem(index) {
      console.log(index);
      this.hotel.items.splice(index, 1);
    },
    stepHandler: function stepHandler(e, i) {
      console.log(e, i);
      this.grid.active = i;
    },
    nextStep: function nextStep() {
      this.grid.active++;
    },
    previousStep: function previousStep() {
      if (this.grid.active === 2) {
        this.ombrelli = [];
        this.grid.direction = '';
        this.grid.active = 0;
      } else {
        this.grid.active--;
      }
    },
    filter: function filter(query) {
      var _this2 = this;

      console.log(this.query, this.overview.arrivals.filter(function (item) {
        return item.ombrid === _this2.query;
      }));
      this.filtered = this.overview.arrivals.filter(function (item) {
        return item.guest.name === _this2.query;
      });
    },

    // querySearch (queryString, cb) {
    //   var links = this.linkst
    //   var results = queryString ? links.filter(this.createFilter(queryString)) : links
    //   // call callback function to return suggestions
    //   console.log(results)
    //   cb(results)
    // },
    // createFilter (queryString) {
    //   return (link) => {
    //     // console.log(link, queryString)
    //     return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
    //   }
    // },
    handleSelect: function handleSelect(item) {
      console.log(item);
    },

    disabledFunc: function disabledFunc(dayMoment) {
      // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
      // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
      if (this.disabledDates.includes(moment(dayMoment).format('YYYY-MM-DD'))) {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return true;
      } else {
        // console.log(moment(dayMoment).format('YYYY-MM-DD'))
        return false;
      }
    },
    preCheckDate: function preCheckDate() {
      var _this3 = this;

      // console.log('ombrellos: ', this.ombrellos)
      // console.log(date)
      console.log('preCheckDate');
      this.disabledDates = [];
      this.ombrellos.guests.forEach(function (guest, indexo) {
        // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // console.log('guest: ', guest.name, 'ombrello guest: ', this.ombrellos.guest)
        if (guest.name !== _this3.ombrellos.guest) {
          var start = moment(guest.arrival, 'YYYY-MM-DD').add('days', 1);
          var end = moment(guest.departure, 'YYYY-MM-DD');
          // console.log('guest name: ', guest.name, 'start: ', start, 'end: ', end)
          var range = moment.range(start, end);
          var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days', { excludeStart: true, excludeEnd: true })).map(function (m) {
            return m.format('YYYY-MM-DD');
          });
          // this.disabledDates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
          Array.prototype.push.apply(_this3.disabledDates, dates);
          console.log('guest: ', guest.name, dates);
        }
      });
    },

    // checkDate (date) {
    // console.log(moment(date).format('YYYY-MM-DD'))
    // date = moment(date).format('YYYY-MM-DD')
    // return moment(date).isBetween(moment(this.ombrellos.arrival), moment(this.ombrellos.departure))
    // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
    // if (moment(date).isBetween(moment('2019-04-12'), moment('2019-04-14'))) {
    //   return true
    // } else {
    //   return false
    // }
    // this.ombrellos.guests.forEach(function (guest, indexo) {
    //   console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
    //   if (moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12'))) {
    //     return true
    //   } else {
    //     return false
    //   }
    // })
    // },
    handleDragover: function handleDragover(group, data, event) {
      // console.log(data)
      // console.log(group.ombrid)
      // console.log(event)
      if (!group.free) {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleDrop: function handleDrop(group, data, key) {
      console.log(group.ombrello.ombrid, data.target.id);
      this.moveombrello(group.ombrello, data.target.id);
      // alert(`You dropped with data: ${JSON.stringify(data)}`)
    },
    changeombrid: function changeombrid() {
      console.log('changeombrid');
      this.editombrid = true;
    },
    onChange: function onChange(range) {
      this.range = range;
      console.log(moment(range.endDate._d));
    },
    setRange: function setRange(p) {
      if (typeof p === 'number') {
        console.log(p);
        this.range = {
          startDate: moment().add(p, 'days'),
          endDate: moment()
        };
      }
    },
    show: function show(ombrello) {
      console.log(ombrello.arrival);
      this.ombrellos = ombrello;
      if (ombrello.free) {
        this.ombrellos.chairs = this.hotel.chairs;
        this.ombrellos.beds = this.hotel.beds;
      }
      // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
      this.date[0] = ombrello.arrival;
      this.date[1] = ombrello.departure;
      // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
      if (ombrello.arrival) {
        console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'));
        this.range.startDate = moment(ombrello.arrival);
      }
      if (ombrello.departure) {
        this.range.endDate = moment(ombrello.departure);
      }
      this.preCheckDate();
      this.$modal.show('hello-world');
    },
    hide: function hide() {
      this.$modal.hide('hello-world');
    },
    settings: function settings() {
      this.$modal.show('settings');
    },

    updatehotel: function updatehotel() {
      var _this4 = this;

      this.$http.post(host + '/api/updatehotel', { hotel: this.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this4.$modal.hide('settings');
        // this.getOmbrelli()
      }, function (error) {
        console.log(error);
        _this4.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    changepassword: function changepassword(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('passreset');
          _this5.loading = true;
          // this.error.state = false
          _this5.$http.post(host + '/changepassword', { password: _this5.formel.password }, {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }).then(function (data) {
            // this.ombrelli = data.body.ombrells
            console.log(data);
            _this5.loading = false;
            // this.success.state = true
            // this.success.message = data.body.success
            // localStorage.setItem('jwt', data.body.jwt)
            // localStorage.setItem('profile', data.body.profile)
            // router.replace('Hotel')
            // this.loading = false
            // this.getHotel()
          }, function (error) {
            console.log(error);
            _this5.loading = false;
            // this.error.state = true
            // this.error.message = error.body.error
          });
        } else {
          console.log('error submit!!');
          // return false
        }
      });
    },

    saveOmbrello: function saveOmbrello() {
      var _this6 = this;

      console.log(this.ombrellos);
      console.log(this.range['endDate']);
      this.$delete(this.ombrellos, '__v');
      this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD');
      this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD');
      this.editombrid = false;
      // if (this.ombrellos.free && this.ombrellos.ombrid === this.ombrelli) {
      //   console.log(this.ombrellos.ombrid + ' is free so i am not updating guest data')
      //   // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
      // } else {
      //   console.log(this.ombrellos.ombrid + ' has a new guest')
      //   this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
      // }
      this.ombrellos.guests.push({ name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure });
      this.ombrellos.guest = '';
      this.ombrellos.room = '';
      this.ombrellos.arrival = '';
      this.ombrellos.departure = '';
      this.ombrellos.guestsinday = [];
      this.ombrellos.free = true;
      console.log('ombrello: ', this.ombrellos.ombrid, this.ombrellos.guests);
      this.$http.post(host + '/api/updateombrello', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this6.$modal.hide('hello-world');
        _this6.getOmbrelli();
      }, function (error) {
        console.log(error);
        _this6.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    updateombrello: function updateombrello() {
      var _this7 = this;

      console.log(this.ombrellos);
      console.log(this.range['endDate']);
      this.$delete(this.ombrellos, '__v');
      this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD');
      this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD');
      this.editombrid = false;
      // this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
      if (this.ombrellos.free) {
        console.log(this.ombrellos.guests[this.ombrellos.guestnr] + ' is free so i am not updating guest data');
        // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
      } else {
        this.ombrellos.guests[this.ombrellos.guestnr] = { name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure };
      }
      this.ombrellos.guest = '';
      this.ombrellos.room = '';
      this.ombrellos.arrival = '';
      this.ombrellos.departure = '';
      this.ombrellos.guestsinday = [];
      this.ombrellos.free = true;
      console.log('ombrello update: ', this.ombrellos);
      this.$http.post(host + '/api/updateombrello', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this7.$modal.hide('hello-world');
        _this7.getOmbrelli();
      }, function (error) {
        console.log(error);
        _this7.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    moveombrello: function moveombrello(old, newo) {
      var _this8 = this;

      console.log(old, newo);
      // this.ombrellos = old
      // this.closeombrello()
      // old._id = newo
      // old.ombrid = ombrid
      // console.log(this.ombrellos)
      // this.ombrellos = newo
      this.$http.post(host + '/api/moveombrello', { old: old, newo: newo }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // console.log(data)
        _this8.dragging = null;
        _this8.getOmbrelli();
      }, function (error) {
        console.log(error);
        _this8.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 500
        });
      });
    },
    closeombrello: function closeombrello(index) {
      var _this9 = this;

      console.log(this.ombrellos.guests, index);
      this.ombrellos.guests.splice(index, 1);
      console.log('updated: ', this.ombrellos.guests);
      this.ombrellos.guest = '';
      this.ombrellos.room = '';
      this.ombrellos.arrival = '';
      this.ombrellos.departure = '';
      this.ombrellos.free = true;
      this.$http.post(host + '/ombrelloni/close', { ombrellos: this.ombrellos }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this9.$modal.hide('hello-world');
        _this9.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },

    addombrell: function addombrell() {
      var _this10 = this;

      console.log(this.addombrello, this.hotelid);
      this.$http
      // .get('http://srv5.ghosted.it:8000/authorized',
      // var ombrellos = this.ombrellos
      .post(host + '/ombrelloni/add', { ombrid: this.addombrello.ombrid, hotelid: this.hotelid, location: this.location }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        // this.ombrelli = data.body.ombrells
        console.log(data);
        _this10.getOmbrelli();
      }, function (error) {
        console.log(error);
      });
    },
    editguest: function editguest(index) {
      console.log(index.ombrid, index.edit);
      index.edit = true;
      // Vue.set(this.ombrelli[index], 'edit', true)
    },
    saveEdit: function saveEdit(index, guest) {
      // save your changes
      // this.toggleEdit(index, guest)
      console.log(index, guest);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.ombrelli[index], 'guest', guest);
    },
    // presetGrid () {
    //   var grid = this.hotel.cols * this.hotel.rows
    //   if (this.ombrelli.length === grid) {
    //     console.log('preset grid done')
    //   } else {
    //     console.log('preset grid not yet done')
    //     if (this.numbers.first < 10) {
    //       this.pregrid = {
    //         first: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         },
    //         left: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         },
    //         up: {
    //           letter: this.letters.first,
    //           number: '0' + this.numbers.first
    //         }
    //       }
    //     } else {
    //       this.pregrid = {
    //         first: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         },
    //         left: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         },
    //         up: {
    //           letter: this.letters.first,
    //           number: this.numbers.first
    //         }
    //       }
    //     }
    //   }
    // },
    resetGrid: function resetGrid() {
      this.ombrelli = [];
      this.grid.firststep = true;
      this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
      this.letters.row = 1;
      this.numbers.act = this.numbers.first;
      this.grid.active = 2;
      if (this.letters.first.length === 0 || this.grid.direction === 'empty') {
        this.setemptyGrid();
      } else {
        this.setGrid();
      }
    },
    setemptyGrid: function setemptyGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      console.log('ombrelli length', this.ombrelli.length + 1, 'numbers act: ', this.numbers.act);
      if (this.ombrelli.length === grid) {
        console.log('done');
      } else {
        if (grid > 99 && this.numbers.act <= 9) {
          console.log('case: 1');
          this.ombrelli.push({ ombrid: '00' + parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        } else if (grid > 99 && this.numbers.act <= 99) {
          console.log('case: 2');
          this.ombrelli.push({ ombrid: '0' + parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        } else {
          console.log('case: 3');
          this.ombrelli.push({ ombrid: parseInt(this.numbers.act), free: true });
          this.numbers.act++;
        }
        this.setemptyGrid();
      }
    },
    setGrid: function setGrid() {
      var grid = this.hotel.cols * this.hotel.rows;
      // console.log(this.letters.first)
      if (this.letters.act === this.alphabet.length) {
        this.letters.act = 0;
      }
      var act = this.alphabet[this.letters.act].toUpperCase();
      console.log('act: ', act, this.numbers.act);
      if (this.ombrelli.length === grid) {
        console.log('done');
      } else {
        // console.log('not done')
        if (this.numbers.act < 10) {
          this.ombrelli.push({ ombrid: act + '0' + this.numbers.act, free: true });
          console.log('nr: ', act + '0' + this.numbers.act);
          if (this.grid.direction === 'left') {
            this.numbers.act++;
          } else {
            this.letters.act++;
          }
          if (this.ombrelli.length === this.hotel.cols * this.letters.row) {
            if (this.grid.direction === 'left') {
              this.numbers.act = this.numbers.first;
              this.letters.row++;
              this.letters.act++;
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
              this.numbers.act++;
              this.letters.row++;
            }
            console.log('end of row', this.letters.row - 1, this.numbers.act);
          } else {}
          this.setGrid();
        } else {
          this.ombrelli.push({ ombrid: act + this.numbers.act, free: true });
          console.log('nr: ', act + this.numbers.act);
          if (this.grid.direction === 'left') {
            this.numbers.act++;
          } else {
            this.letters.act++;
          }
          if (this.ombrelli.length === this.hotel.cols * this.letters.row) {
            if (this.grid.direction === 'left') {
              this.numbers.act = this.numbers.first;
              this.letters.row++;
              this.letters.act++;
            } else {
              this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase());
              this.numbers.act++;
              this.letters.row++;
            }
            console.log('end of row', this.letters.row - 1, this.numbers.act);
          } else {}
          this.setGrid();
        }
        // if (this.numbers.first < 10) {
        //   this.ombrelli.push({ombrid: act + '0' + this.numbers.first, free: true})
        //   this.letters.act = this.alphabet.indexOf(act) + 1
        //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //     this.letters.act = 0
        //     this.letters.row = this.letters.row + 1
        //   }
        //   this.setGrid()
        // } else {
        //   this.ombrelli.push({ombrid: act + this.numbers.first, free: true})
        //   this.letters.act = this.alphabet.indexOf(act) + 1
        //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //     this.letters.act = 0
        //     this.letters.row = this.letters.row + 1
        //   }
        //   this.setGrid()
        // }
      }
      // var grid = this.hotel.cols * this.hotel.rows
      // console.log(this.letters.first)
      // var act = this.alphabet[this.letters.act]
      // console.log('act: ', act)
      // if (this.ombrelli.length === grid) {
      //   console.log('done')
      // } else {
      //   console.log('not done')
      //   if (this.hotel.rows > 10 && this.letters.row < 10) {
      //     this.ombrelli.push({ombrid: act + '0' + this.letters.row, free: true})
      //     this.letters.act = this.alphabet.indexOf(act) + 1
      //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
      //       this.letters.act = 0
      //       this.letters.row = this.letters.row + 1
      //     }
      //     this.setGrid()
      //   } else {
      //     this.ombrelli.push({ombrid: act + this.letters.row, free: true})
      //     this.letters.act = this.alphabet.indexOf(act) + 1
      //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
      //       this.letters.act = 0
      //       this.letters.row = this.letters.row + 1
      //     }
      //     this.setGrid()
      //   }
      // }
    },

    saveGrid: function saveGrid() {
      var _this11 = this;

      console.log(this.ombrelli);
      this.$http.post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        _this11.getOmbrelli();
        _this11.nogrid = false;
      }, function (error) {
        console.log(error);
        _this11.$notify({
          group: 'foo',
          title: 'grid saved',
          type: 'success',
          duration: 500
        });
      });
    },
    changeDate: function changeDate() {
      console.log(moment(this.today).format('YYYY-MM-DD'));
      this.today = moment(this.today).format('YYYY-MM-DD');
      this.getOmbrelli();
      this.rangeview = false;
    },
    changeRange: function changeRange() {
      var _this12 = this;

      // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
      var start = moment(this.rangepicker[0], 'YYYY-MM-DD');
      var end = moment(this.rangepicker[1], 'YYYY-MM-DD');
      var range = moment.range(start, end);
      var dates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(range.by('days')).map(function (m) {
        return m.format('YYYY-MM-DD');
      });
      // console.log('range picker dates: ', dates)
      this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);';
      this.rangeviewdata = dates;
      this.rangeview = true;
      this.ombrelli.forEach(function (ombrello, indexo) {
        // console.log('ombrello: ', ombrello)
        // this.ombrelli.push(ombrello)
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this12.ombrelli[indexo], 'dates', []);
        // ombrello.guests.forEach((guest, index) => {
        // console.log('guest: ', guest)
        // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
        dates.forEach(function (date, indexd) {
          _this12.ombrelli[indexo].dates.push({ date: moment(date).format('DD/MM'), day: moment(date).format('dd'), guests: [], free: true });
          ombrello.guests.forEach(function (guest, index) {
            if (moment(date).isBetween(guest.arrival, guest.departure, null, '[]')) {
              console.log(ombrello.ombrid + ' is occupied on ' + date);
              // this.ombrelli[indexo].dates.push({date: date, guest: guest})
              _this12.ombrelli[indexo].dates[indexd].guests.push(guest);
              _this12.ombrelli[indexo].dates[indexd].free = false;
            } else {
              // console.log(ombrello.ombrid + ' is free on ' + this.today)
              console.log(ombrello.ombrid + ' is free on ' + date);
              // this.ombrelli[indexo].free = true
              // this.ombrelli[indexo].dates.push({date: date, guest: guest})
            }
          });
        });
      });
    },
    getOmbrelli: function getOmbrelli() {
      var _this13 = this;

      this.$http.post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log('hotel: ', data.body.ombrells);
        // this.hotelid = data.body.hotels._id
        // this.hotel = data.body.hotels
        moment.locale(data.body.hotels.lang);
        if (data.body.hotels.chairs === undefined) {
          _this13.hotel.chairs = 1;
        }
        if (data.body.hotels.beds === undefined) {
          _this13.hotel.beds = 1;
        }
        // this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);'
        // console.log('hotel: ' + this.hotelid)
        // console.log(data)
        // this.ombrelli = data.body.ombrells
        // console.log(this.today)
        // this.ombrelli = []
        // data.body.ombrells.forEach((ombrello, indexo) => {
        //   this.ombrelli.push(ombrello)
        //   ombrello.guests.forEach((guest, index) => {
        //     console.log('guest: ', guest)
        //     if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '[]')) {
        //       console.log(ombrello.ombrid + ' is occupied between ' + guest.arrival + ' and ' + guest.departure)
        //       this.ombrelli[indexo].guest = guest.name
        //       this.ombrelli[indexo].room = guest.room
        //       this.ombrelli[indexo].arrival = guest.arrival
        //       this.ombrelli[indexo].departure = guest.departure
        //       this.ombrelli[indexo].free = false
        //       this.ombrelli[indexo].guestnr = index
        //       this.ombrelli[indexo].guestsinday.push(guest)
        //     } else {
        //     }
        //   })
        // })
        // this.getOverview()
        // if (!this.hotel.firststep && data.body.ombrells <= 0) {
        //   this.nogrid = true
        // }
        _this13.loading = false;
      }, function (error) {
        console.log(error);
        _this13.$router.replace('/');
      });
    },
    getOverview: function getOverview() {
      var _this14 = this;

      this.overview.arrivals = [];
      this.overview.departures = [];
      this.overview.stays = [];
      this.ombrelli.forEach(function (ombrello, indexo) {
        // console.log('ombrello: ', ombrello)
        // this.ombrelli.push(ombrello)
        ombrello.guests.forEach(function (guest, index) {
          console.log('guest: ', guest);
          // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
          if (moment(_this14.today).isSame(guest.arrival)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
            console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival);
            _this14.overview.arrivals.push({ guest: guest, ombrid: ombrello.ombrid });
          } else if (moment(_this14.today).isSame(guest.departure)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
            console.log(ombrello.ombrid + ' is starting today: ' + guest.departure);
            _this14.overview.departures.push({ guest: guest, ombrid: ombrello.ombrid });
          } else if (moment(_this14.today).isBetween(guest.arrival, guest.departure, null, '()')) {
            console.log(ombrello.ombrid + ' is staying here today: ' + guest.departure);
            _this14.overview.stays.push({ guest: guest, ombrid: ombrello.ombrid });
          }
        });
      });
    },
    addchair: function addchair(index, nr, chair, hotel) {
      var _this15 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addchair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this15.ombrelli[index], 'chairs', newchairs);
        _this15.$notify({
          group: 'foo',
          title: 'Chair added',
          type: 'success',
          duration: 500
        });
      }, function (error) {
        console.log(error);
      });
    },
    removechair: function removechair(index, nr, chair, hotel) {
      var _this16 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removechair/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this16.ombrelli[index], 'chairs', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    addbed: function addbed(index, nr, chair, hotel) {
      var _this17 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr + 1;
      this.$http.post(host + '/api/addbed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this17.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    removebed: function removebed(index, nr, chair, hotel) {
      var _this18 = this;

      console.log(this.ombrelli);
      console.log(index, chair, hotel);
      var newchairs = nr - 1;
      this.$http.post(host + '/api/removebed/' + chair, { chairid: chair, hotelid: hotel }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.jwt
        }
      }).then(function (data) {
        console.log(data);
        // this.loading = false
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this18.ombrelli[index], 'beds', newchairs);
      }, function (error) {
        console.log(error);
      });
    },
    changeguest: function changeguest(index, chair, guest) {
      console.log(this.ombrelli);
      console.log(index, chair, guest);
      // var newchairs = nr - 1
      // this.$http
      //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
      //   {
      //     headers: {
      //       'Authorization': 'Bearer ' + localStorage.jwt
      //     }
      //   },
      //   ).then((data) => {
      //     console.log(data)
      //     // this.loading = false
      //     Vue.set(this.ombrelli[index], 'beds', newchairs)
      //   }, (error) => {
      //     console.log(error)
      //   })
    }
  },
  beforeMount: function beforeMount() {
    // this.getOmbrelli()
    // this.letters.act = this.alphabet.indexOf(this.letters.first)
  },

  mounted: function mounted() {
    // this.getOverview()
    // moment.locale(this.hotel.lang)
    // console.log('hotel: ', this.hotel)
  },
  computed: {
    hotelgrid: function hotelgrid() {
      // `this` points to the vm instance
      this.numbers.last = this.hotel.cols * this.hotel.rows;
      return this.hotel.cols * this.hotel.rows;
    },
    state: function state() {
      // console.log('today: ', this.today)
    },
    filteredArrivals: function filteredArrivals() {
      var _this19 = this;

      console.log('filteredArrivals');
      return this.overview.arrivals.filter(function (post) {
        var arrivals = post.guest.name.toLowerCase().includes(_this19.query.toLowerCase());
        var arrivalsroom = post.guest.room.toLowerCase().includes(_this19.query.toLowerCase());
        console.log(arrivals);
        if (arrivals) {
          return arrivals;
        } else {
          return arrivalsroom;
        }
      });
    },
    filteredDepartures: function filteredDepartures() {
      var _this20 = this;

      return this.overview.departures.filter(function (post) {
        var departures = post.guest.name.toLowerCase().includes(_this20.query.toLowerCase());
        var departuresroom = post.guest.room.toLowerCase().includes(_this20.query.toLowerCase());
        if (departures) {
          return departures;
        } else {
          return departuresroom;
        }
      });
    },
    filteredStays: function filteredStays() {
      var _this21 = this;

      return this.overview.stays.filter(function (post) {
        var stays = post.guest.name.toLowerCase().includes(_this21.query.toLowerCase());
        var staysroom = post.guest.room.toLowerCase().includes(_this21.query.toLowerCase());
        if (stays) {
          return stays;
        } else {
          return staysroom;
        }
      });
    },
    pregrid: function pregrid() {
      var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1;
      if (this.letters.first.length > 0) {
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.numbers.first) + 1 } };
        }
      } else {
        console.log('no letter', this.hotel.cols);
        if (this.numbers.first < 10) {
          return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } };
        } else {
          return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: parseInt(this.numbers.first) + 1 }, up: { letter: this.alphabet[next].toUpperCase(), number: this.hotel.cols + 1 }, upleft: { letter: this.alphabet[next].toUpperCase(), number: parseInt(this.hotel.cols) + 1 } };
        }
      }
    }
  }
});

/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 119,
	"./af.js": 119,
	"./ar": 126,
	"./ar-dz": 120,
	"./ar-dz.js": 120,
	"./ar-kw": 121,
	"./ar-kw.js": 121,
	"./ar-ly": 122,
	"./ar-ly.js": 122,
	"./ar-ma": 123,
	"./ar-ma.js": 123,
	"./ar-sa": 124,
	"./ar-sa.js": 124,
	"./ar-tn": 125,
	"./ar-tn.js": 125,
	"./ar.js": 126,
	"./az": 127,
	"./az.js": 127,
	"./be": 128,
	"./be.js": 128,
	"./bg": 129,
	"./bg.js": 129,
	"./bm": 130,
	"./bm.js": 130,
	"./bn": 131,
	"./bn.js": 131,
	"./bo": 132,
	"./bo.js": 132,
	"./br": 133,
	"./br.js": 133,
	"./bs": 134,
	"./bs.js": 134,
	"./ca": 135,
	"./ca.js": 135,
	"./cs": 136,
	"./cs.js": 136,
	"./cv": 137,
	"./cv.js": 137,
	"./cy": 138,
	"./cy.js": 138,
	"./da": 139,
	"./da.js": 139,
	"./de": 28,
	"./de-at": 140,
	"./de-at.js": 140,
	"./de-ch": 141,
	"./de-ch.js": 141,
	"./de.js": 28,
	"./dv": 142,
	"./dv.js": 142,
	"./el": 143,
	"./el.js": 143,
	"./en-SG": 144,
	"./en-SG.js": 144,
	"./en-au": 145,
	"./en-au.js": 145,
	"./en-ca": 146,
	"./en-ca.js": 146,
	"./en-gb": 147,
	"./en-gb.js": 147,
	"./en-ie": 148,
	"./en-ie.js": 148,
	"./en-il": 149,
	"./en-il.js": 149,
	"./en-nz": 150,
	"./en-nz.js": 150,
	"./eo": 151,
	"./eo.js": 151,
	"./es": 154,
	"./es-do": 152,
	"./es-do.js": 152,
	"./es-us": 153,
	"./es-us.js": 153,
	"./es.js": 154,
	"./et": 155,
	"./et.js": 155,
	"./eu": 156,
	"./eu.js": 156,
	"./fa": 157,
	"./fa.js": 157,
	"./fi": 158,
	"./fi.js": 158,
	"./fo": 159,
	"./fo.js": 159,
	"./fr": 162,
	"./fr-ca": 160,
	"./fr-ca.js": 160,
	"./fr-ch": 161,
	"./fr-ch.js": 161,
	"./fr.js": 162,
	"./fy": 163,
	"./fy.js": 163,
	"./ga": 164,
	"./ga.js": 164,
	"./gd": 165,
	"./gd.js": 165,
	"./gl": 166,
	"./gl.js": 166,
	"./gom-latn": 167,
	"./gom-latn.js": 167,
	"./gu": 168,
	"./gu.js": 168,
	"./he": 169,
	"./he.js": 169,
	"./hi": 170,
	"./hi.js": 170,
	"./hr": 171,
	"./hr.js": 171,
	"./hu": 172,
	"./hu.js": 172,
	"./hy-am": 173,
	"./hy-am.js": 173,
	"./id": 174,
	"./id.js": 174,
	"./is": 175,
	"./is.js": 175,
	"./it": 29,
	"./it-ch": 176,
	"./it-ch.js": 176,
	"./it.js": 29,
	"./ja": 177,
	"./ja.js": 177,
	"./jv": 178,
	"./jv.js": 178,
	"./ka": 179,
	"./ka.js": 179,
	"./kk": 180,
	"./kk.js": 180,
	"./km": 181,
	"./km.js": 181,
	"./kn": 182,
	"./kn.js": 182,
	"./ko": 183,
	"./ko.js": 183,
	"./ku": 184,
	"./ku.js": 184,
	"./ky": 185,
	"./ky.js": 185,
	"./lb": 186,
	"./lb.js": 186,
	"./lo": 187,
	"./lo.js": 187,
	"./lt": 188,
	"./lt.js": 188,
	"./lv": 189,
	"./lv.js": 189,
	"./me": 190,
	"./me.js": 190,
	"./mi": 191,
	"./mi.js": 191,
	"./mk": 192,
	"./mk.js": 192,
	"./ml": 193,
	"./ml.js": 193,
	"./mn": 194,
	"./mn.js": 194,
	"./mr": 195,
	"./mr.js": 195,
	"./ms": 197,
	"./ms-my": 196,
	"./ms-my.js": 196,
	"./ms.js": 197,
	"./mt": 198,
	"./mt.js": 198,
	"./my": 199,
	"./my.js": 199,
	"./nb": 200,
	"./nb.js": 200,
	"./ne": 201,
	"./ne.js": 201,
	"./nl": 203,
	"./nl-be": 202,
	"./nl-be.js": 202,
	"./nl.js": 203,
	"./nn": 204,
	"./nn.js": 204,
	"./pa-in": 205,
	"./pa-in.js": 205,
	"./pl": 206,
	"./pl.js": 206,
	"./pt": 208,
	"./pt-br": 207,
	"./pt-br.js": 207,
	"./pt.js": 208,
	"./ro": 209,
	"./ro.js": 209,
	"./ru": 210,
	"./ru.js": 210,
	"./sd": 211,
	"./sd.js": 211,
	"./se": 212,
	"./se.js": 212,
	"./si": 213,
	"./si.js": 213,
	"./sk": 214,
	"./sk.js": 214,
	"./sl": 215,
	"./sl.js": 215,
	"./sq": 216,
	"./sq.js": 216,
	"./sr": 218,
	"./sr-cyrl": 217,
	"./sr-cyrl.js": 217,
	"./sr.js": 218,
	"./ss": 219,
	"./ss.js": 219,
	"./sv": 220,
	"./sv.js": 220,
	"./sw": 221,
	"./sw.js": 221,
	"./ta": 222,
	"./ta.js": 222,
	"./te": 223,
	"./te.js": 223,
	"./tet": 224,
	"./tet.js": 224,
	"./tg": 225,
	"./tg.js": 225,
	"./th": 226,
	"./th.js": 226,
	"./tl-ph": 227,
	"./tl-ph.js": 227,
	"./tlh": 228,
	"./tlh.js": 228,
	"./tr": 229,
	"./tr.js": 229,
	"./tzl": 230,
	"./tzl.js": 230,
	"./tzm": 232,
	"./tzm-latn": 231,
	"./tzm-latn.js": 231,
	"./tzm.js": 232,
	"./ug-cn": 233,
	"./ug-cn.js": 233,
	"./uk": 234,
	"./uk.js": 234,
	"./ur": 235,
	"./ur.js": 235,
	"./uz": 237,
	"./uz-latn": 236,
	"./uz-latn.js": 236,
	"./uz.js": 237,
	"./vi": 238,
	"./vi.js": 238,
	"./x-pseudo": 239,
	"./x-pseudo.js": 239,
	"./yo": 240,
	"./yo.js": 240,
	"./zh-cn": 241,
	"./zh-cn.js": 241,
	"./zh-hk": 242,
	"./zh-hk.js": 242,
	"./zh-tw": 243,
	"./zh-tw.js": 243
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 536;

/***/ }),
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(652),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a333d36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b8ecaca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(622),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(623),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(653),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(654),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a8a93e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(612),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03594801",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03675f82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(647),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5240dc80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5224ad7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52087e7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51ec4f7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51d02078",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51b3f176",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5197c274",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-517b9372",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(616),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f1d0572",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52d38cb2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18a8f4cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-055a5b57",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-614058cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b82f4904",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(619),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17f40fd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ea52e40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e5b7226",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c81960d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(630),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3937ffbb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7da018c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-261a04c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(615),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06c6b81c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c737098c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b1befc2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d0764b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d157c39",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d2393ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d31ab3b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(617),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13754836",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(658),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-82c425f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8f3ce30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81348ad6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(621),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ad611e3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d8e04f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(618),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1613d234",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36e8f17f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24e9040b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-10",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('div', {
    staticClass: "loader-xbox"
  })])])
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-11",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--gauge",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--ping-pong",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "ball"
  })])
}]}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--cube-shadow",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--scale-out",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "blob top",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob bottom",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob left",
    style: (_vm.blobStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "blob move-blob",
    style: (_vm.moveBlobStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--hour-glass",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('svg', {
    staticClass: "hourglass",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 206",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    staticClass: "middle",
    attrs: {
      "d": "M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "outer",
    attrs: {
      "d": "M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--double-bounce",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "double-bounce1",
    style: (_vm.bounceStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2",
    style: (_vm.bounceStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--stretch",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "rect rect-1",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-2",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-3",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-4",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-5",
    style: (_vm.rectStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid fixed h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr auto",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "getOmbrelli": _vm.getOmbrelli
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "justify-items": "center",
      "align-content": "start",
      "overflow": "auto",
      "height": "100vh",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "grid range"
  }, [_c('div', {
    staticClass: "selector"
  }, [_c('p', [(!_vm.nogrid) ? _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a day",
      "picker-options": _vm.datePickerOptions,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.changeDate()
      }
    },
    model: {
      value: (_vm.today),
      callback: function($$v) {
        _vm.today = $$v
      },
      expression: "today"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.nogrid) ? _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "al",
      "start-placeholder": "Data inizio",
      "end-placeholder": "Data fine",
      "picker-options": _vm.datePickerOptions,
      "format": "dd-MM-yyyy"
    },
    on: {
      "change": function($event) {
        return _vm.changeRange()
      }
    },
    model: {
      value: (_vm.rangepicker),
      callback: function($$v) {
        _vm.rangepicker = $$v
      },
      expression: "rangepicker"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid thegrid",
    style: (_vm.style)
  }, [_vm._l((_vm.ombrelli), function(ombrello, index) {
    return (_vm.rangeview) ? _c('div', {
      staticClass: "grid ombrello"
    }, [_c('div', {
      staticClass: "grid seat range"
    }, [_c('div', {
      staticClass: "grid data"
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))])]), _vm._v(" "), _c('div', {
      staticClass: "grid days",
      staticStyle: {
        "grid-template-columns": "repeat(7, 1fr)"
      }
    }, _vm._l((ombrello.dates), function(day, indexd) {
      return _c('div', {
        staticClass: "grid"
      }, [(!day.free) ? _c('span', {
        staticClass: "grid day",
        on: {
          "click": function($event) {
            return _vm.bookedshow(ombrello, day)
          }
        }
      }, [_c('el-popover', {
        attrs: {
          "placement": "top-start",
          "title": 'Dettagli ombrello ' + ombrello.ombrid,
          "width": "auto",
          "trigger": "hover",
          "fit": "true"
        }
      }, [_c('el-table', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "data": day.guests
        }
      }, [_c('el-table-column', {
        attrs: {
          "width": "auto",
          "property": "room",
          "label": "Stanza"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "min-width": 100,
          "property": "name",
          "label": "Nome"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "width": "120",
          "property": "arrival",
          "label": "Arrivo"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "width": "120",
          "property": "departure",
          "label": "Partenza"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "width": "auto",
          "property": "note",
          "label": "Note"
        }
      })], 1), _vm._v(" "), _c('el-button', {
        attrs: {
          "slot": "reference"
        },
        slot: "reference"
      }, [_vm._v(_vm._s(day.date))])], 1)], 1) : _vm._e(), _vm._v(" "), (day.free) ? _c('span', {
        staticClass: "grid day free",
        on: {
          "click": function($event) {
            return _vm.newshow(ombrello, day)
          }
        }
      }, [_vm._v(_vm._s(day.date))]) : _vm._e()])
    }), 0)])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.ombrelli), function(ombrello, index) {
    return (!_vm.rangeview) ? _c('div', {
      staticClass: "grid ombrello drag",
      class: {
        nonvisible: !ombrello.visible
      }
    }, [(!ombrello.free) ? _c('div', {
      staticClass: "grid seat",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_c('div', {
      staticClass: "grid header",
      class: {
        hidden: !_vm.hotel.poolsettings.chairs
      }
    }, [_c('div', {
      staticClass: "grid items"
    }, _vm._l((ombrello.guestsinday[0].items), function(item) {
      return _c('div', {
        staticClass: "grid item"
      }, [(item.num > 0) ? _c('div', {
        staticClass: "grid details"
      }, _vm._l((item.num), function(nu) {
        return _c('span', {
          staticClass: "icon",
          domProps: {
            "innerHTML": _vm._s(item.icon)
          }
        })
      }), 0) : _vm._e()])
    }), 0)]), _vm._v(" "), (!_vm.hotel.poolsettings.guest && !_vm.hotel.poolsettings.room) ? _c('el-popover', {
      attrs: {
        "placement": "top-start",
        "title": 'Dettagli ombrello ' + ombrello.ombrid,
        "width": "auto",
        "trigger": "hover",
        "fit": "true",
        "content": ombrello.guestsinday[0].name
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": ombrello.guestsinday
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "auto",
        "property": "room",
        "label": "Stanza"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": 100,
        "property": "name",
        "label": "Nome"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "arrival",
        "label": "Arrivo"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "departure",
        "label": "Partenza"
      }
    })], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.room || _vm.hotel.poolsettings.guest) ? _c('div', {
      staticClass: "grid ident"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].name))]) : _vm._e(), _vm._v(" "), (!ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest name")]) : _vm._e(), _vm._v(" "), (ombrello.guestsinday.length > 1) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && ombrello.guestsinday.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid data",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "grid date",
      class: {
        hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]), _vm._v(" "), _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (ombrello.free) ? _c('div', {
      staticClass: "blocco seat free",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_c('a', {
      staticClass: "blocco nr",
      attrs: {
        "id": ombrello._id
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "grid overview"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome ospite o numero camera"
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('h3', [_vm._v("Check In")]) : _vm._e(), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('div', {
    staticClass: "grid arrivals"
  }, _vm._l((_vm.filteredArrivals), function(arrival) {
    return _c('span', {
      staticClass: "arrival"
    }, [_vm._v(_vm._s(arrival.ombrello.ombrid) + " - " + _vm._s(arrival.guest.name) + "@" + _vm._s(arrival.guest.room))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('h3', [_vm._v("Check Out")]) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('div', {
    staticClass: "grid departures"
  }, _vm._l((_vm.filteredDepartures), function(departure, index) {
    return _c('span', {
      staticClass: "departure",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.open('overviewdetail', departure, index)
        }
      }
    }, [_vm._v(_vm._s(departure.ombrello.ombrid) + " - " + _vm._s(departure.guest.name) + "@" + _vm._s(departure.guest.room) + " ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid stays"
  }, _vm._l((_vm.filteredStays), function(stay) {
    return _c('span', {
      staticClass: "stay"
    }, [_vm._v(_vm._s(stay.ombrello.ombrid) + " - " + _vm._s(stay.guest.name) + "@" + _vm._s(stay.guest.room))])
  }), 0)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "overviewdetail",
      "width": 360,
      "minWidth": 360,
      "maxWidth": 1040,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    }
  }, [(!_vm.loading && _vm.checkoutbasket) ? _c('div', {
    staticClass: "grid overviewdetail"
  }, [_c('h1', [_vm._v("Checkout " + _vm._s(_vm.checkoutbasket.ombrid))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('small', [_vm._v("Ospite")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].name))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('small', [_vm._v("Camera")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].room))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('small', [_vm._v("Arrivo")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].arrival))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('small', [_vm._v("Partenza")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].departure))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.checkoutbasket.guests[0].note))]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid items"
  }, _vm._l((_vm.checkoutbasket.guests[0].items), function(item) {
    return _c('div', {
      staticClass: "grid item"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.num))])])
  }), 0), _vm._v(" "), (_vm.hotel.cashier && _vm.checkoutbasket.cashable && _vm.hotel.seasons.length !== 0) ? _c('div', {
    staticClass: "grid total"
  }, [_c('span', [_c('small', [_vm._v("Base")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashierbasket.tocash))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("Extra")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashierbasket.extra))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Totale:")])]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("€ " + _vm._s(_vm.cashierbasket.total))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.hotel.cashier && _vm.hotel.seasons.length !== 0) ? _c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Checkout Ospite")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('Hello', {
    attrs: {
      "ombrellos": _vm.ombrellos,
      "hotel": _vm.hotel,
      "disabledDates": _vm.disabledDates,
      "range": _vm.range
    },
    on: {
      "changeOmbrellodate": _vm.onChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid fixed h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid cashier h100"
  }, [_c('div', {
    staticClass: "grid seasons"
  }, [_c('div', {
    staticClass: "grid enable"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.hotel.name) + " - Stagioni e pagamenti ombrellone")])]), _vm._v(" "), _c('span', [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    on: {
      "change": _vm.editcashier
    },
    model: {
      value: (_vm.hotel.cashier),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "cashier", $$v)
      },
      expression: "hotel.cashier"
    }
  })], 1), _vm._v(" "), _c('span', [(_vm.hotel.cashier) ? _c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addseason
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-square"
  }), _vm._v(" aggiungi stagione")]) : _vm._e()])]), _vm._v(" "), (_vm.hotel && _vm.hotel.seasons.length === 0) ? _c('p', [_vm._v("Aggiungi la tua prima stagione")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.hotel.seasons), function(season, index) {
    return (_vm.hotel.cashier) ? _c('div', {
      staticClass: "grid season"
    }, [_c('span', [_vm._v(_vm._s(season.name))]), _vm._v(" "), _c('div', {
      staticClass: "grid data"
    }, [_c('span', [_c('small', [_vm._v(_vm._s(season.start) + " > " + _vm._s(season.end))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("€ " + _vm._s(season.amount))])]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-edit",
      on: {
        "click": function($event) {
          return _vm.editseason(season, index)
        }
      }
    })])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "grid items"
  }, [(_vm.newseason || _vm.updateseason) ? _c('div', {
    staticClass: "grid addseason"
  }, [(_vm.newseason) ? _c('span', [_c('strong', [_vm._v("Aggiungi stagione")])]) : _vm._e(), _vm._v(" "), (_vm.updateseason) ? _c('span', [_c('strong', [_vm._v("Update stagione " + _vm._s(_vm.season.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "addseasonForm",
    attrs: {
      "model": _vm.season,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Denominazione stagione",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Denominazione stagione",
      "name": "name"
    },
    model: {
      value: (_vm.season.name),
      callback: function($$v) {
        _vm.$set(_vm.season, "name", $$v)
      },
      expression: "season.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "al",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "format": "dd-MM-yyyy",
      "picker-options": _vm.datePickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.changeRange()
      }
    },
    model: {
      value: (_vm.season.daterange),
      callback: function($$v) {
        _vm.$set(_vm.season, "daterange", $$v)
      },
      expression: "season.daterange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prezzo base ombrellone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Prezzo ombrellone",
      "name": "ombrellone"
    },
    model: {
      value: (_vm.season.amount),
      callback: function($$v) {
        _vm.$set(_vm.season, "amount", $$v)
      },
      expression: "season.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("€")])], 2)], 1), _vm._v(" "), _vm._l((_vm.season.items), function(item) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": 'Prezzo base ' + item.name
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Prezzo oggetto",
        "name": "price"
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("€")])], 2)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.newseason) ? _c('el-button', {
    staticClass: "btn btn-green",
    on: {
      "click": function($event) {
        return _vm.addnewseason('addseasonForm')
      }
    }
  }, [_vm._v("aggiungi stagione")]) : _vm._e(), _vm._v(" "), (_vm.updateseason) ? _c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.updateseason) ? _c('el-button', {
    staticClass: "btn btn-green",
    on: {
      "click": function($event) {
        return _vm.saveseason('addseasonForm', _vm.season.index)
      }
    }
  }, [_vm._v("salva impostazioni stagione")]) : _vm._e()], 1)])], 2)], 1) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Attenzione",
      "visible": _vm.dialogVisible,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("Sei sicuro di voler cancellare la stagione " + _vm._s(_vm.season.name) + "?")]), _vm._v(" "), _c('p', [_vm._v("Tutti i dati verranno cancellati.")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Anulla")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        return _vm.deleteseason(_vm.season.index)
      }
    }
  }, [_vm._v("Cancella")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr auto",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "addombrid": _vm.addombrid,
      "addombrell": _vm.addombrell,
      "editCanvas": _vm.editCanvas,
      "edit": _vm.edit,
      "getOmbrelli": _vm.getOmbrelli
    }
  }), _vm._v(" "), _c('div', {
    ref: "canvas",
    staticStyle: {
      "display": "grid",
      "justify-items": "center",
      "align-content": "start",
      "overflow": "auto",
      "height": "100vh",
      "padding": "0px"
    }
  }, [_c('div', [_c('p', [(!_vm.edit) ? _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a day",
      "picker-options": _vm.datePickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.changeDate()
      }
    },
    model: {
      value: (_vm.today),
      callback: function($$v) {
        _vm.today = $$v
      },
      expression: "today"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "h100",
    staticStyle: {
      "position": "relative"
    },
    style: ({
      width: _vm.windowWidth + 'px',
      height: _vm.windowHeight + 'px'
    })
  }, _vm._l((_vm.ombrelli), function(ombrello, index) {
    return _c('VueDragResize', {
      key: ombrello._id,
      staticClass: "grid ombrello",
      attrs: {
        "preventActiveBehavior": true,
        "parentW": _vm.windowWidth,
        "parentH": _vm.windowHeight,
        "parentLimitation": true,
        "isActive": _vm.edit,
        "x": ombrello.x,
        "y": ombrello.y,
        "w": ombrello.width,
        "h": ombrello.height,
        "isDraggable": _vm.edit,
        "isResizable": false
      },
      on: {
        "clicked": function($event) {
          _vm.edit ? _vm.noshow() : _vm.show(ombrello)
        },
        "resizing": _vm.resize,
        "dragstop": function (left, top, width, height) { return _vm.onResizing(index, left, top, width, height); }
      }
    }, [(!ombrello.free) ? _c('div', {
      staticClass: "grid seat",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds
      },
      on: {
        "click": function($event) {
          _vm.edit ? _vm.noshow() : _vm.show(ombrello)
        }
      }
    }, [(_vm.edit) ? _c('span', {
      staticClass: "deleteombrello"
    }, [_c('i', {
      staticClass: "fas fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteOmbrello(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid header",
      class: {
        single: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.chairs && !_vm.hotel.poolsettings.beds
      }
    }, [(_vm.hotel.poolsettings.beds) ? _c('img', {
      attrs: {
        "src": __webpack_require__(84)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('img', {
      attrs: {
        "src": __webpack_require__(83)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removechair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.chairs)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addchair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.beds) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removebed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.beds)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addbed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e()]), _vm._v(" "), (!_vm.hotel.poolsettings.guest && !_vm.hotel.poolsettings.room) ? _c('el-popover', {
      attrs: {
        "placement": "top-start",
        "title": 'Dettagli ombrello ' + ombrello.ombrid,
        "width": "auto",
        "trigger": "hover",
        "fit": "true",
        "content": ombrello.guestsinday[0].name
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": ombrello.guestsinday
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "auto",
        "property": "room",
        "label": "Stanza"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "min-width": 100,
        "property": "name",
        "label": "Nome"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "arrival",
        "label": "Arrivo"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "120",
        "property": "departure",
        "label": "Partenza"
      }
    })], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.room || _vm.hotel.poolsettings.guest) ? _c('div', {
      staticClass: "grid ident"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].name))]) : _vm._e(), _vm._v(" "), (!ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest name")]) : _vm._e(), _vm._v(" "), (ombrello.guestsinday.length > 1) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && ombrello.guestsinday.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid data",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "grid date",
      class: {
        hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]), _vm._v(" "), _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (ombrello.free && ombrello.location === 'canvas') ? _c('div', {
      staticClass: "grid seat free drop",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          _vm.edit ? _vm.noshow() : _vm.show(ombrello)
        }
      }
    }, [(_vm.edit) ? _c('span', {
      staticClass: "deleteombrello"
    }, [_c('i', {
      staticClass: "fas fa-trash",
      on: {
        "click": function($event) {
          return _vm.deleteOmbrello(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid nr",
      attrs: {
        "id": ombrello._id
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid overview"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome ospite o numero camera"
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('h2', [_vm._v("Check In")]) : _vm._e(), _vm._v(" "), (_vm.overview.arrivals.length > 0) ? _c('div', {
    staticClass: "grid arrivals"
  }, _vm._l((_vm.filteredArrivals), function(arrival) {
    return _c('span', {
      staticClass: "arrival"
    }, [_vm._v(_vm._s(arrival.ombrid) + " - " + _vm._s(arrival.guest.name) + "@" + _vm._s(arrival.guest.room))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('h2', [_vm._v("Check Out")]) : _vm._e(), _vm._v(" "), (_vm.overview.departures.length > 0) ? _c('div', {
    staticClass: "grid departures"
  }, _vm._l((_vm.filteredDepartures), function(departure) {
    return _c('span', {
      staticClass: "departure"
    }, [_vm._v(_vm._s(departure.ombrid) + " - " + _vm._s(departure.guest.name) + "@" + _vm._s(departure.guest.room))])
  }), 0) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "grid stays"
  }, _vm._l((_vm.filteredStays), function(stay) {
    return _c('span', {
      staticClass: "stay"
    }, [_vm._v(_vm._s(stay.ombrid) + " - " + _vm._s(stay.guest.name) + "@" + _vm._s(stay.guest.room))])
  }), 0)], 1), _vm._v(" "), _c('Hello', {
    attrs: {
      "ombrellos": _vm.ombrellos,
      "hotel": _vm.hotel,
      "disabledDates": _vm.disabledDates,
      "range": _vm.range
    },
    on: {
      "changeOmbrellodate": _vm.onChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--wave",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "name": "hello-world",
      "width": _vm.modal.width,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    }
  }, [_c('div', {
    staticClass: "grid edit ombrello w100"
  }, [_c('div', {
    staticClass: "grid data h50"
  }, [(_vm.$mq === 'sm') ? _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times-circle"
  })]) : _vm._e(), _vm._v(" "), _c('el-form', [(!_vm.editombrid) ? _c('h1', {
    on: {
      "click": _vm.changeombrid
    }
  }, [_vm._v(_vm._s(_vm.ombrellos.ombrid))]) : _vm._e(), _vm._v(" "), _c('el-form-item', [(_vm.editombrid) ? _c('el-input', {
    model: {
      value: (_vm.ombrellos.ombrid),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "ombrid", $$v)
      },
      expression: "ombrellos.ombrid"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nome ospite"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome ospite"
    },
    model: {
      value: (_vm.ombrellos.guest),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "guest", $$v)
      },
      expression: "ombrellos.guest"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Camera"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero camera"
    },
    model: {
      value: (_vm.ombrellos.room),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "room", $$v)
      },
      expression: "ombrellos.room"
    }
  })], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Arrivo e Partenza")])]), _vm._v(" "), _c('DateRange', {
    staticClass: "calendar",
    attrs: {
      "sync-range": _vm.hellorange,
      "first-day-of-week": 1,
      "lang": _vm.lang,
      "emitChangeOnStep0": true,
      "dayClassFunc": _vm.dayClassFunc
    },
    on: {
      "update:syncRange": function($event) {
        _vm.hellorange = $event
      },
      "update:sync-range": function($event) {
        _vm.hellorange = $event
      },
      "change": _vm.onChangedate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " spacer sm"
  }), _vm._v(" "), _c('p', [(!_vm.ombrellos.free) ? _c('a', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.updateombrello
    }
  }, [_vm._v("Salva Ombrello")]) : _vm._e()]), _vm._v(" "), _c('p', [(_vm.ombrellos.free) ? _c('a', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.saveOmbrello
    }
  }, [_vm._v("Salva Ombrello")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid seats",
    class: {
      free: _vm.ombrellos.free
    }
  }, [_c('div', {
    staticClass: "grid qrcode"
  }, [(_vm.hotel.cashier && _vm.ombrellos.cashable && _vm.hotel.seasons.length !== 0) ? _c('div', {
    staticClass: "grid cash"
  }, [_c('span', [_c('small', [_vm._v("Base")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashier.tocash))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("Extra")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashier.extra))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Totale:")])]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("€ " + _vm._s(_vm.cashier.total))])])]) : _vm._e(), _vm._v(" "), (_vm.ombrellos.passid && !_vm.ombrellos.free) ? _c('qrcode', {
    attrs: {
      "value": 'https://spiaggia.ombrelleria.com/api/get/pass/' + _vm.ombrellos.passid,
      "options": {
        width: 148
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('el-form', [(_vm.sendPassForm) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "email"
    },
    model: {
      value: (_vm.guest.email),
      callback: function($$v) {
        _vm.$set(_vm.guest, "email", $$v)
      },
      expression: "guest.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sendPassForm) ? _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.sendPass
    }
  }, [_vm._v("manda beachpass")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "Note"
    },
    model: {
      value: (_vm.ombrellos.note),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "note", $$v)
      },
      expression: "ombrellos.note"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.ombrellos.items), function(item) {
    return _c('div', {
      staticClass: "grid"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          item.num -= 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(item.num)), _c('a', {
      on: {
        "click": function($event) {
          item.num += 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])])])
  }), 0)]), _vm._v(" "), (!_vm.ombrellos.free) ? _c('div', {
    staticClass: "grid navi ombrellooptions"
  }, [_c('div', {
    staticClass: "grid shader"
  }, [_c('div', {
    staticClass: "options"
  }, [(!_vm.ombrellos.passid && !_vm.ombrellos.free) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Crea Beachpass",
      "placement": "left-start"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generatePass
    }
  }, [_c('i', {
    staticClass: "fas fa-qrcode"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.ombrellos.passid && !_vm.ombrellos.free) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "manda beachpass tramite email",
      "placement": "left-start"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sendPassForm = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-envelope"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "left-start"
    }
  }, [_c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Cancella prenotazione")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibleOmbrello = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })])], 1)], 1)])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Attenzione",
      "visible": _vm.dialogVisibleOmbrello,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleOmbrello = $event
      }
    }
  }, [_c('p', [_vm._v("Sei sicuro di voler cancellare la prenotazione per " + _vm._s(_vm.ombrellos.ombrid) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisibleOmbrello = false
      }
    }
  }, [_vm._v("Anulla")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        return _vm.closeombrello(_vm.ombrellos.guestnr)
      }
    }
  }, [_vm._v("Cancella")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--pencil",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 677.34762 182.15429"
    }
  }, [_c('g', [_c('path', {
    staticClass: "body-pencil",
    attrs: {
      "d": "M128.273 0l-3.9 2.77L0 91.078l128.273 91.076 549.075-.006V.008L128.273 0zm20.852 30l498.223.006V152.15l-498.223.007V30zm-25 9.74v102.678l-49.033-34.813-.578-32.64 49.61-35.225z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M134.482 157.147v25l518.57.008.002-25-518.572-.008z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading && _vm.hotel) ? _c('modal', {
    attrs: {
      "name": "settings",
      "width": _vm.modal.width,
      "minWidth": 360,
      "maxWidth": 1040,
      "height": _vm.modal.height,
      "adaptive": true,
      "scrollable": ""
    }
  }, [_c('div', {
    staticClass: "grid edit settings w100"
  }, [(!_vm.addbeachitem) ? _c('div', {
    staticClass: "grid data h50"
  }, [_c('h1', [_vm._v(_vm._s(_vm.hotel.name))]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Nome Hotel"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.hotel.name),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "name", $$v)
      },
      expression: "hotel.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "column"
    }
  }, [_c('span', {
    staticClass: "grid colorpicker",
    staticStyle: {
      "grid-auto-flow": "column"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Colore Hotel")]), _vm._v(" "), _c('el-color-picker', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.hotel.colors.primary),
      callback: function($$v) {
        _vm.$set(_vm.hotel.colors, "primary", $$v)
      },
      expression: "hotel.colors.primary"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid settings"
  }, [_c('span', [_vm._v("Numero camera")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.room),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "room", $$v)
      },
      expression: "hotel.poolsettings.room"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Nome ospite")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.guest),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "guest", $$v)
      },
      expression: "hotel.poolsettings.guest"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Oggetti spiaggia")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.chairs),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "chairs", $$v)
      },
      expression: "hotel.poolsettings.chairs"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Arrivo e Partenza")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.poolsettings.arrival),
      callback: function($$v) {
        _vm.$set(_vm.hotel.poolsettings, "arrival", $$v)
      },
      expression: "hotel.poolsettings.arrival"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Booking Ombrellone singolo giorno")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#00B325"
    },
    model: {
      value: (_vm.hotel.singledaybooking),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "singledaybooking", $$v)
      },
      expression: "hotel.singledaybooking"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.updatehotel
    }
  }, [_vm._v("Salva Impostazioni")]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addbeachitem) ? _c('div', {
    staticClass: "addbeachitem"
  }, [_c('h3', [_vm._v("Aggiungi oggetto in spiaggia")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Nome oggetto in spiaggia"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome oggetto spiaggia"
    },
    model: {
      value: (_vm.beachitem.name),
      callback: function($$v) {
        _vm.$set(_vm.beachitem, "name", $$v)
      },
      expression: "beachitem.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-radio', {
    attrs: {
      "label": "grid",
      "border": ""
    },
    model: {
      value: (_vm.beachitem.icon),
      callback: function($$v) {
        _vm.$set(_vm.beachitem, "icon", $$v)
      },
      expression: "beachitem.icon"
    }
  }, [_c('i', {
    staticClass: "far fa-grin-tongue-wink"
  })])], 1), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-green",
    on: {
      "click": _vm.updatebeachitems
    }
  }, [_vm._v("Aggiungi oggetto")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid seats h50",
    class: {
      neutral: _vm.passForm
    },
    style: ({
      background: _vm.hotel.colors.primary
    })
  }, [_vm._l((_vm.hotel.items), function(item, index) {
    return (!_vm.passForm) ? _c('div', {
      staticClass: "grid"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), (!_vm.addbeachitem) ? _c('span', [_c('a', {
      on: {
        "click": function($event) {
          item.num -= 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(item.num)), _c('a', {
      on: {
        "click": function($event) {
          item.num += 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e(), _vm._v(" "), (_vm.addbeachitem) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.deletebeachitem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    })]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.passForm) ? _c('div', {
    staticClass: "grid"
  }, [_c('el-form', {
    ref: "changepassForm",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Inserisci la tua nuova password",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-green block",
    on: {
      "click": function($event) {
        return _vm.changepassword('changepassForm')
      }
    }
  }, [_vm._v("salva password")])], 1)], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "grid navi",
    class: {
      neutral: _vm.passForm
    },
    style: ({
      background: _vm.hotel.colors.primary
    })
  }, [_c('div', {
    staticClass: "grid shader"
  }, [_c('div', {
    staticClass: "options"
  }, [(_vm.hotel.beachtype == 'grid') ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia impostazioni spiaggia",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/editgrid/' + _vm.hotel._id
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Imposta pagamenti",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/pagamenti/' + _vm.hotel._id
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-cash-register"
  })])], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia la tua password",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('i', {
    staticClass: "fas fa-lock",
    on: {
      "click": function($event) {
        _vm.passForm = true
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "left-start"
    }
  }, [_c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Cancella " + _vm._s(_vm.hotel.name))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Attenzione",
      "visible": _vm.dialogVisible,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("Sei sicuro di voler cancellare " + _vm._s(_vm.hotel.name) + "?")]), _vm._v(" "), _c('p', [_vm._v("Tutti i dati verranno cancellati.")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Anulla")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.deleteHotel
    }
  }, [_vm._v("Cancella")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--two-cube",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "cube2",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--mikepad",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('div', {
    staticClass: "binding"
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "line line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line3"
  })])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid addhotel"
  }, [_c('el-tooltip', {
    staticClass: "item back",
    attrs: {
      "effect": "dark",
      "content": "torna in spiaggia",
      "placement": "left-start"
    }
  }, [_c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/hotel'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid generator"
  }, [_c('div', {
    staticClass: "grid steps"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "min-width": "960px"
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.grid.active,
      "align-center": "",
      "finish-status": "success"
    }
  }, _vm._l((_vm.filteredSteps), function(option, index) {
    return _c('el-step', {
      key: index,
      attrs: {
        "title": option.title,
        "description": option.desc
      },
      nativeOn: {
        "click": function($event) {
          return (function (e) { return _vm.stepHandler(e, index); })($event)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid cont"
  }, [(_vm.grid.active === 0) ? _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "one"
    }
  }, [(!_vm.loading) ? _c('h2', [_vm._v("Aggiungi il tuo Hotel")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formAddhotel",
    attrs: {
      "model": _vm.hotel,
      "rules": _vm.rules,
      "status-icon": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "Nome Hotel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome Hotel",
      "type": "text"
    },
    model: {
      value: (_vm.hotel.name),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "name", $$v)
      },
      expression: "hotel.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "",
      "label": "Colore preferito"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.hotel.colors.primary),
      callback: function($$v) {
        _vm.$set(_vm.hotel.colors, "primary", $$v)
      },
      expression: "hotel.colors.primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.next('formAddhotel')
      }
    }
  }, [_vm._v("Avanti "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.grid.active === 1) ? _c('div', {
    attrs: {
      "id": "two"
    }
  }, [_c('h2', [_vm._v("Scegli il modello di spiaggia")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formAddhotel",
    attrs: {
      "model": _vm.hotel,
      "inline": true,
      "rules": _vm.rules,
      "status-icon": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "grid",
      "border": ""
    },
    model: {
      value: (_vm.hotel.beachtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "beachtype", $$v)
      },
      expression: "hotel.beachtype"
    }
  }, [_vm._v("Spiaggia con righe e colonne fisse "), _c('img', {
    attrs: {
      "src": "/static/img/addhotel-grid.png"
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "canvas",
      "border": ""
    },
    model: {
      value: (_vm.hotel.beachtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "beachtype", $$v)
      },
      expression: "hotel.beachtype"
    }
  }, [_vm._v("Spiaggia libera, imposto gli ombrelloni da solo "), _c('img', {
    attrs: {
      "src": "/static/img/addhotel-canvas.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeStep
    }
  }, [_vm._v("Avanti "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.grid.active === 2) ? _c('div', {
    attrs: {
      "id": "three"
    }
  }, [_c('h3', [_vm._v("Inserisci/cambia la lettera e il numero del primo ombrellone in fronte mare a sinistra")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "column",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "rules": _vm.rules,
      "model": _vm.hotel
    }
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Righe in Spiaggia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rows"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.hotel.rows),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "rows", $$v)
      },
      expression: "hotel.rows"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Colonne in Spiaggia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "cols"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.hotel.cols),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "cols", $$v)
      },
      expression: "hotel.cols"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lettera",
      "prop": "letterfirst"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "prima lettera"
    },
    model: {
      value: (_vm.letters.first),
      callback: function($$v) {
        _vm.$set(_vm.letters, "first", $$v)
      },
      expression: "letters.first"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Numero",
      "prop": "numberfirst"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "primo numero"
    },
    model: {
      value: (_vm.numbers.first),
      callback: function($$v) {
        _vm.$set(_vm.numbers, "first", $$v)
      },
      expression: "numbers.first"
    }
  })], 1), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetGrid
    }
  }, [_vm._v("Avanti "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid step first"
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.letters.first) + _vm._s(_vm.numbers.first))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])])])]) : _vm._e(), _vm._v(" "), (_vm.grid.active === 3) ? _c('div', {
    attrs: {
      "id": "four"
    }
  }, [_c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.hotel.beachtype === 'grid') ? _c('div', [_c('h2', [_vm._v("Controlla e salve")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formAddhotel",
    attrs: {
      "model": _vm.hotel,
      "inline": true,
      "rules": _vm.rules,
      "status-icon": ""
    }
  }, [(_vm.letters.first.length !== 0) ? _c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "left",
      "border": ""
    },
    on: {
      "change": _vm.resetGrid
    },
    model: {
      value: (_vm.hotel.gridtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "gridtype", $$v)
      },
      expression: "hotel.gridtype"
    }
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.first.letter) + _vm._s(_vm.pregrid.first.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.left.letter) + _vm._s(_vm.pregrid.left.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.up.letter) + _vm._s(_vm.pregrid.up.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.upleft.letter) + _vm._s(_vm.pregrid.upleft.number))])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.letters.first.length !== 0) ? _c('el-form-item', {
    attrs: {
      "prop": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "up",
      "border": ""
    },
    on: {
      "change": _vm.resetGrid
    },
    model: {
      value: (_vm.hotel.gridtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "gridtype", $$v)
      },
      expression: "hotel.gridtype"
    }
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.first.letter) + _vm._s(_vm.pregrid.first.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.up.letter) + _vm._s(_vm.pregrid.up.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.left.letter) + _vm._s(_vm.pregrid.left.number))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(_vm.pregrid.upleft.letter) + _vm._s(_vm.pregrid.upleft.number))])])])])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "empty",
      "border": ""
    },
    on: {
      "change": _vm.resetGrid
    },
    model: {
      value: (_vm.hotel.gridtype),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "gridtype", $$v)
      },
      expression: "hotel.gridtype"
    }
  }, [_c('div', {
    staticClass: "grid ombrello",
    staticStyle: {
      "grid-template-columns": "1fr 1fr",
      "grid-row-gap": "12px",
      "grid-column-gap": "12px"
    }
  }, [_c('div', {
    staticClass: "blocco seat free first"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(Number(_vm.numbers.first)))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(Number(_vm.numbers.first) + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s(Number(_vm.numbers.first) + _vm.hotel.cols))])]), _vm._v(" "), _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  }, [_vm._v(_vm._s((Number(_vm.numbers.first) + 1) + _vm.hotel.cols))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveGrid
    }
  }, [_vm._v("Salva Impostazioni "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1)], 1) : _c('div', {
    staticClass: "guide"
  }, [_c('h2', [_vm._v("Sei pronto a partire")]), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-button-group', [(_vm.grid.active !== 0) ? _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        _vm.grid.active--
      }
    }
  }, [_vm._v("Indietro")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveGrid
    }
  }, [_vm._v("Ok "), _c('i', {
    staticClass: "el-icon-arrow-right el-icon-right"
  })])], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "grid",
    staticStyle: {
      "padding": "96px 0",
      "max-width": "1200px"
    },
    style: (_vm.style)
  }, _vm._l((_vm.ombrelli), function(ombrello, index) {
    return _c('div', {
      staticClass: "grid ombrello drag"
    }, [(!ombrello.free) ? _c('div', {
      staticClass: "grid seat",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds
      },
      style: ({
        background: _vm.hotel.colors.secondary
      }),
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_c('div', {
      staticClass: "grid header",
      class: {
        single: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.chairs && !_vm.hotel.poolsettings.beds
      }
    }, [(_vm.hotel.poolsettings.beds) ? _c('img', {
      attrs: {
        "src": __webpack_require__(84)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('img', {
      attrs: {
        "src": __webpack_require__(83)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.chairs) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removechair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.chairs)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addchair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.beds) ? _c('span', {
      staticClass: "grid"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removebed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.beds)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addbed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])]) : _vm._e()]), _vm._v(" "), (!_vm.hotel.poolsettings.guest && !_vm.hotel.poolsettings.room) ? _c('el-popover', {
      attrs: {
        "placement": "top-start",
        "title": ombrello.guestsinday[0].room,
        "width": "200",
        "trigger": "hover",
        "content": ombrello.guestsinday[0].name
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.room || _vm.hotel.poolsettings.guest) ? _c('div', {
      staticClass: "grid ident"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[0].name))]) : _vm._e(), _vm._v(" "), (!ombrello.guest && _vm.hotel.poolsettings.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest name")]) : _vm._e(), _vm._v(" "), (ombrello.guestsinday.length > 1) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].room))]) : _vm._e(), _vm._v(" "), (ombrello.guest && ombrello.guestsinday.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guestsinday[1].name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid data",
      class: {
        minimal: !_vm.hotel.poolsettings.chairs || !_vm.hotel.poolsettings.beds, hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('div', {
      staticClass: "grid nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "grid date",
      class: {
        hidden: !_vm.hotel.poolsettings.arrival
      }
    }, [_c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]), _vm._v(" "), _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (ombrello.free) ? _c('div', {
      staticClass: "blocco seat free",
      attrs: {
        "id": ombrello._id
      }
    }, [_c('a', {
      staticClass: "blocco nr",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('circle4') : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco seat free"
  }, [_c('a', {
    staticClass: "blocco nr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Nella prossima schermata troverai una spiaggia libera, clicca su questa icona "), _c('i', {
    staticClass: "fas fa-wrench"
  }), _vm._v(" nel menu a sinistra per aggiungere o spostare gli ombrelloni.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Usa questo "), _c('i', {
    staticClass: "fas fa-umbrella-beach"
  }), _vm._v(" per aggiungere gli ombrelloni o clicca e trascina gli ombrelloni gia inseriti per spostarli.")])
}]}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square-2",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--cube",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 500.00001 500.00001"
    }
  }, [_c('g', {
    attrs: {
      "fill": _vm.color
    }
  }, [_c('path', {
    staticClass: "b0",
    attrs: {
      "d": "M66.734 66.734v366.533h366.532V66.734H66.734zm15 15h336.532v336.533H81.734V81.734z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b2",
    attrs: {
      "d": "M354.16 2.5v143.34H497.5V2.5H354.16zm10 10H487.5v123.34H364.16V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b1",
    attrs: {
      "d": "M0 2.5v143.34h143.34V2.5H0zm10 10h123.34v123.34H10V12.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b3",
    attrs: {
      "d": "M354.16 356.66V500H497.5V356.66H354.16zm10 10H487.5V490H364.16V366.66z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "b4",
    attrs: {
      "d": "M0 356.66V500h143.34V356.66H0zm10 10h123.34V490H10V366.66z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-square4",
    style: (_vm.styles)
  }, [_c('span', {
    staticClass: "loader-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square-5",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('span', {
    staticClass: "load3 one"
  }), _vm._v(" "), _c('span', {
    staticClass: "load3 two"
  }), _vm._v(" "), _c('span', {
    staticClass: "load3-center"
  })])])
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--texture",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jawn"
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "jawn",
    style: (_vm.innerStyles)
  })])])
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blocco h100 w100"
  }, [_c('circle4')], 1)
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hello3 grid h100"
  }, [_c('div', {
    staticClass: "grid login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid form"
  }, [(_vm.loginform && !_vm.formReset || _vm.signupform && !_vm.formReset) ? _c('h2', [_vm._v("Accedi a Ombrelleria")]) : _vm._e(), _vm._v(" "), (_vm.formReset) ? _c('h2', [_vm._v("Inserisci la tua email")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (!_vm.formReset) ? _c('el-form', {
    ref: "formLogin",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signup('formLogin')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    ref: "emailinput",
    attrs: {
      "placeholder": "Indirizzo Email",
      "type": "text",
      "prefix-icon": "fas fa-user-circle",
      "name": "email"
    },
    model: {
      value: (_vm.formel.email),
      callback: function($$v) {
        _vm.$set(_vm.formel, "email", $$v)
      },
      expression: "formel.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.signup('formLogin')
      }
    }
  }, [_vm._v("login")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.loginform = false, _vm.signupform = true, _vm.error.state = false
      }
    }
  }, [_vm._v("registrati")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.formReset = true, _vm.error.state = false
      }
    }
  }, [_vm._v("ho dimenticato la password")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formReset) ? _c('el-form', {
    ref: "formReset",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.passreset('formReset')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    ref: "emailinput",
    attrs: {
      "placeholder": "Indirizzo Email",
      "type": "text",
      "prefix-icon": "fas fa-user-circle",
      "name": "email"
    },
    model: {
      value: (_vm.formel.email),
      callback: function($$v) {
        _vm.$set(_vm.formel, "email", $$v)
      },
      expression: "formel.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.passreset('formReset')
      }
    }
  }, [_vm._v("manda nuova password")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.loginform = false, _vm.signupform = true, _vm.error.state = false
      }
    }
  }, [_vm._v("registrati")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.formReset = false, _vm.error.state = false
      }
    }
  }, [_vm._v("torna alla login")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "intermed "
  }, [_c('transition', {
    attrs: {
      "name": "slide-login",
      "mode": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginform),
      expression: "loginform"
    }],
    staticClass: "login",
    class: {
      success: _vm.success.state, error: _vm.error.state
    }
  }, [_c('h1', [_vm._v("Bentornato")]), _vm._v(" "), (_vm.error.state) ? _c('p', [_vm._v(_vm._s(_vm.error.message))]) : _vm._e(), _vm._v(" "), (_vm.success.state) ? _c('p', [_vm._v(_vm._s(_vm.success.message))]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-signup",
      "mode": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.signupform),
      expression: "signupform"
    }],
    staticClass: "signup",
    class: {
      success: _vm.success.state, error: _vm.error.state
    }
  }, [_c('h1', [_vm._v("Benvenuto")]), _vm._v(" "), (_vm.error.state) ? _c('p', [_vm._v(_vm._s(_vm.error.message))]) : _vm._e(), _vm._v(" "), (_vm.success.state) ? _c('p', [_vm._v(_vm._s(_vm.success.message))]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "grid signup"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid form"
  }, [_c('h2', [_vm._v("Registrati a Ombrelleria")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formsignup",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signup('formsignup')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Indirizzo Email",
      "type": "text",
      "prefix-icon": "fas fa-user-circle",
      "name": "email"
    },
    model: {
      value: (_vm.formel.email),
      callback: function($$v) {
        _vm.$set(_vm.formel, "email", $$v)
      },
      expression: "formel.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.signup('formsignup')
      }
    }
  }, [_vm._v("Registrati")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-secondary block",
    on: {
      "click": function($event) {
        _vm.loginform = true, _vm.signupform = false, _vm.formReset = false, _vm.error.state = false
      }
    }
  }, [_vm._v("vai alla login")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-alpha.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-alpha.svg"
    }
  })])
}]}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-9",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading spin-1"
  }, [_c('div', {
    staticClass: "loading spin-2"
  }, [_c('div', {
    staticClass: "loading spin-3"
  }, [_c('div', {
    staticClass: "loading spin-4"
  }, [_c('div', {
    staticClass: "loading spin-5"
  }, [_c('div', {
    staticClass: "loading spin-6"
  })])])])])])
}]}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-8",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-container"
  }, [_c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_1"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_2"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_3"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_4"
  }, [_vm._v(" ")])])])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-7",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle-6",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100"
    }
  }, [_c('g', {
    staticClass: "anim-0"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "50",
      "fill": _vm.background
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-1"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-2"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "50",
      "x2": "75",
      "y2": "50",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-3"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "25",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "75",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-4"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "75",
      "y1": "25",
      "x2": "25",
      "y2": "25",
      "stroke": "white",
      "stroke-width": "3"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-5",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-4",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-3",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-2",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-diamond",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "diamond",
    style: (_vm.diamondStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--google",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {}, [_c('router-view', {
    attrs: {
      "auth": _vm.auth,
      "authenticated": _vm.authenticated
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "forgot grid h100"
  }, [_c('div', {}, [_c('h3', [_vm._v("Prego inserisci la tua nuova password")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formLogin",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.forgot('formLogin')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.forgot('formLogin')
      }
    }
  }, [_vm._v("cambia password")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr auto",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "getOmbrelli": _vm.getOmbrelli
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid toolbox"
  }, [_c('el-button-group', [(!_vm.bulkedit) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia struttura spiaggia",
      "placement": "bottom"
    }
  }, [(!_vm.setgrid) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setgrid = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  })]) : _vm._e(), _vm._v(" "), (_vm.setgrid) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setgrid = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.bulkedit) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia impostazioni Ombrelloni",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.show('bulkombrellosettings'), _vm.disableSelection()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Abilita Multi-Edit",
      "placement": "bottom"
    }
  }, [(!_vm.bulkedit) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.enableSelection
    }
  }, [_c('i', {
    staticClass: "fas fa-lock"
  })]) : _vm._e(), _vm._v(" "), (_vm.bulkedit) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.destroySelection()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-unlock"
  })]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "test",
    staticStyle: {
      "display": "grid",
      "justify-items": "center",
      "align-content": "start",
      "overflow": "auto",
      "height": "100vh",
      "padding": "0px"
    }
  }, [(_vm.setgrid) ? _c('div', {
    staticClass: "grid setgrid"
  }, [_c('el-form', [(_vm.hotel && !_vm.loading) ? _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "column",
      "grid-column-gap": "24px",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Righe in Spiaggia")]), _vm._v(" "), _c('el-form-item', [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    on: {
      "change": _vm.changeGrid
    },
    model: {
      value: (_vm.hotel.rows),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "rows", $$v)
      },
      expression: "hotel.rows"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Colonne in Spiaggia")]), _vm._v(" "), _c('el-form-item', [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    on: {
      "change": _vm.changeGrid
    },
    model: {
      value: (_vm.hotel.cols),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "cols", $$v)
      },
      expression: "hotel.cols"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "row"
    }
  }, [_c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveGrid
    }
  }, [_vm._v("Salve struttura spiaggia")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boundary"
  }, [(_vm.hotel && !_vm.loading) ? _c('div', {
    staticClass: "grid editgrid",
    staticStyle: {
      "padding": "96px"
    },
    style: (_vm.gridstyle)
  }, [_vm._l((_vm.ombrelli), function(ombrello, index) {
    return (!_vm.firstreset) ? _c('div', {
      staticClass: "grid ombrello"
    }, [_c('div', {
      staticClass: "grid seat free",
      class: {
        nonvisible: !ombrello.visible
      },
      attrs: {
        "id": ombrello._id,
        "data-item": ombrello.ombrid,
        "data-id": ombrello._id
      }
    }, [_c('div', [_vm._v("\n              " + _vm._s(ombrello.ombrid) + "\n              ")]), _vm._v(" "), (!_vm.bulkedit) ? _c('div', {
      staticClass: "options"
    }, [(!ombrello.visible) ? _c('el-checkbox', {
      attrs: {
        "label": "visible"
      },
      model: {
        value: (ombrello.visible),
        callback: function($$v) {
          _vm.$set(ombrello, "visible", $$v)
        },
        expression: "ombrello.visible"
      }
    }, [_c('i', {
      staticClass: "fas fa-eye-slash"
    })]) : _vm._e(), _vm._v(" "), (ombrello.visible) ? _c('el-checkbox', {
      attrs: {
        "label": "visible"
      },
      model: {
        value: (ombrello.visible),
        callback: function($$v) {
          _vm.$set(ombrello, "visible", $$v)
        },
        expression: "ombrello.visible"
      }
    }, [_c('i', {
      staticClass: "fas fa-eye"
    })]) : _vm._e(), _vm._v(" "), (!ombrello.cashable && _vm.hotel.cashier) ? _c('el-checkbox', {
      attrs: {
        "label": "cashable"
      },
      model: {
        value: (ombrello.cashable),
        callback: function($$v) {
          _vm.$set(ombrello, "cashable", $$v)
        },
        expression: "ombrello.cashable"
      }
    }, [_c('i', {
      staticClass: "fab fa-creative-commons-nc-eu"
    })]) : _vm._e(), _vm._v(" "), (ombrello.cashable && _vm.hotel.cashier) ? _c('el-checkbox', {
      attrs: {
        "label": "cashable"
      },
      model: {
        value: (ombrello.cashable),
        callback: function($$v) {
          _vm.$set(ombrello, "cashable", $$v)
        },
        expression: "ombrello.cashable"
      }
    }, [_c('i', {
      staticClass: "fas fa-euro-sign"
    })]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fas fa-cash-register",
      on: {
        "click": function($event) {
          return _vm.show('ombrellosettings', ombrello)
        }
      }
    })], 1) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.newombrelli), function(ombrello, index) {
    return (_vm.firstreset) ? _c('div', {
      staticClass: "grid ombrello"
    }, [_c('div', {
      staticClass: "grid seat free",
      attrs: {
        "id": ombrello._id
      }
    }, [_c('span', [_vm._v(_vm._s(ombrello.ombrid))])])]) : _vm._e()
  })], 2) : _vm._e()])]), _vm._v(" "), (!_vm.loading && _vm.hotel) ? _c('modal', {
    attrs: {
      "name": "ombrellosettings",
      "width": "50%",
      "minWidth": 360,
      "maxWidth": 1040,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    }
  }, [_c('div', {
    staticClass: "grid ombrellosettings"
  }, [_c('div', {
    staticClass: "grid seasons"
  }, [_c('h1', [_vm._v(_vm._s(_vm.ombrellos.ombrid) + " "), _vm._l((_vm.selectedOmbrellos), function(ombrello) {
    return _c('span', [_vm._v(_vm._s(ombrello))])
  })], 2), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.ombrellos.seasons))]), _vm._v(" "), _c('el-form', _vm._l((_vm.hotel.seasons), function(season) {
    return _c('div', {
      staticClass: "grid season"
    }, [_c('span', [_vm._v(_vm._s(season.name))]), _vm._v(" "), _c('div', {
      staticClass: "grid data"
    }, [_c('span', [_c('small', [_vm._v(_vm._s(season.start) + " > " + _vm._s(season.end))])]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-edit",
      on: {
        "click": function($event) {
          return _vm.editseason(season, _vm.index)
        }
      }
    })])])
  }), 0)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.hotel) ? _c('modal', {
    attrs: {
      "name": "bulkombrellosettings",
      "width": "70%",
      "minWidth": 360,
      "maxWidth": 1040,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    },
    on: {
      "before-close": _vm.beforeClose
    }
  }, [_c('div', {
    staticClass: "grid bulkombrellosettings"
  }, [(_vm.selectedOmbrellos.length === 0) ? _c('span', [_vm._v("Nessun Ombrellone selezionato")]) : _vm._e(), _vm._v(" "), (_vm.selectedOmbrellos.length >= 1) ? _c('div', {
    staticClass: "grid selectedombrellos"
  }, _vm._l((_vm.selectedOmbrellos), function(ombrello) {
    return _c('span', [_vm._v(_vm._s(ombrello.ombrid))])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form', [_c('div', {
    staticClass: "grid seasons"
  }, [_c('span', [_c('strong', [_vm._v("Cambia impostazioni per tutti gli ombrelloni selezionati")])]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _vm._l((_vm.newseasons), function(season, index) {
    return _c('div', {
      staticClass: "grid season"
    }, [_c('span', [_vm._v(_vm._s(season.name))]), _vm._v(" "), _c('div', {
      staticClass: "grid data"
    }, [_c('span', [_c('small', [_vm._v(_vm._s(season.start) + " > " + _vm._s(season.end))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("€ " + _vm._s(season.amount))])]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-edit",
      on: {
        "click": function($event) {
          return _vm.editseason(season, index)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.hotel.cashier) ? _c('div', {
    staticClass: "grid setting"
  }, [_c('span', [_vm._v("Ombrelloni a pagamento")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.ombrellos.cashable),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "cashable", $$v)
      },
      expression: "ombrellos.cashable"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid setting"
  }, [_c('span', [_vm._v("Ombrelloni visibili")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.ombrellos.visible),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "visible", $$v)
      },
      expression: "ombrellos.visible"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveBulk
    }
  }, [_vm._v("Salva Impostazioni")])], 2)]), _vm._v(" "), (_vm.updateseason) ? _c('div', {
    staticClass: "grid addseason"
  }, [_c('span', [_c('strong', [_vm._v("Update stagione: " + _vm._s(_vm.newseason.name))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Prezzo base ombrellone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Prezzo ombrellone",
      "name": "ombrellone"
    },
    model: {
      value: (_vm.newseason.amount),
      callback: function($$v) {
        _vm.$set(_vm.newseason, "amount", $$v)
      },
      expression: "newseason.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("€")])], 2)], 1), _vm._v(" "), _vm._l((_vm.newseason.items), function(item) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": 'Prezzo base ' + item.name
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Prezzo oggetto",
        "name": "price"
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("€")])], 2)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    staticClass: "btn btn-green",
    on: {
      "click": function($event) {
        return _vm.bulkUpdateseason()
      }
    }
  }, [_vm._v("salva impostazioni stagione")])], 1)])], 2)], 1) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "addpool": _vm.addpool,
      "addombrid": _vm.addombrid,
      "addombrell": _vm.addombrell,
      "editpool": _vm.editpool,
      "edit": _vm.edit
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "grid",
      "justify-content": "center",
      "overflow-y": "auto",
      "height": "100vh",
      "padding": "96px 0"
    }
  }, [(!_vm.loading) ? _c('div', {}, [_vm._l((_vm.hotel.pools), function(pool, index) {
    return _c('VueDragResize', {
      key: pool._id,
      staticClass: "pool grid",
      staticStyle: {
        "align-content": "center",
        "justify-content": "center"
      },
      attrs: {
        "snapToGrid": true,
        "gridX": 200,
        "gridY": 200,
        "isActive": _vm.edit,
        "x": pool.x,
        "y": pool.y,
        "w": pool.width,
        "h": pool.height,
        "z": 997,
        "isDraggable": _vm.edit,
        "isResizable": _vm.edit
      },
      on: {
        "resizing": function (left, top, width, height) { return _vm.pooldrag(index, left, top, width, height); },
        "dragstop": function (left, top, width, height) { return _vm.pooldrag(index, left, top, width, height); }
      }
    }, [(_vm.edit) ? _c('a', {
      staticClass: "btn",
      staticStyle: {
        "z-index": "999"
      },
      on: {
        "click": function($event) {
          return _vm.removePool(index)
        }
      }
    }, [_vm._v("remove")]) : _vm._e(), _vm._v(" "), (!_vm.edit) ? _c('span', {
      staticClass: "fas fa-swimming-pool",
      style: ({
        fontSize: pool.width / 8 + 'px'
      })
    }) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.ombrelli), function(ombrello, index) {
    return _c('VueDragResize', {
      key: ombrello._id,
      staticClass: "blocco ombrello",
      attrs: {
        "snapToGrid": true,
        "gridX": 20,
        "gridY": 20,
        "isActive": _vm.edit,
        "x": ombrello.x,
        "y": ombrello.y,
        "w": ombrello.width,
        "h": ombrello.height,
        "z": 997,
        "isDraggable": _vm.edit,
        "isResizable": false
      },
      on: {
        "resizing": _vm.resize,
        "dragstop": function (left, top, width, height) { return _vm.onResizing(index, left, top, width, height); }
      }
    }, [(!ombrello.free && ombrello.location === 'pool') ? _c('div', {
      staticClass: "blocco seat"
    }, [(_vm.hotel.poolsettings.beds || _vm.hotel.poolsettings.chairs) ? _c('div', {
      staticClass: "header blocco row"
    }, [(_vm.hotel.poolsettings.chairs) ? _c('div', {
      staticClass: "blocco"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(84)
      }
    }), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removechair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.chairs)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addchair(index, ombrello.chairs, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])])]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.beds) ? _c('div', {
      staticClass: "blocco"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(83)
      }
    }), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removebed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(ombrello.beds)), _c('a', {
      on: {
        "click": function($event) {
          return _vm.addbed(index, ombrello.beds, ombrello._id, _vm.hotelid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ident blocco row"
    }, [(_vm.hotel.poolsettings.room) ? _c('span', {
      staticClass: "room"
    }, [_vm._v(_vm._s(ombrello.room))]) : _vm._e(), _vm._v(" "), (ombrello.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.guest))]) : _vm._e(), _vm._v(" "), (!ombrello.guest) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v("no guest")]) : _vm._e()]), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure || _vm.hotel.poolsettings.ombrid) ? _c('div', {
      staticClass: "caldata blocco row"
    }, [(_vm.hotel.poolsettings.ombrid) ? _c('div', {
      staticClass: "blocco nr"
    }, [_vm._v(_vm._s(ombrello.ombrid))]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.arrival || _vm.hotel.poolsettings.departure) ? _c('div', {
      staticClass: "blocco"
    }, [(_vm.hotel.poolsettings.arrival) ? _c('span', [_c('span', {
      staticClass: "fa fa-chevron-right"
    }), _vm._v(" " + _vm._s(ombrello.arrival))]) : _vm._e(), _vm._v(" "), (_vm.hotel.poolsettings.departure) ? _c('span', [_c('span', {
      staticClass: "fa fa-chevron-left"
    }), _vm._v(" " + _vm._s(ombrello.departure))]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (ombrello.free && ombrello.location === 'pool') ? _c('div', {
      staticClass: "blocco seat free drop",
      attrs: {
        "id": ombrello._id
      }
    }, [_c('div', {
      staticClass: "blocco nr",
      attrs: {
        "id": ombrello._id
      },
      on: {
        "click": function($event) {
          return _vm.show(ombrello)
        }
      }
    }, [_vm._v(_vm._s(ombrello.ombrid))])]) : _vm._e()])
  })], 2) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "hello-world",
      "width": "50%",
      "height": "50%",
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "grid edit w100"
  }, [_c('div', {
    staticClass: "grid data h50"
  }, [(!_vm.editombrid) ? _c('h1', {
    on: {
      "click": _vm.changeombrid
    }
  }, [_vm._v(_vm._s(_vm.ombrellos.ombrid))]) : _vm._e(), _vm._v(" "), (_vm.editombrid) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ombrellos.ombrid),
      expression: "ombrellos.ombrid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "ombrid"
    },
    domProps: {
      "value": (_vm.ombrellos.ombrid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ombrellos, "ombrid", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Guest Name")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ombrellos.guest),
      expression: "ombrellos.guest"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "guest"
    },
    domProps: {
      "value": (_vm.ombrellos.guest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ombrellos, "guest", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ombrellos.room),
      expression: "ombrellos.room"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "room",
      "placeholder": "Room Number"
    },
    domProps: {
      "value": (_vm.ombrellos.room)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ombrellos, "room", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Arrival and Departure")])]), _vm._v(" "), _c('DateRange', {
    staticClass: "calendar",
    attrs: {
      "sync-range": _vm.range,
      "first-day-of-week": 1,
      "lang": _vm.lang
    },
    on: {
      "update:syncRange": function($event) {
        _vm.range = $event
      },
      "update:sync-range": function($event) {
        _vm.range = $event
      },
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  }), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-green",
    on: {
      "click": _vm.updateombrello
    }
  }, [_vm._v("Update Umbrella")])]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  }), _vm._v(" "), _c('p', [(!_vm.ombrellos.free) ? _c('a', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.closeombrello
    }
  }, [_vm._v("close ombrello")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "grid seats h50",
    class: {
      free: _vm.ombrellos.free
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(256)
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.chairs -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.ombrellos.chairs)), _c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.chairs += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(255)
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.beds -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.ombrellos.beds)), _c('a', {
    on: {
      "click": function($event) {
        _vm.ombrellos.beds += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "settings",
      "width": "50%",
      "height": "50%",
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "grid edit w100"
  }, [_c('div', {
    staticClass: "grid data h50"
  }, [_c('h1', [_vm._v(_vm._s(_vm.hotel.hotelname))]), _vm._v(" "), _c('label', [_vm._v("cols")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotel.cols),
      expression: "hotel.cols"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cols"
    },
    domProps: {
      "value": (_vm.hotel.cols)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hotel, "cols", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("rows")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotel.rows),
      expression: "hotel.rows"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rows"
    },
    domProps: {
      "value": (_vm.hotel.rows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hotel, "rows", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("lang")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotel.lang),
      expression: "hotel.lang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "lang"
    },
    domProps: {
      "value": (_vm.hotel.lang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hotel, "lang", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  }), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-green",
    on: {
      "click": _vm.updatehotel
    }
  }, [_vm._v("Update Settings")])]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid seats h50"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(256)
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.chairs -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.hotel.chairs)), _c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.chairs += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(255)
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.beds -= 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus-square"
  })]), _vm._v(_vm._s(_vm.hotel.beds)), _c('a', {
    on: {
      "click": function($event) {
        _vm.hotel.beds += 1
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  })])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle",
    style: (_vm.styles),
    attrs: {
      "viewBox": "0 0 66 66",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "fill": "none",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "cx": "33",
      "cy": "33",
      "r": "30"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--socker",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cube panelLoad"
  }, [_c('div', {
    staticClass: "cube-face cube-face-front"
  }, [_vm._v("L")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-back"
  }, [_vm._v("O")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-left"
  }, [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-right"
  }, [_vm._v("D")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-bottom"
  }, [_vm._v("I")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-top"
  }, [_vm._v("N'")])])
}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--square-grid",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hotel) ? _c('el-menu', {
    staticClass: "nav h100",
    attrs: {
      "router": true,
      "default-active": "2",
      "collapse": _vm.isCollapse,
      "background-color": _vm.hotel.colors.primary,
      "text-color": "#fff",
      "active-text-color": "#fff"
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "grid logo"
  }, [(_vm.isCollapse) ? _c('el-menu-item', {
    on: {
      "click": function($event) {
        _vm.isCollapse = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bars"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Apri menu")])]) : _vm._e(), _vm._v(" "), (!_vm.isCollapse) ? _c('el-menu-item', {
    on: {
      "click": function($event) {
        _vm.isCollapse = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bars"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Chiudi menu")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid actions"
  }, [(_vm.hotels.length > 1) ? _c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fas fa-random"
  }), _vm._v(" "), (!_vm.isCollapse) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Hotels")]) : _vm._e()]), _vm._v(" "), _c('el-menu-item-group', [_vm._l((_vm.hotels), function(hotel, index) {
    return (hotel.beachtype === 'grid') ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": '/ombrelli/' + hotel._id
      },
      on: {
        "click": function($event) {
          return _vm.changeHotel(hotel)
        }
      }
    }, [_vm._v(_vm._s(hotel.name))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.hotels), function(hotel, index) {
    return (hotel.beachtype === 'canvas') ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": '/Canvas/' + hotel._id
      },
      on: {
        "click": function($event) {
          return _vm.changeHotel(hotel)
        }
      }
    }, [_vm._v(_vm._s(hotel.name))]) : _vm._e()
  })], 2)], 2) : _vm._e(), _vm._v(" "), (_vm.hotel.beachtype === 'grid') ? _c('el-menu-item', {
    attrs: {
      "index": '/ombrelli/' + _vm.hotel._id
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Spiaggia " + _vm._s(_vm.hotel.name))])]) : _vm._e(), _vm._v(" "), (_vm.hotel.beachtype === 'canvas') ? _c('el-menu-item', {
    attrs: {
      "index": '/Canvas/' + _vm.hotel._id
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.pool) ? _c('el-menu-item', {
    attrs: {
      "index": '/Pool/' + _vm.hotel._id
    },
    on: {
      "click": _vm.editpool
    }
  }, [_c('i', {
    staticClass: "fas fa-wrench"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Edit Canvas")])]) : _vm._e(), _vm._v(" "), (_vm.pool) ? _c('el-menu-item', {
    attrs: {
      "index": '/Pool/' + _vm.hotel._id
    },
    on: {
      "click": _vm.addpool
    }
  }, [_c('i', {
    staticClass: "fas fa-swimming-pool"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Add Pool")])]) : _vm._e(), _vm._v(" "), (_vm.pool) ? _c('el-menu-item', {
    attrs: {
      "index": '/Pool/' + _vm.hotel._id
    },
    on: {
      "click": _vm.addombrid
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Add Ombrello")])]) : _vm._e(), _vm._v(" "), (_vm.canvas) ? _c('el-menu-item', {
    attrs: {
      "index": '/Canvas/' + _vm.hotel._id
    },
    on: {
      "click": _vm.editCanvas
    }
  }, [(!_vm.edit) ? _c('i', {
    staticClass: "fas fa-wrench"
  }) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('i', {
    staticClass: "fas fa-save"
  }) : _vm._e(), _vm._v(" "), (!_vm.edit) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Imposta spiaggia")]) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Salva Impostazioni")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.canvas && _vm.edit) ? _c('el-menu-item', {
    attrs: {
      "index": '/Canvas/' + _vm.hotel._id
    },
    on: {
      "click": _vm.addombrid
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Agiungi ombrello")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid footer"
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/addhotel"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-square"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Aggiungi Hotel")])]), _vm._v(" "), _c('el-menu-item', {
    on: {
      "click": _vm.settings
    }
  }, [_c('i', {
    staticClass: "fas fa-cog"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Impostazioni " + _vm._s(_vm.hotel.name))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/logout"
    }
  }, [_c('i', {
    staticClass: "fas fa-power-off"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Log Out")])])], 1)]) : _vm._e(), _vm._v(" "), _c('settings', {
    attrs: {
      "hotel": _vm.hotel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--socker",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel center-gel"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c1 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c2 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c3 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c4 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c5 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c6 r1"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c7 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c8 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c9 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c10 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c11 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c12 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c13 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c14 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c15 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c16 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c17 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c18 r2"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c19 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c20 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c21 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c22 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c23 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c24 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c25 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c26 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c28 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c29 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c30 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c31 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c32 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c33 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c34 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c35 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c36 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gel c37 r3"
  }, [_c('div', {
    staticClass: "hex-brick h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h2"
  }), _vm._v(" "), _c('div', {
    staticClass: "hex-brick h3"
  })])
}]}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jumper",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('circle4')], 1)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--hexagon",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hexagon-container"
  }, [_c('li', {
    staticClass: "hexagon hex_1"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_2"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_3"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_4"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_5"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_6"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_7"
  })])
}]}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--plane",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "middle"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "bottom"
    }
  }, [_c('div', {
    staticClass: "plane"
  })])
}]}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner-origami",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner loading",
    style: (_vm.innerStyles)
  }, [_c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  })])])
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--spin-line",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.lineStyles)
  })])
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "blocco h100 w100"
  }, [_c('h1', [_vm._v("A quale Hotel vuoi accedere?")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_vm._l((_vm.hotels), function(hotel) {
    return _c('div', [(hotel.beachtype === 'grid') ? _c('router-link', {
      staticClass: "btn btn-green block left",
      attrs: {
        "to": {
          path: '/ombrelli/' + hotel._id
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-th"
    }), _vm._v(" " + _vm._s(hotel.name))]) : _vm._e(), _vm._v(" "), (hotel.beachtype === 'canvas') ? _c('router-link', {
      staticClass: "btn btn-green block left",
      attrs: {
        "to": {
          path: '/Canvas/' + hotel._id
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-umbrella-beach"
    }), _vm._v(" " + _vm._s(hotel.name))]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-blue block left",
    attrs: {
      "to": {
        path: '/addhotel'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-square"
  }), _vm._v(" aggiungi Hotel")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 672 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[321]);


// WEBPACK FOOTER //
// static/js/app.96a0a724a1986aa6e028.js